"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Vehicle service pack selected by the customer
 */
var AuServicePackDescription;
(function (AuServicePackDescription) {
    /**
     * NONE
     */
    AuServicePackDescription["NONE"] = "NONE";
})(AuServicePackDescription = exports.AuServicePackDescription || (exports.AuServicePackDescription = {}));
/**
 * Vehicle warranty selected by the customer
 */
var AuWarrantyDescription;
(function (AuWarrantyDescription) {
    /**
     * NONE
     */
    AuWarrantyDescription["NONE"] = "NONE";
})(AuWarrantyDescription = exports.AuWarrantyDescription || (exports.AuWarrantyDescription = {}));
/**
 * Represents a credit type for credits that customers already have. This does not represent financial
 * products provided by VWFS. For that use Product enum from @bus/models.
 */
var AutocreditAuCreditType;
(function (AutocreditAuCreditType) {
    AutocreditAuCreditType["CONSUMER_LOAN"] = "CONSUMER_LOAN";
    AutocreditAuCreditType["CONSUMER_LOAN_CHOICE"] = "CONSUMER_LOAN_CHOICE";
    AutocreditAuCreditType["CHATTLE_MORTGAGE"] = "CHATTLE_MORTGAGE";
    AutocreditAuCreditType["CHATTLE_MORTGAGE_CHOICE"] = "CHATTLE_MORTGAGE_CHOICE";
})(AutocreditAuCreditType = exports.AutocreditAuCreditType || (exports.AutocreditAuCreditType = {}));
var WorkPermitStatus;
(function (WorkPermitStatus) {
    WorkPermitStatus["RESTRICTED"] = "restricted";
    WorkPermitStatus["UNRESTRICTED"] = "unrestricted";
})(WorkPermitStatus = exports.WorkPermitStatus || (exports.WorkPermitStatus = {}));
var ResidencePermitStatus;
(function (ResidencePermitStatus) {
    ResidencePermitStatus["RESTRICTED"] = "restricted";
    ResidencePermitStatus["UNRESTRICTED"] = "unrestricted";
})(ResidencePermitStatus = exports.ResidencePermitStatus || (exports.ResidencePermitStatus = {}));
var HeyCarCoreProduct;
(function (HeyCarCoreProduct) {
    HeyCarCoreProduct["AUTOCREDIT"] = "AUTOCREDIT";
    HeyCarCoreProduct["PRIVATELEASE"] = "PRIVATELEASE";
})(HeyCarCoreProduct = exports.HeyCarCoreProduct || (exports.HeyCarCoreProduct = {}));
var Taxation;
(function (Taxation) {
    Taxation["STANDARD"] = "StandardTaxation";
    Taxation["DIFFERENTIAL"] = "DifferentialTaxation";
})(Taxation = exports.Taxation || (exports.Taxation = {}));
/**
 * Represents the origin system where the customer purchased the vehicle. This can be an online shop
 * (storefront) or a dealer sales system. It is part of the sales channel.
 */
var OriginSystem;
(function (OriginSystem) {
    OriginSystem["ECOMGW"] = "ECOMGW";
    OriginSystem["VWWE"] = "VWWE";
    OriginSystem["VGSG"] = "VGSG";
    OriginSystem["VWTHUNDERDEALERAPP"] = "VWTHUNDERDEALERAPP";
    OriginSystem["HEYCAR"] = "HEYCAR";
    OriginSystem["ONESHOP"] = "ONESHOP";
    OriginSystem["ONESHOP_CUPRA"] = "ONESHOP_CUPRA";
    OriginSystem["EVA"] = "EVA";
})(OriginSystem = exports.OriginSystem || (exports.OriginSystem = {}));
/**
 * CC IT Housing situation
 */
var ClassiccreditOneShopItHousingSituation;
(function (ClassiccreditOneShopItHousingSituation) {
    ClassiccreditOneShopItHousingSituation["RENT"] = "Rent";
    ClassiccreditOneShopItHousingSituation["HOUSED_PARENTS"] = "Housed_Parents";
    ClassiccreditOneShopItHousingSituation["PROPERTY_OWNERSHIP"] = "Property_Ownership";
    ClassiccreditOneShopItHousingSituation["OTHER"] = "Other";
})(ClassiccreditOneShopItHousingSituation = exports.ClassiccreditOneShopItHousingSituation || (exports.ClassiccreditOneShopItHousingSituation = {}));
/**
 * CC IT marital status
 */
var ClassiccreditOneShopItMaritalStatus;
(function (ClassiccreditOneShopItMaritalStatus) {
    ClassiccreditOneShopItMaritalStatus["DIVORCED"] = "Divorced";
    ClassiccreditOneShopItMaritalStatus["MARRIED"] = "Married";
    ClassiccreditOneShopItMaritalStatus["SEPARATED"] = "Separated";
    ClassiccreditOneShopItMaritalStatus["SINGLE"] = "Single";
    ClassiccreditOneShopItMaritalStatus["WIDOWED"] = "Widowed";
})(ClassiccreditOneShopItMaritalStatus = exports.ClassiccreditOneShopItMaritalStatus || (exports.ClassiccreditOneShopItMaritalStatus = {}));
/**
 * Indicates the type of the address.
 */
var AddressType;
(function (AddressType) {
    AddressType["PRIMARY"] = "Primary";
    AddressType["INVOICE"] = "Invoice";
    AddressType["BUSINESS"] = "Business";
    AddressType["POBOX"] = "POBox";
    AddressType["SHIPPING"] = "Shipping";
    AddressType["INFORMATION"] = "Information";
    AddressType["SECOND_RESIDENCE"] = "SecondResidence";
    AddressType["HOLIDAY_RESIDENCE"] = "HolidayResidence";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
/**
 * CC IT Activity Type
 */
var ClassiccreditOneShopItEmploymentActivityType;
(function (ClassiccreditOneShopItEmploymentActivityType) {
    ClassiccreditOneShopItEmploymentActivityType["AUTONOMO"] = "LAVOR. AUTONOMO";
    ClassiccreditOneShopItEmploymentActivityType["DIPENDENTE"] = "LAVOR. DIPENDENTE";
    ClassiccreditOneShopItEmploymentActivityType["PENSIONATO"] = "PENSIONATO";
    ClassiccreditOneShopItEmploymentActivityType["AZIENDA"] = "SOCIO AZIENDA";
    ClassiccreditOneShopItEmploymentActivityType["ALTRO"] = "ALTRO";
    ClassiccreditOneShopItEmploymentActivityType["PUBBLICO"] = "DIPEND. PUBBLICO";
    ClassiccreditOneShopItEmploymentActivityType["PRIVATO"] = "DIPEND. PRIVATO";
    ClassiccreditOneShopItEmploymentActivityType["GIURIDICA"] = "PERSONA GIURIDICA";
    ClassiccreditOneShopItEmploymentActivityType["PRIV616"] = "DIP.PRIV <6M <16H";
})(ClassiccreditOneShopItEmploymentActivityType = exports.ClassiccreditOneShopItEmploymentActivityType || (exports.ClassiccreditOneShopItEmploymentActivityType = {}));
/**
 * The transmission type of the vehicle
 */
var TransmissionType;
(function (TransmissionType) {
    TransmissionType["AUTOMATIC"] = "A";
    TransmissionType["AUTOMATIC_SHIFT_GEARBOX"] = "ASG";
    TransmissionType["CONTINUOUSLY_VARIABLE_TRANSMISSION"] = "CVT";
    TransmissionType["DIRECT_SHIFT_GEARBOX"] = "DSG";
    TransmissionType["MANUAL"] = "M";
    TransmissionType["A"] = "A";
    TransmissionType["M"] = "M";
    TransmissionType["DSG"] = "DSG";
    TransmissionType["ASG"] = "ASG";
    TransmissionType["CVT"] = "CVT";
})(TransmissionType = exports.TransmissionType || (exports.TransmissionType = {}));
/**
 * Deviating vehicle nature.
 */
var RegistrationOfVehicleType;
(function (RegistrationOfVehicleType) {
    RegistrationOfVehicleType["VEHICLE"] = "VEHICLE";
    RegistrationOfVehicleType["TRUCK"] = "TRUCK";
})(RegistrationOfVehicleType = exports.RegistrationOfVehicleType || (exports.RegistrationOfVehicleType = {}));
/**
 * Flag, if the transaction is performed as agency business.
 */
var AgencyBusinessType;
(function (AgencyBusinessType) {
    AgencyBusinessType["PRIVATE_AGENCY_MODEL"] = "PRIVATE_AGENCY_MODEL";
    AgencyBusinessType["NONE"] = "NONE";
})(AgencyBusinessType = exports.AgencyBusinessType || (exports.AgencyBusinessType = {}));
/**
 * The type of the vehicle option.
 */
var VehicleOptionType;
(function (VehicleOptionType) {
    VehicleOptionType["ACCESSORY_ORIGINAL"] = "ACCESSORY_ORIGINAL";
    VehicleOptionType["ACCESSORY_THIRD_PARTY"] = "ACCESSORY_THIRD_PARTY";
    VehicleOptionType["COLOR_EXTERIOR"] = "COLOR_EXTERIOR";
    VehicleOptionType["COLOR_INTERIOR"] = "COLOR_INTERIOR";
    VehicleOptionType["EQUIPMENT"] = "EQUIPMENT";
    VehicleOptionType["EXTENDED_WARRANTY_MANUFACTURER"] = "EXTENDED_WARRANTY_MANUFACTURER";
    VehicleOptionType["PACKAGE"] = "PACKAGE";
    VehicleOptionType["RIM"] = "RIM";
    VehicleOptionType["TIRE"] = "TIRE";
    VehicleOptionType["UPHOLSTERY"] = "UPHOLSTERY";
})(VehicleOptionType = exports.VehicleOptionType || (exports.VehicleOptionType = {}));
/**
 * Type of the Electricity current.
 */
var ElectricityCurrentType;
(function (ElectricityCurrentType) {
    ElectricityCurrentType["ALTERNATING_CURRENT"] = "AC";
    ElectricityCurrentType["DIRECT_CURRENT"] = "DC";
})(ElectricityCurrentType = exports.ElectricityCurrentType || (exports.ElectricityCurrentType = {}));
/**
 * Type of the battery.
 */
var BatteryType;
(function (BatteryType) {
    BatteryType["LITHIUM_ION"] = "LITHIUM_ION";
    BatteryType["LITHIUM_IONEN"] = "LITHIUM_IONEN";
})(BatteryType = exports.BatteryType || (exports.BatteryType = {}));
/**
 * Status of the vehicle, if it is in stock or virtual (built to order).
 */
var VehicleTradeState;
(function (VehicleTradeState) {
    VehicleTradeState["IN_STOCK"] = "IN_STOCK";
    VehicleTradeState["VIRTUAL"] = "VIRTUAL";
    VehicleTradeState["IN_TRANSIT"] = "IN_TRANSIT";
    VehicleTradeState["INSTOCK"] = "INSTOCK";
})(VehicleTradeState = exports.VehicleTradeState || (exports.VehicleTradeState = {}));
/**
 * Type of the delivery cost.
 */
var DeliveryCostType;
(function (DeliveryCostType) {
    DeliveryCostType["CHERISHED_LICENSE_PLATE"] = "CHERISHED_LICENSE_PLATE";
    DeliveryCostType["DELIVERY"] = "DELIVERY";
    DeliveryCostType["FUEL"] = "FUEL";
    DeliveryCostType["HANDLING"] = "HANDLING";
    DeliveryCostType["RECYCLING"] = "RECYCLING";
    DeliveryCostType["REGISTRATION"] = "REGISTRATION";
    DeliveryCostType["TRANSPORTATION"] = "TRANSPORTATION";
})(DeliveryCostType = exports.DeliveryCostType || (exports.DeliveryCostType = {}));
var SalesContext;
(function (SalesContext) {
    SalesContext["ONLINE"] = "online";
    SalesContext["POINTOFSALE"] = "pointofsale";
    SalesContext["ONESALES"] = "onesales";
})(SalesContext = exports.SalesContext || (exports.SalesContext = {}));
/**
 * The type of the unique customer identifier. This can be either a customerIdentity like Verimi or
 * VW.ID or any other kind of identifier.
 */
var CustomerType;
(function (CustomerType) {
    CustomerType["INDIVIDUAL"] = "INDIVIDUAL";
    CustomerType["LEGAL_ENTITY"] = "LEGAL_ENTITY";
    CustomerType["WE_ID"] = "WE_ID";
    CustomerType["VERIMI_ID"] = "VERIMI_ID";
    CustomerType["THUNDERAPP_ID"] = "THUNDERAPP_ID";
})(CustomerType = exports.CustomerType || (exports.CustomerType = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["SPECIAL"] = "SPECIAL";
    DiscountType["VOLUME"] = "VOLUME";
    DiscountType["PROMOTION"] = "PROMOTION";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var EnergyEfficiencyClass;
(function (EnergyEfficiencyClass) {
    EnergyEfficiencyClass["APlus"] = "APlus";
    EnergyEfficiencyClass["APlusOneshop"] = "A+";
    EnergyEfficiencyClass["A"] = "A";
    EnergyEfficiencyClass["B"] = "B";
    EnergyEfficiencyClass["C"] = "C";
    EnergyEfficiencyClass["D"] = "D";
    EnergyEfficiencyClass["E"] = "E";
    EnergyEfficiencyClass["F"] = "F";
    EnergyEfficiencyClass["G"] = "G";
})(EnergyEfficiencyClass = exports.EnergyEfficiencyClass || (exports.EnergyEfficiencyClass = {}));
var ContractType;
(function (ContractType) {
    ContractType["withoutUCBilling"] = "withoutUCBilling";
    ContractType["withUCBilling"] = "withUCBilling";
})(ContractType = exports.ContractType || (exports.ContractType = {}));
var CreditProtectionInsurancePackageId;
(function (CreditProtectionInsurancePackageId) {
    CreditProtectionInsurancePackageId["LRV"] = "LRV";
    CreditProtectionInsurancePackageId["LRVMOB"] = "LRVMOB";
    CreditProtectionInsurancePackageId["LRVPLUS"] = "LRVPLUS";
    CreditProtectionInsurancePackageId["LRVMOBPLUS"] = "LRVMOBPLUS";
    CreditProtectionInsurancePackageId["NONE"] = "NONE";
})(CreditProtectionInsurancePackageId = exports.CreditProtectionInsurancePackageId || (exports.CreditProtectionInsurancePackageId = {}));
var ServicePackageId;
(function (ServicePackageId) {
    ServicePackageId["S_PACKAGE"] = "S_PACKAGE";
    ServicePackageId["M_PACKAGE"] = "M_PACKAGE";
    ServicePackageId["L_PACKAGE"] = "L_PACKAGE";
    ServicePackageId["NONE"] = "NONE";
})(ServicePackageId = exports.ServicePackageId || (exports.ServicePackageId = {}));
var FuelConsumptionUnit;
(function (FuelConsumptionUnit) {
    FuelConsumptionUnit["KilowatthoursPerOnehundredKilometers"] = "KilowattsPerOnehundredKilometers";
    FuelConsumptionUnit["LitersPerOnehundredKilometers"] = "LitersPerOnehundredKilometers";
    FuelConsumptionUnit["KilogramPerOnehundredKilometers"] = "KilogramPerOnehundredKilometers";
})(FuelConsumptionUnit = exports.FuelConsumptionUnit || (exports.FuelConsumptionUnit = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["GBP"] = "GBP";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));
/**
 * This represents the unit of duration for a financial product provided by VWFS. Currently all products
 * are monthly paid and therefore there is only one value. This may change in the future
 */
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["MONTHS"] = "MONTHS";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
/**
 * Represents the unit of mileage of a vehicle. This can be used for odometers and for expected mileages
 * in a certain time frame.
 */
var MileageUnit;
(function (MileageUnit) {
    MileageUnit["KILOMETERS"] = "KILOMETERS";
    MileageUnit["MILES"] = "MILES";
})(MileageUnit = exports.MileageUnit || (exports.MileageUnit = {}));
var ModelCodeType;
(function (ModelCodeType) {
    ModelCodeType["MBV"] = "MBV";
    ModelCodeType["MANECK"] = "MANECK";
    ModelCodeType["MBT"] = "MBT";
    ModelCodeType["KBA"] = "KBA";
    ModelCodeType["KUBA"] = "KUBA";
    ModelCodeType["ATLAS"] = "ATLAS";
})(ModelCodeType = exports.ModelCodeType || (exports.ModelCodeType = {}));
/**
 * Represents the emission class.
 */
var EmissionClass;
(function (EmissionClass) {
    EmissionClass["EURO1"] = "EURO1";
    EmissionClass["EURO2"] = "EURO2";
    EmissionClass["EURO3"] = "EURO3";
    EmissionClass["EURO4"] = "EURO4";
    EmissionClass["EURO5"] = "EURO5";
    EmissionClass["EURO6"] = "EURO6";
    EmissionClass["D3"] = "D3";
    EmissionClass["D4"] = "D4";
    EmissionClass["EURO6_AD"] = "EURO6 AD";
    EmissionClass["EURO6_AG"] = "EURO6 AG";
    EmissionClass["EURO6b"] = "EURO6b";
    EmissionClass["EURO6c"] = "EURO6c";
    EmissionClass["EURO6d"] = "EURO6d";
    EmissionClass["AX"] = "AX";
    EmissionClass["AY"] = "AY";
})(EmissionClass = exports.EmissionClass || (exports.EmissionClass = {}));
var CalculationSign;
(function (CalculationSign) {
    CalculationSign["ADDITION"] = "ADDITION";
    CalculationSign["DEDUCTION"] = "DEDUCTION";
})(CalculationSign = exports.CalculationSign || (exports.CalculationSign = {}));
var ProcessSalesContext;
(function (ProcessSalesContext) {
    ProcessSalesContext["V"] = "V";
})(ProcessSalesContext = exports.ProcessSalesContext || (exports.ProcessSalesContext = {}));
var AgencyModel;
(function (AgencyModel) {
    AgencyModel["NONE"] = "NONE";
    AgencyModel["PRIVATE_AGENCY_MODEL"] = "PRIVATE_AGENCY_MODEL";
})(AgencyModel = exports.AgencyModel || (exports.AgencyModel = {}));
var DeliveryDateConfirmed;
(function (DeliveryDateConfirmed) {
    DeliveryDateConfirmed["NON_BINDING"] = "NON_BINDING";
    DeliveryDateConfirmed["BINDING"] = "BINDING";
})(DeliveryDateConfirmed = exports.DeliveryDateConfirmed || (exports.DeliveryDateConfirmed = {}));
/**
 * Represents the object code of a vehicle model.
 */
var ObjectCode;
(function (ObjectCode) {
    ObjectCode["CAMPER"] = "CAMPER";
    ObjectCode["COMMERCIAL_VEHICLE"] = "COMMERCIAL_VEHICLE";
    ObjectCode["PASSENGER_CAR"] = "PASSENGER_CAR";
    ObjectCode["TRAILER"] = "TRAILER";
    ObjectCode["TWO_WHEELER"] = "TWO_WHEELER";
})(ObjectCode = exports.ObjectCode || (exports.ObjectCode = {}));
var MeasureSizes;
(function (MeasureSizes) {
    MeasureSizes["mm"] = "mm";
    MeasureSizes["s"] = "s";
    MeasureSizes["kg"] = "kg";
    MeasureSizes["l"] = "l";
})(MeasureSizes = exports.MeasureSizes || (exports.MeasureSizes = {}));
var ConsumptionType;
(function (ConsumptionType) {
    ConsumptionType["CITY"] = "CITY";
    ConsumptionType["HIGHWAY"] = "HIGHWAY";
    ConsumptionType["OVERALL"] = "OVERALL";
})(ConsumptionType = exports.ConsumptionType || (exports.ConsumptionType = {}));
/**
 * Indicates which type of gas the indicated emission refers to.
 */
var EmissionType;
(function (EmissionType) {
    EmissionType["CO2"] = "CO2";
    EmissionType["NOX"] = "NOX";
    EmissionType["NOx"] = "NOx";
    EmissionType["PM"] = "PM";
})(EmissionType = exports.EmissionType || (exports.EmissionType = {}));
/**
 * The engines fuel type of the vehicle.
 */
var FuelType;
(function (FuelType) {
    FuelType["COMPRESSED_NATURAL_GAS"] = "Compressed Natural Gas (CNG)";
    FuelType["DIESEL"] = "Diesel";
    FuelType["ELECTRICITY"] = "Electricity";
    FuelType["ETHANOL"] = "Ethanol";
    FuelType["GASOLINE"] = "Gasoline (RON 91)";
    FuelType["HYDROGEN"] = "Hydrogen";
    FuelType["LIQUIFIED_PETROLEUM_GAS"] = "Liquefied Petroleum Gas (LPG)";
    FuelType["SUPER_E5_RON_95"] = "Super (E5) (RON 95)";
    FuelType["SUPER_E10_RON_95"] = "Super E10 (RON 95)";
    FuelType["OTHER"] = "Other";
    FuelType["N"] = "N";
    FuelType["S"] = "S";
    FuelType["SP"] = "SP";
    FuelType["D"] = "D";
    FuelType["E85"] = "E85";
    FuelType["F"] = "F";
    FuelType["H"] = "H";
    FuelType["L"] = "L";
    FuelType["HL"] = "HL";
    FuelType["E"] = "E";
    FuelType["W"] = "W";
})(FuelType = exports.FuelType || (exports.FuelType = {}));
var SpecialUnits;
(function (SpecialUnits) {
    SpecialUnits["ThreeToTwelveThousandRpm"] = "ThreeToTwelveThousandRpm";
    SpecialUnits["TorqueUpToThreethousand"] = "TorqueUpToThreethousand";
})(SpecialUnits = exports.SpecialUnits || (exports.SpecialUnits = {}));
var HousingType;
(function (HousingType) {
    HousingType["RENT"] = "RENT";
    HousingType["PROPERTY_OWNERSHIP"] = "PROPERTY_OWNERSHIP";
})(HousingType = exports.HousingType || (exports.HousingType = {}));
var CreditTypes;
(function (CreditTypes) {
    CreditTypes["CONSUMER_CREDIT"] = "CONSUMER_CREDIT";
    CreditTypes["FRAMEWORK_CREDIT"] = "FRAMEWORK_CREDIT";
    CreditTypes["LEASING"] = "LEASING";
    CreditTypes["CREDIT_CARD"] = "CREDIT_CARD";
})(CreditTypes = exports.CreditTypes || (exports.CreditTypes = {}));
var IndustryTypes;
(function (IndustryTypes) {
    IndustryTypes["BUILDING_INDUSTRY"] = "BUILDING_INDUSTRY";
    IndustryTypes["RETAIL"] = "RETAIL";
    IndustryTypes["HOSPITALITY_INDUSTRY"] = "HOSPITALITY_INDUSTRY";
    IndustryTypes["FINANCIAL_SERVICES_INSTITUTIONS"] = "FINANCIAL_SERVICES_INSTITUTIONS";
    IndustryTypes["DATA_PROCESSING_AND_DATABASES"] = "DATA_PROCESSING_AND_DATABASES";
    IndustryTypes["SERVICES_MAINLY_FOR_COMPANIES"] = "SERVICES_MAINLY_FOR_COMPANIES";
    IndustryTypes["EDUCATION_AND_TEACHING"] = "EDUCATION_AND_TEACHING";
    IndustryTypes["HEALTH_VETERINARY_AND_SOCIAL_SERVICES"] = "HEALTH_VETERINARY_AND_SOCIAL_SERVICES";
    IndustryTypes["OTHER_SERVICE_ACTIVITIES"] = "OTHER_SERVICE_ACTIVITIES";
    IndustryTypes["MANUFACTURE_OF_METAL_PRODUCTS"] = "MANUFACTURE_OF_METAL_PRODUCTS";
    IndustryTypes["PUBLIC_AUTHORITIES_COUNTRIES"] = "PUBLIC_AUTHORITIES_COUNTRIES";
})(IndustryTypes = exports.IndustryTypes || (exports.IndustryTypes = {}));
var MediaAssetType;
(function (MediaAssetType) {
    MediaAssetType["TEXT"] = "TEXT";
    MediaAssetType["URL"] = "URL";
    MediaAssetType["INFO"] = "INFO";
    MediaAssetType["WARN"] = "WARN";
    MediaAssetType["ERROR"] = "ERROR";
    MediaAssetType["JSON"] = "JSON";
})(MediaAssetType = exports.MediaAssetType || (exports.MediaAssetType = {}));
/**
 * Unit for the vehicle delivery time.
 */
var DeliveryTimeUnit;
(function (DeliveryTimeUnit) {
    /**
     * weeks
     */
    DeliveryTimeUnit["WEEKS"] = "weeks";
})(DeliveryTimeUnit = exports.DeliveryTimeUnit || (exports.DeliveryTimeUnit = {}));
/**
 * The distribution channel for documents
 */
var DigitalOfferDeProcessSalesContext;
(function (DigitalOfferDeProcessSalesContext) {
    /**
     * Seat
     */
    DigitalOfferDeProcessSalesContext["SEAT"] = "S";
    /**
     * Volkswagen
     */
    DigitalOfferDeProcessSalesContext["VW"] = "V";
    /**
     * Audi
     */
    DigitalOfferDeProcessSalesContext["AUDI"] = "A";
    /**
     * AEB
     */
    DigitalOfferDeProcessSalesContext["AEB"] = "E";
    /**
     * Skoda
     */
    DigitalOfferDeProcessSalesContext["SKODA"] = "K";
    /**
     * Volkswagen Nutzfahrzeuge
     */
    DigitalOfferDeProcessSalesContext["VWN"] = "N";
})(DigitalOfferDeProcessSalesContext = exports.DigitalOfferDeProcessSalesContext || (exports.DigitalOfferDeProcessSalesContext = {}));
/**
 * The engines fuel type of the vehicle.
 */
var DigitalOfferDeFuelType;
(function (DigitalOfferDeFuelType) {
    DigitalOfferDeFuelType["COMPRESSED_NATURAL_GAS"] = "Compressed Natural Gas (CNG)";
    DigitalOfferDeFuelType["DIESEL"] = "Diesel";
    DigitalOfferDeFuelType["ELECTRICITY"] = "Electricity";
    DigitalOfferDeFuelType["ETHANOL"] = "Ethanol";
    DigitalOfferDeFuelType["GASOLINE"] = "Gasoline (RON 91)";
    DigitalOfferDeFuelType["HYDROGEN"] = "Hydrogen";
    DigitalOfferDeFuelType["LIQUIFIED_PETROLEUM_GAS"] = "Liquefied Petroleum Gas (LPG)";
    DigitalOfferDeFuelType["SUPER_E5_RON_95"] = "Super (E5) (RON 95)";
    DigitalOfferDeFuelType["SUPER_E10_RON_95"] = "Super E10 (RON 95)";
    DigitalOfferDeFuelType["OTHER"] = "Other";
})(DigitalOfferDeFuelType = exports.DigitalOfferDeFuelType || (exports.DigitalOfferDeFuelType = {}));
/**
 * Represents the type of a customer
 */
var DigitalOfferDePartnerType;
(function (DigitalOfferDePartnerType) {
    DigitalOfferDePartnerType["PRIVATE"] = "PRIVATE";
    DigitalOfferDePartnerType["ORGANIZATION"] = "ORGANIZATION";
    DigitalOfferDePartnerType["BUSINESS"] = "BUSINESS";
    DigitalOfferDePartnerType["ENTREPRENEUR"] = "ENTREPRENEUR";
    DigitalOfferDePartnerType["PARTNERSHIP"] = "PARTNERSHIP";
    DigitalOfferDePartnerType["CIVIL_PARTNERSHIP"] = "CIVIL_PARTNERSHIP";
})(DigitalOfferDePartnerType = exports.DigitalOfferDePartnerType || (exports.DigitalOfferDePartnerType = {}));
/**
 * Indicates the role of the customer.
 */
var DigitalOfferDeCustomerRole;
(function (DigitalOfferDeCustomerRole) {
    DigitalOfferDeCustomerRole["INSURER"] = "INSURER";
    DigitalOfferDeCustomerRole["USER"] = "USER";
    DigitalOfferDeCustomerRole["OWNER"] = "OWNER";
    DigitalOfferDeCustomerRole["CO_OWNER"] = "CO_OWNER";
    DigitalOfferDeCustomerRole["CESSIONARY"] = "CESSIONARY";
    DigitalOfferDeCustomerRole["BUSINESS_PARTNER"] = "BUSINESS_PARTNER";
    DigitalOfferDeCustomerRole["BENEFICIARY"] = "BENEFICIARY";
})(DigitalOfferDeCustomerRole = exports.DigitalOfferDeCustomerRole || (exports.DigitalOfferDeCustomerRole = {}));
/**
 * Represents the emission class.
 */
var DigitalOfferDeEmissionClassType;
(function (DigitalOfferDeEmissionClassType) {
    DigitalOfferDeEmissionClassType["EURO1"] = "EURO1";
    DigitalOfferDeEmissionClassType["EURO2"] = "EURO2";
    DigitalOfferDeEmissionClassType["EURO3"] = "EURO3";
    DigitalOfferDeEmissionClassType["EURO4"] = "EURO4";
    DigitalOfferDeEmissionClassType["EURO5"] = "EURO5";
    DigitalOfferDeEmissionClassType["EURO6"] = "EURO6";
    DigitalOfferDeEmissionClassType["D3"] = "D3";
    DigitalOfferDeEmissionClassType["D4"] = "D4";
    DigitalOfferDeEmissionClassType["EURO6_AD"] = "EURO6 AD";
    DigitalOfferDeEmissionClassType["EURO6_AG"] = "EURO6 AG";
})(DigitalOfferDeEmissionClassType = exports.DigitalOfferDeEmissionClassType || (exports.DigitalOfferDeEmissionClassType = {}));
/**
 * Indicates which type of gas the indicated emission refers to.
 */
var DigitalOfferDeEmissionType;
(function (DigitalOfferDeEmissionType) {
    DigitalOfferDeEmissionType["CO2"] = "CO2";
    DigitalOfferDeEmissionType["NOX"] = "NOX";
})(DigitalOfferDeEmissionType = exports.DigitalOfferDeEmissionType || (exports.DigitalOfferDeEmissionType = {}));
/**
 * Indicates the type of a customer.
 */
var DigitalOfferDeCustomerType;
(function (DigitalOfferDeCustomerType) {
    DigitalOfferDeCustomerType["INDIVIDUAL"] = "INDIVIDUAL";
    DigitalOfferDeCustomerType["LEGAL_ENTITY"] = "LEGAL_ENTITY";
})(DigitalOfferDeCustomerType = exports.DigitalOfferDeCustomerType || (exports.DigitalOfferDeCustomerType = {}));
/**
 * This setting forces signatories to authenticate using the supplied identification method to view the
 * document before signing.
 */
var ScriveAuthenticationMethodToView;
(function (ScriveAuthenticationMethodToView) {
    ScriveAuthenticationMethodToView["STANDARD"] = "standard";
    ScriveAuthenticationMethodToView["SMS_PIN"] = "sms_pin";
    ScriveAuthenticationMethodToView["SE_BANKID"] = "se_bankid";
    ScriveAuthenticationMethodToView["NO_BANKID"] = "no_bankid";
    ScriveAuthenticationMethodToView["DK_NEMID"] = "dk_nemid";
    ScriveAuthenticationMethodToView["FI_TUPAS"] = "fi_tupas";
    ScriveAuthenticationMethodToView["ONFIDO"] = "onfido";
    ScriveAuthenticationMethodToView["NL_IDIN"] = "nl_idin";
    ScriveAuthenticationMethodToView["VERIMI"] = "verimi";
})(ScriveAuthenticationMethodToView = exports.ScriveAuthenticationMethodToView || (exports.ScriveAuthenticationMethodToView = {}));
/**
 * This setting forces signatories to authenticate using the supplied identification method to sign when
 * signing the document.
 */
var ScriveAuthenticationMethodToSign;
(function (ScriveAuthenticationMethodToSign) {
    ScriveAuthenticationMethodToSign["STANDARD"] = "standard";
    ScriveAuthenticationMethodToSign["SMS_PIN"] = "sms_pin";
    ScriveAuthenticationMethodToSign["SE_BANKID"] = "se_bankid";
    ScriveAuthenticationMethodToSign["NO_BANKID"] = "no_bankid";
    ScriveAuthenticationMethodToSign["DK_NEMID"] = "dk_nemid";
    ScriveAuthenticationMethodToSign["ONFIDO"] = "onfido";
    ScriveAuthenticationMethodToSign["NL_IDIN"] = "nl_idin";
    ScriveAuthenticationMethodToSign["VERIMI"] = "verimi";
})(ScriveAuthenticationMethodToSign = exports.ScriveAuthenticationMethodToSign || (exports.ScriveAuthenticationMethodToSign = {}));
/**
 * Current status of the document within the signing process.
 */
var ScriveDocumentStatus;
(function (ScriveDocumentStatus) {
    ScriveDocumentStatus["PREPARATION"] = "preparation";
    ScriveDocumentStatus["PENDING"] = "pending";
    ScriveDocumentStatus["CLOSED"] = "closed";
    ScriveDocumentStatus["CANCELLED"] = "canceled";
    ScriveDocumentStatus["TIMEDOUT"] = "timedout";
    ScriveDocumentStatus["REJECTED"] = "rejected";
    ScriveDocumentStatus["DOCUMENT_ERROR"] = "document_error";
})(ScriveDocumentStatus = exports.ScriveDocumentStatus || (exports.ScriveDocumentStatus = {}));
/**
 * The different types of signing parties' roles for the Scrive E-Sign service.
 */
var SignatoryRole;
(function (SignatoryRole) {
    SignatoryRole["SIGNING_PARTY"] = "signing_party";
    SignatoryRole["VIEWER"] = "viewer";
    SignatoryRole["APPROVER"] = "approver";
})(SignatoryRole = exports.SignatoryRole || (exports.SignatoryRole = {}));
/**
 * Represents a VWFS sales brand, selling financial products. The string values of this enum are lower
 * case to be url friendly.
 */
var Brand;
(function (Brand) {
    Brand["VW"] = "vw";
    Brand["VWN"] = "vwn";
    Brand["PORSCHE"] = "porsche";
    Brand["DUTCHFINANCE"] = "dutchfinance";
    Brand["AUTOCASH"] = "autocash";
    Brand["AUDI"] = "audi";
    Brand["SEAT"] = "seat";
    Brand["SKODA"] = "skoda";
    Brand["VWFS"] = "vwfs";
    Brand["BENTLEY"] = "bentley";
    Brand["CUPRA"] = "cupra";
})(Brand = exports.Brand || (exports.Brand = {}));
/**
 * Represents a sales market of VWFS coded as ISO 3166-1 alpha-2 with a few exceptions (e.g. 'int').
 * Only use it if you want to express a sales market. For general country codes e.g. for nationalities
 * use CountryCode in @bus/models. The string values of this enum are lower case to be url friendly.
 */
var Country;
(function (Country) {
    Country["NL"] = "nl";
    Country["DE"] = "de";
    Country["PT"] = "pt";
    Country["FR"] = "fr";
    Country["PL"] = "pl";
    Country["UK"] = "uk";
    Country["IT"] = "it";
    Country["MX"] = "mx";
    Country["CZ"] = "cz";
    Country["IE"] = "ie";
    Country["TT"] = "tt";
    Country["ES"] = "es";
    Country["AU"] = "au";
    Country["GR"] = "gr";
    /**
     * Norway
     */
    Country["NO"] = "no";
    Country["INT"] = "int";
})(Country = exports.Country || (exports.Country = {}));
var Manufacturer;
(function (Manufacturer) {
    Manufacturer["Abarth"] = "Abarth";
    Manufacturer["Acura"] = "Acura";
    Manufacturer["AlfaRomeo"] = "Alfa Romeo";
    Manufacturer["Alpine"] = "Alpine";
    Manufacturer["AstonMartin"] = "Aston Martin";
    Manufacturer["Audi"] = "Audi";
    Manufacturer["Bentley"] = "Bentley";
    Manufacturer["BMW"] = "BMW";
    Manufacturer["Bugatti"] = "Bugatti";
    Manufacturer["Cadillac"] = "Cadillac";
    Manufacturer["ChevroletUSA"] = "Chevrolet USA";
    Manufacturer["Chrysler"] = "Chrysler";
    Manufacturer["Citroen"] = "Citroen";
    Manufacturer["CUPRA"] = "CUPRA";
    Manufacturer["Dacia"] = "Dacia";
    Manufacturer["Daewoo"] = "Daewoo";
    Manufacturer["Daf"] = "Daf";
    Manufacturer["Daihatsu"] = "Daihatsu";
    Manufacturer["DFSK"] = "DFSK";
    Manufacturer["Dodge"] = "Dodge";
    Manufacturer["Donkervoort"] = "Donkervoort";
    Manufacturer["DS"] = "DS";
    Manufacturer["Ducati"] = "Ducati";
    Manufacturer["Ferrari"] = "Ferrari";
    Manufacturer["Fiat"] = "Fiat";
    Manufacturer["Ford"] = "Ford";
    Manufacturer["FUSO"] = "FUSO";
    Manufacturer["Gaz"] = "Gaz";
    Manufacturer["Gazelle"] = "Gazelle";
    Manufacturer["Gmc"] = "Gmc";
    Manufacturer["HarleyDavidson"] = "Harley-Davidson";
    Manufacturer["Honda"] = "Honda";
    Manufacturer["Hummer"] = "Hummer";
    Manufacturer["Hyundai"] = "Hyundai";
    Manufacturer["Infiniti"] = "Infiniti";
    Manufacturer["Irizar"] = "Irizar";
    Manufacturer["Isuzu"] = "Isuzu";
    Manufacturer["Iveco"] = "Iveco";
    Manufacturer["Jaguar"] = "Jaguar";
    Manufacturer["Jeep"] = "Jeep";
    Manufacturer["Jmc"] = "Jmc";
    Manufacturer["Kamaz"] = "Kamaz";
    Manufacturer["Kawasaki"] = "Kawasaki";
    Manufacturer["Kia"] = "Kia";
    Manufacturer["Ktm"] = "Ktm";
    Manufacturer["Lada"] = "Lada";
    Manufacturer["Lamborghini"] = "Lamborghini";
    Manufacturer["Lancia"] = "Lancia";
    Manufacturer["LandRover"] = "Land Rover";
    Manufacturer["Lexus"] = "Lexus";
    Manufacturer["Lincoln"] = "Lincoln";
    Manufacturer["Lotus"] = "Lotus";
    Manufacturer["MAN"] = "MAN";
    Manufacturer["Maserati"] = "Maserati";
    Manufacturer["Mazda"] = "Mazda";
    Manufacturer["McLaren"] = "McLaren";
    Manufacturer["MercedesBenz"] = "Mercedes-Benz";
    Manufacturer["Mini"] = "Mini";
    Manufacturer["Mitsubishi"] = "Mitsubishi";
    Manufacturer["Morgan"] = "Morgan";
    Manufacturer["Nissan"] = "Nissan";
    Manufacturer["Opel"] = "Opel";
    Manufacturer["Peugeot"] = "Peugeot";
    Manufacturer["Pgo"] = "Pgo";
    Manufacturer["Piaggio"] = "Piaggio";
    Manufacturer["Polaris"] = "Polaris";
    Manufacturer["Pontiac"] = "Pontiac";
    Manufacturer["Porsche"] = "Porsche";
    Manufacturer["Ram"] = "Ram";
    Manufacturer["Renault"] = "Renault";
    Manufacturer["RollsRoyce"] = "Rolls-Royce";
    Manufacturer["Saab"] = "Saab";
    Manufacturer["SAIC"] = "SAIC";
    Manufacturer["Scania"] = "Scania";
    Manufacturer["SEAT"] = "SEAT";
    Manufacturer["Setra"] = "Setra";
    Manufacturer["Skoda"] = "Skoda";
    Manufacturer["smart"] = "smart";
    Manufacturer["SsangYong"] = "SsangYong";
    Manufacturer["StreetScooter"] = "StreetScooter";
    Manufacturer["Subaru"] = "Subaru";
    Manufacturer["Suzuki"] = "Suzuki";
    Manufacturer["Tata"] = "Tata";
    Manufacturer["Tesla"] = "Tesla";
    Manufacturer["Toyota"] = "Toyota";
    Manufacturer["Volkswagen"] = "Volkswagen";
    Manufacturer["VolkswagenNutzfahrzeuge"] = "Volkswagen Nutzfahrzeuge";
    Manufacturer["Volvo"] = "Volvo";
})(Manufacturer = exports.Manufacturer || (exports.Manufacturer = {}));
/**
 * Represents a modifier for a financial product provided by VWFS. Only use this enum if the Product
 * enum is not enough or if you need to differentiate two representations of the same financial product.
 */
var ProductModifier;
(function (ProductModifier) {
    /**
     * For all products that handle new cars.
     */
    ProductModifier["NEW"] = "new";
    /**
     * For all products that handle used cars.
     */
    ProductModifier["USED"] = "used";
})(ProductModifier = exports.ProductModifier || (exports.ProductModifier = {}));
/**
 * Represents a financial product provided by VWFS. Use this enum in everey situation, when you need it
 * for computation. For customer facing text you should create a mapper. For market backends you also
 * need to map the values. The string values of this enum are lower case to be url friendly.
 */
var Product;
(function (Product) {
    Product["AUTOCREDIT"] = "autocredit";
    Product["CLASSICCREDIT"] = "classiccredit";
    Product["PRIVATELEASE"] = "privatelease";
    Product["OPERATELEASE"] = "operatelease";
    Product["FINANCELEASE"] = "financelease";
    Product["SERVICEINSPECTION"] = "serviceinspection";
    Product["MICROINSURANCE"] = "microinsurance";
    Product["MOTORINSURANCE"] = "motorinsurance";
    Product["MULTIPRODUCT"] = "multiproduct";
    Product["SHORTTERMINSURANCE"] = "shortterminsurance";
    Product["SHORTTERMINSURANCE_TESTDRIVER"] = "shortterminsurance-testdriver";
    Product["ONLINESERVICEPLANS"] = "onlineserviceplans";
    Product["EXTENDEDWARRANTY"] = "extendedwarranty";
    Product["EXTENDEDWARRANTY_MAKER"] = "extendedwarranty-maker";
    Product["EXTENDEDWARRANTY_NEW"] = "extendedwarranty-new";
    Product["CHARGEANDFUEL"] = "chargeandfuel";
    Product["SUBSCRIPTION"] = "subscription";
    Product["EXTERNAL_LEGITIMATION"] = "external-legitimation";
    Product["ALL"] = "all";
})(Product = exports.Product || (exports.Product = {}));
/**
 * Represents an ISO 3166-1 alpha-2 conform country code accessible through the full english name of the
 * country. This enum should be used to describe for instance vehicle origins or nationalities of
 * persons. Don't use it to describe a VWFS market. Use enum Country in @bus/models.
 */
var CountryCode;
(function (CountryCode) {
    CountryCode["Afghanistan"] = "AF";
    CountryCode["AlandIslands"] = "AX";
    CountryCode["Albania"] = "AL";
    CountryCode["Algeria"] = "DZ";
    CountryCode["AmericanSamoa"] = "AS";
    CountryCode["Andorra"] = "AD";
    CountryCode["Angola"] = "AO";
    CountryCode["Anguilla"] = "AI";
    CountryCode["Antarctica"] = "AQ";
    CountryCode["AntiguaAndBarbuda"] = "AG";
    CountryCode["Argentina"] = "AR";
    CountryCode["Armenia"] = "AM";
    CountryCode["Aruba"] = "AW";
    CountryCode["Australia"] = "AU";
    CountryCode["Austria"] = "AT";
    CountryCode["Azerbaijan"] = "AZ";
    CountryCode["Bahamas"] = "BS";
    CountryCode["Bahrain"] = "BH";
    CountryCode["Bangladesh"] = "BD";
    CountryCode["Barbados"] = "BB";
    CountryCode["Belarus"] = "BY";
    CountryCode["Belgium"] = "BE";
    CountryCode["Belize"] = "BZ";
    CountryCode["Benin"] = "BJ";
    CountryCode["Bermuda"] = "BM";
    CountryCode["Bhutan"] = "BT";
    CountryCode["Bolivia"] = "BO";
    CountryCode["BonaireSintEustatiusAndSaba"] = "BQ";
    CountryCode["BosniaAndHerzegovina"] = "BA";
    CountryCode["Botswana"] = "BW";
    CountryCode["BouvetIsland"] = "BV";
    CountryCode["Brazil"] = "BR";
    CountryCode["BritishIndianOceanTerritory"] = "IO";
    CountryCode["BruneiDarussalam"] = "BN";
    CountryCode["Bulgaria"] = "BG";
    CountryCode["BurkinaFaso"] = "BF";
    CountryCode["Burundi"] = "BI";
    CountryCode["Cambodia"] = "KH";
    CountryCode["Cameroon"] = "CM";
    CountryCode["Canada"] = "CA";
    CountryCode["CapeVerde"] = "CV";
    CountryCode["CaymanIslands"] = "KY";
    CountryCode["CentralAfricanRepublic"] = "CF";
    CountryCode["Chad"] = "TD";
    CountryCode["Chile"] = "CL";
    CountryCode["China"] = "CN";
    CountryCode["ChristmasIsland"] = "CX";
    CountryCode["CocosKeelingIslands"] = "CC";
    CountryCode["Colombia"] = "CO";
    CountryCode["Comoros"] = "KM";
    CountryCode["Congo"] = "CG";
    CountryCode["CongoDemocraticRepublic"] = "CD";
    CountryCode["CookIslands"] = "CK";
    CountryCode["CostaRica"] = "CR";
    CountryCode["Croatia"] = "HR";
    CountryCode["Cuba"] = "CU";
    CountryCode["Curacao"] = "CW";
    CountryCode["Cyprus"] = "CY";
    CountryCode["CzechRepublic"] = "CZ";
    CountryCode["Denmark"] = "DK";
    CountryCode["Djibouti"] = "DJ";
    CountryCode["Dominica"] = "DM";
    CountryCode["DominicanRepublic"] = "DO";
    CountryCode["Ecuador"] = "EC";
    CountryCode["Egypt"] = "EG";
    CountryCode["ElSalvador"] = "SV";
    CountryCode["EquatorialGuinea"] = "GQ";
    CountryCode["Eritrea"] = "ER";
    CountryCode["Estonia"] = "EE";
    CountryCode["Ethiopia"] = "ET";
    CountryCode["FalklandIslands"] = "FK";
    CountryCode["FaroeIslands"] = "FO";
    CountryCode["Fiji"] = "FJ";
    CountryCode["Finland"] = "FI";
    CountryCode["France"] = "FR";
    CountryCode["FrenchGuiana"] = "GF";
    CountryCode["FrenchPolynesia"] = "PF";
    CountryCode["FrenchSouthernTerritories"] = "TF";
    CountryCode["Gabon"] = "GA";
    CountryCode["Gambia"] = "GM";
    CountryCode["Georgia"] = "GE";
    CountryCode["Germany"] = "DE";
    CountryCode["Ghana"] = "GH";
    CountryCode["Gibraltar"] = "GI";
    CountryCode["Greece"] = "GR";
    CountryCode["Greenland"] = "GL";
    CountryCode["Grenada"] = "GD";
    CountryCode["Guadeloupe"] = "GP";
    CountryCode["Guam"] = "GU";
    CountryCode["Guatemala"] = "GT";
    CountryCode["Guernsey"] = "GG";
    CountryCode["Guinea"] = "GN";
    CountryCode["GuineaBissau"] = "GW";
    CountryCode["Guyana"] = "GY";
    CountryCode["Haiti"] = "HT";
    CountryCode["HeardIslandMcdonaldIslands"] = "HM";
    CountryCode["HolySeeVaticanCityState"] = "VA";
    CountryCode["Honduras"] = "HN";
    CountryCode["HongKong"] = "HK";
    CountryCode["Hungary"] = "HU";
    CountryCode["Iceland"] = "IS";
    CountryCode["India"] = "IN";
    CountryCode["Indonesia"] = "ID";
    CountryCode["Iran"] = "IR";
    CountryCode["Iraq"] = "IQ";
    CountryCode["Ireland"] = "IE";
    CountryCode["IsleOfMan"] = "IM";
    CountryCode["Israel"] = "IL";
    CountryCode["Italy"] = "IT";
    CountryCode["IvoryCoast"] = "CI";
    CountryCode["Jamaica"] = "JM";
    CountryCode["Japan"] = "JP";
    CountryCode["Jersey"] = "JE";
    CountryCode["Jordan"] = "JO";
    CountryCode["Kazakhstan"] = "KZ";
    CountryCode["Kenya"] = "KE";
    CountryCode["Kiribati"] = "KI";
    CountryCode["Korea"] = "KR";
    CountryCode["Kosovo"] = "XK";
    CountryCode["Kuwait"] = "KW";
    CountryCode["Kyrgyzstan"] = "KG";
    CountryCode["LaoPeoplesDemocraticRepublic"] = "LA";
    CountryCode["Latvia"] = "LV";
    CountryCode["Lebanon"] = "LB";
    CountryCode["Lesotho"] = "LS";
    CountryCode["Liberia"] = "LR";
    CountryCode["LibyanArabJamahiriya"] = "LY";
    CountryCode["Liechtenstein"] = "LI";
    CountryCode["Lithuania"] = "LT";
    CountryCode["Luxembourg"] = "LU";
    CountryCode["Macao"] = "MO";
    CountryCode["Macedonia"] = "MK";
    CountryCode["Madagascar"] = "MG";
    CountryCode["Malawi"] = "MW";
    CountryCode["Malaysia"] = "MY";
    CountryCode["Maldives"] = "MV";
    CountryCode["Mali"] = "ML";
    CountryCode["Malta"] = "MT";
    CountryCode["MarshallIslands"] = "MH";
    CountryCode["Martinique"] = "MQ";
    CountryCode["Mauritania"] = "MR";
    CountryCode["Mauritius"] = "MU";
    CountryCode["Mayotte"] = "YT";
    CountryCode["Mexico"] = "MX";
    CountryCode["Micronesia"] = "FM";
    CountryCode["Moldova"] = "MD";
    CountryCode["Monaco"] = "MC";
    CountryCode["Mongolia"] = "MN";
    CountryCode["Montenegro"] = "ME";
    CountryCode["Montserrat"] = "MS";
    CountryCode["Morocco"] = "MA";
    CountryCode["Mozambique"] = "MZ";
    CountryCode["Myanmar"] = "MM";
    CountryCode["Namibia"] = "NA";
    CountryCode["Nauru"] = "NR";
    CountryCode["Nepal"] = "NP";
    CountryCode["Netherlands"] = "NL";
    CountryCode["NetherlandsAntilles"] = "AN";
    CountryCode["NewCaledonia"] = "NC";
    CountryCode["NewZealand"] = "NZ";
    CountryCode["Nicaragua"] = "NI";
    CountryCode["Niger"] = "NE";
    CountryCode["Nigeria"] = "NG";
    CountryCode["Niue"] = "NU";
    CountryCode["NorfolkIsland"] = "NF";
    CountryCode["NorthernMarianaIslands"] = "MP";
    CountryCode["NorthKorea"] = "KP";
    CountryCode["Norway"] = "NO";
    CountryCode["Oman"] = "OM";
    CountryCode["Pakistan"] = "PK";
    CountryCode["Palau"] = "PW";
    CountryCode["PalestinianTerritory"] = "PS";
    CountryCode["Panama"] = "PA";
    CountryCode["PapuaNewGuinea"] = "PG";
    CountryCode["Paraguay"] = "PY";
    CountryCode["Peru"] = "PE";
    CountryCode["Philippines"] = "PH";
    CountryCode["Pitcairn"] = "PN";
    CountryCode["Poland"] = "PL";
    CountryCode["Portugal"] = "PT";
    CountryCode["PuertoRico"] = "PR";
    CountryCode["Qatar"] = "QA";
    CountryCode["Reunion"] = "RE";
    CountryCode["Romania"] = "RO";
    CountryCode["RussianFederation"] = "RU";
    CountryCode["Rwanda"] = "RW";
    CountryCode["SaintBarthelemy"] = "BL";
    CountryCode["SaintHelena"] = "SH";
    CountryCode["SaintKittsAndNevis"] = "KN";
    CountryCode["SaintLucia"] = "LC";
    CountryCode["SaintMartin"] = "MF";
    CountryCode["SaintPierreAndMiquelon"] = "PM";
    CountryCode["SaintVincentAndGrenadines"] = "VC";
    CountryCode["Samoa"] = "WS";
    CountryCode["SanMarino"] = "SM";
    CountryCode["SaoTomeAndPrincipe"] = "ST";
    CountryCode["SaudiArabia"] = "SA";
    CountryCode["Senegal"] = "SN";
    CountryCode["Serbia"] = "RS";
    CountryCode["Seychelles"] = "SC";
    CountryCode["SierraLeone"] = "SL";
    CountryCode["Singapore"] = "SG";
    CountryCode["SintMaarten"] = "SX";
    CountryCode["Slovakia"] = "SK";
    CountryCode["Slovenia"] = "SI";
    CountryCode["SolomonIslands"] = "SB";
    CountryCode["Somalia"] = "SO";
    CountryCode["SouthAfrica"] = "ZA";
    CountryCode["SouthGeorgiaAndSandwichIsl"] = "GS";
    CountryCode["Spain"] = "ES";
    CountryCode["SriLanka"] = "LK";
    CountryCode["Sudan"] = "SD";
    CountryCode["Suriname"] = "SR";
    CountryCode["SvalbardAndJanMayen"] = "SJ";
    CountryCode["Swaziland"] = "SZ";
    CountryCode["Sweden"] = "SE";
    CountryCode["Switzerland"] = "CH";
    CountryCode["SyrianArabRepublic"] = "SY";
    CountryCode["Taiwan"] = "TW";
    CountryCode["Tajikistan"] = "TJ";
    CountryCode["Tanzania"] = "TZ";
    CountryCode["Thailand"] = "TH";
    CountryCode["TimorLeste"] = "TL";
    CountryCode["Togo"] = "TG";
    CountryCode["Tokelau"] = "TK";
    CountryCode["Tonga"] = "TO";
    CountryCode["TrinidadAndTobago"] = "TT";
    CountryCode["Tunisia"] = "TN";
    CountryCode["Turkey"] = "TR";
    CountryCode["Turkmenistan"] = "TM";
    CountryCode["TurksAndCaicosIslands"] = "TC";
    CountryCode["Tuvalu"] = "TV";
    CountryCode["Uganda"] = "UG";
    CountryCode["Ukraine"] = "UA";
    CountryCode["UnitedArabEmirates"] = "AE";
    CountryCode["UnitedKingdom"] = "GB";
    CountryCode["UnitedStates"] = "US";
    CountryCode["UnitedStatesOutlyingIslands"] = "UM";
    CountryCode["Uruguay"] = "UY";
    CountryCode["Uzbekistan"] = "UZ";
    CountryCode["Vanuatu"] = "VU";
    CountryCode["Venezuela"] = "VE";
    CountryCode["Vietnam"] = "VN";
    CountryCode["VirginIslandsBritish"] = "VG";
    CountryCode["VirginIslandsUS"] = "VI";
    CountryCode["WallisAndFutuna"] = "WF";
    CountryCode["WesternSahara"] = "EH";
    CountryCode["Yemen"] = "YE";
    CountryCode["Zambia"] = "ZM";
    CountryCode["Zimbabwe"] = "ZW";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
/**
 * Represents an ISO 639-1 language code. It should be used whenever a langage has to be computed.
 */
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["Afar"] = "aa";
    LanguageCode["Abkhazian"] = "ab";
    LanguageCode["Avestan"] = "ae";
    LanguageCode["Afrikaans"] = "af";
    LanguageCode["Akan"] = "ak";
    LanguageCode["Amharic"] = "am";
    LanguageCode["Aragonese"] = "an";
    LanguageCode["Arabic"] = "ar";
    LanguageCode["Assamese"] = "as";
    LanguageCode["Avaric"] = "av";
    LanguageCode["Aymara"] = "ay";
    LanguageCode["Azerbaijani"] = "az";
    LanguageCode["Bashkir"] = "ba";
    LanguageCode["Belarusian"] = "be";
    LanguageCode["Bulgarian"] = "bg";
    LanguageCode["Bihari"] = "bh";
    LanguageCode["Bislama"] = "bi";
    LanguageCode["Bambara"] = "bm";
    LanguageCode["Bengali"] = "bn";
    LanguageCode["Tibetan"] = "bo";
    LanguageCode["Breton"] = "br";
    LanguageCode["Bosnian"] = "bs";
    LanguageCode["Catalan"] = "ca";
    LanguageCode["Chechen"] = "ce";
    LanguageCode["Chamorro"] = "ch";
    LanguageCode["Corsican"] = "co";
    LanguageCode["Cree"] = "cr";
    LanguageCode["Czech"] = "cs";
    LanguageCode["Chuvash"] = "cv";
    LanguageCode["Welsh"] = "cy";
    LanguageCode["Danish"] = "da";
    LanguageCode["German"] = "de";
    LanguageCode["Divehi"] = "dv";
    LanguageCode["Dzongkha"] = "dz";
    LanguageCode["Ewe"] = "ee";
    LanguageCode["Greek"] = "el";
    LanguageCode["English"] = "en";
    LanguageCode["Esperanto"] = "eo";
    LanguageCode["Spanish"] = "es";
    LanguageCode["Estonian"] = "et";
    LanguageCode["Basque"] = "eu";
    LanguageCode["Persian"] = "fa";
    LanguageCode["Fulah"] = "ff";
    LanguageCode["Finnish"] = "fi";
    LanguageCode["Fijian"] = "fj";
    LanguageCode["Faroese"] = "fo";
    LanguageCode["French"] = "fr";
    LanguageCode["WesternFrisian"] = "fy";
    LanguageCode["Irish"] = "ga";
    LanguageCode["Gaelic"] = "gd";
    LanguageCode["Galician"] = "gl";
    LanguageCode["Guarani"] = "gn";
    LanguageCode["Gujarati"] = "gu";
    LanguageCode["Manx"] = "gv";
    LanguageCode["Hausa"] = "ha";
    LanguageCode["Hebrew"] = "he";
    LanguageCode["Hindi"] = "hi";
    LanguageCode["Croatian"] = "hr";
    LanguageCode["Haitian"] = "ht";
    LanguageCode["Hungarian"] = "hu";
    LanguageCode["Armenian"] = "hy";
    LanguageCode["Herero"] = "hz";
    LanguageCode["Indonesian"] = "id";
    LanguageCode["Interlingue"] = "ie";
    LanguageCode["Igbo"] = "ig";
    LanguageCode["Sichuan"] = "ii";
    LanguageCode["Inupiaq"] = "ik";
    LanguageCode["Ido"] = "io";
    LanguageCode["Icelandic"] = "is";
    LanguageCode["Italian"] = "it";
    LanguageCode["Inuktitut"] = "iu";
    LanguageCode["Japanese"] = "ja";
    LanguageCode["Javanese"] = "jv";
    LanguageCode["Georgian"] = "ka";
    LanguageCode["Kongo"] = "kg";
    LanguageCode["Kikuyu"] = "ki";
    LanguageCode["Kuanyama"] = "kj";
    LanguageCode["Kazakh"] = "kk";
    LanguageCode["Kalaallisut"] = "kl";
    LanguageCode["CentralKhmer"] = "km";
    LanguageCode["Kannada"] = "kn";
    LanguageCode["Korean"] = "ko";
    LanguageCode["Kanuri"] = "kr";
    LanguageCode["Kashmiri"] = "ks";
    LanguageCode["Kurdish"] = "ku";
    LanguageCode["Komi"] = "kv";
    LanguageCode["Cornish"] = "kw";
    LanguageCode["Kirghiz"] = "ky";
    LanguageCode["Latin"] = "la";
    LanguageCode["Luxembourgish"] = "lb";
    LanguageCode["Ganda"] = "lg";
    LanguageCode["Limburgan"] = "li";
    LanguageCode["Lingala"] = "ln";
    LanguageCode["Lao"] = "lo";
    LanguageCode["Lithuanian"] = "lt";
    LanguageCode["LubaKatanga"] = "lu";
    LanguageCode["Latvian"] = "lv";
    LanguageCode["Malagasy"] = "mg";
    LanguageCode["Marshallese"] = "mh";
    LanguageCode["Maori"] = "mi";
    LanguageCode["Macedonian"] = "mk";
    LanguageCode["Malayalam"] = "ml";
    LanguageCode["Mongolian"] = "mn";
    LanguageCode["Marathi"] = "mr";
    LanguageCode["Malay"] = "ms";
    LanguageCode["Maltese"] = "mt";
    LanguageCode["Burmese"] = "my";
    LanguageCode["Nauru"] = "na";
    LanguageCode["Nepali"] = "ne";
    LanguageCode["Ndonga"] = "ng";
    LanguageCode["Dutch"] = "nl";
    LanguageCode["Norwegian"] = "no";
    LanguageCode["Ojibwa"] = "oj";
    LanguageCode["Oromo"] = "om";
    LanguageCode["Oriya"] = "or";
    LanguageCode["Ossetian"] = "os";
    LanguageCode["Panjabi"] = "pa";
    LanguageCode["Pali"] = "pi";
    LanguageCode["Polish"] = "pl";
    LanguageCode["Pushto"] = "ps";
    LanguageCode["Portuguese"] = "pt";
    LanguageCode["Quechua"] = "qu";
    LanguageCode["Romansh"] = "rm";
    LanguageCode["Rundi"] = "rn";
    LanguageCode["Romanian"] = "ro";
    LanguageCode["Russian"] = "ru";
    LanguageCode["Kinyarwanda"] = "rw";
    LanguageCode["Sanskrit"] = "sa";
    LanguageCode["Sardinian"] = "sc";
    LanguageCode["Sindhi"] = "sd";
    LanguageCode["Sango"] = "sg";
    LanguageCode["Sinhala"] = "si";
    LanguageCode["Slovak"] = "sk";
    LanguageCode["Slovenian"] = "sl";
    LanguageCode["Samoan"] = "sm";
    LanguageCode["Shona"] = "sn";
    LanguageCode["Somali"] = "so";
    LanguageCode["Albanian"] = "sq";
    LanguageCode["Serbian"] = "sr";
    LanguageCode["Swati"] = "ss";
    LanguageCode["Sotho"] = "st";
    LanguageCode["Sundanese"] = "su";
    LanguageCode["Swedish"] = "sv";
    LanguageCode["Swahili"] = "sw";
    LanguageCode["Tamil"] = "ta";
    LanguageCode["Telugu"] = "te";
    LanguageCode["Tajik"] = "tg";
    LanguageCode["Thai"] = "th";
    LanguageCode["Tigrinya"] = "ti";
    LanguageCode["Turkmen"] = "tk";
    LanguageCode["Tagalog"] = "tl";
    LanguageCode["Tswana"] = "tn";
    LanguageCode["Tonga"] = "to";
    LanguageCode["Turkish"] = "tr";
    LanguageCode["Tsonga"] = "ts";
    LanguageCode["Tatar"] = "tt";
    LanguageCode["Twi"] = "tw";
    LanguageCode["Tahitian"] = "ty";
    LanguageCode["Ukrainian"] = "uk";
    LanguageCode["Urdu"] = "ur";
    LanguageCode["Uzbek"] = "uz";
    LanguageCode["Venda"] = "ve";
    LanguageCode["Vietnamese"] = "vi";
    LanguageCode["Walloon"] = "wa";
    LanguageCode["Wolof"] = "wo";
    LanguageCode["Xhosa"] = "xh";
    LanguageCode["Yiddish"] = "yi";
    LanguageCode["Yoruba"] = "yo";
    LanguageCode["Zhuang"] = "za";
    LanguageCode["Chinese"] = "zh";
    LanguageCode["Zulu"] = "zu";
})(LanguageCode = exports.LanguageCode || (exports.LanguageCode = {}));
/**
 * Represents a phone country code. This enum should be used for all phone numbers.
 */
var PhoneCountryCode;
(function (PhoneCountryCode) {
    PhoneCountryCode["Abkhazia"] = "+7 840";
    PhoneCountryCode["Afghanistan"] = "+93";
    PhoneCountryCode["Albania"] = "+355";
    PhoneCountryCode["Algeria"] = "+213";
    PhoneCountryCode["AmericanSamoa"] = "+1 684";
    PhoneCountryCode["Andorra"] = "+376";
    PhoneCountryCode["Angola"] = "+244";
    PhoneCountryCode["Anguilla"] = "+1 264";
    PhoneCountryCode["AntiguaAndBarbuda"] = "+1 268";
    PhoneCountryCode["Argentina"] = "+54";
    PhoneCountryCode["Armenia"] = "+374";
    PhoneCountryCode["Aruba"] = "+297";
    PhoneCountryCode["Ascension"] = "+247";
    PhoneCountryCode["Australia"] = "+61";
    PhoneCountryCode["AustralianExternalTerritories"] = "+672";
    PhoneCountryCode["Austria"] = "+43";
    PhoneCountryCode["Azerbaijan"] = "+994";
    PhoneCountryCode["Bahamas"] = "+1 242";
    PhoneCountryCode["Bahrain"] = "+973";
    PhoneCountryCode["Bangladesh"] = "+880";
    PhoneCountryCode["Barbados"] = "+1 246";
    PhoneCountryCode["Barbuda"] = "+1 268";
    PhoneCountryCode["Belarus"] = "+375";
    PhoneCountryCode["Belgium"] = "+32";
    PhoneCountryCode["Belize"] = "+501";
    PhoneCountryCode["Benin"] = "+229";
    PhoneCountryCode["Bermuda"] = "+1 441";
    PhoneCountryCode["Bhutan"] = "+975";
    PhoneCountryCode["Bolivia"] = "+591";
    PhoneCountryCode["BosniaAndHerzegovina"] = "+387";
    PhoneCountryCode["Botswana"] = "+267";
    PhoneCountryCode["Brazil"] = "+55";
    PhoneCountryCode["BritishIndianOceanTerritory"] = "+246";
    PhoneCountryCode["BruneiDarussalam"] = "+673";
    PhoneCountryCode["Bulgaria"] = "+359";
    PhoneCountryCode["BurkinaFaso"] = "+226";
    PhoneCountryCode["Burundi"] = "+257";
    PhoneCountryCode["Cambodia"] = "+855";
    PhoneCountryCode["Cameroon"] = "+237";
    PhoneCountryCode["Canada"] = "+1";
    PhoneCountryCode["CapeVerde"] = "+238";
    PhoneCountryCode["CaymanIslands"] = "+ 345";
    PhoneCountryCode["CentralAfricanRepublic"] = "+236";
    PhoneCountryCode["Chad"] = "+235";
    PhoneCountryCode["Chile"] = "+56";
    PhoneCountryCode["China"] = "+86";
    PhoneCountryCode["ChristmasIsland"] = "+61";
    PhoneCountryCode["CocosKeelingIslands"] = "+61";
    PhoneCountryCode["Colombia"] = "+57";
    PhoneCountryCode["Comoros"] = "+269";
    PhoneCountryCode["Congo"] = "+242";
    PhoneCountryCode["CongoDemocraticRepublic"] = "+243";
    PhoneCountryCode["CookIslands"] = "+682";
    PhoneCountryCode["CostaRica"] = "+506";
    PhoneCountryCode["Croatia"] = "+385";
    PhoneCountryCode["Cuba"] = "+53";
    PhoneCountryCode["Curacao"] = "+599";
    PhoneCountryCode["Cyprus"] = "+357";
    PhoneCountryCode["CzechRepublic"] = "+420";
    PhoneCountryCode["Denmark"] = "+45";
    PhoneCountryCode["DiegoGarcia"] = "+246";
    PhoneCountryCode["Djibouti"] = "+253";
    PhoneCountryCode["Dominica"] = "+1 767";
    PhoneCountryCode["DominicanRepublic"] = "+1 809";
    PhoneCountryCode["EastTimor"] = "+670";
    PhoneCountryCode["EasterIsland"] = "+56";
    PhoneCountryCode["Ecuador"] = "+593";
    PhoneCountryCode["Egypt"] = "+20";
    PhoneCountryCode["ElSalvador"] = "+503";
    PhoneCountryCode["EquatorialGuinea"] = "+240";
    PhoneCountryCode["Eritrea"] = "+291";
    PhoneCountryCode["Estonia"] = "+372";
    PhoneCountryCode["Ethiopia"] = "+251";
    PhoneCountryCode["FalklandIslands"] = "+500";
    PhoneCountryCode["FaroeIslands"] = "+298";
    PhoneCountryCode["Fiji"] = "+679";
    PhoneCountryCode["Finland"] = "+358";
    PhoneCountryCode["France"] = "+33";
    PhoneCountryCode["FrenchAntilles"] = "+596";
    PhoneCountryCode["FrenchGuiana"] = "+594";
    PhoneCountryCode["FrenchPolynesia"] = "+689";
    PhoneCountryCode["Gabon"] = "+241";
    PhoneCountryCode["Gambia"] = "+220";
    PhoneCountryCode["Georgia"] = "+995";
    PhoneCountryCode["Germany"] = "+49";
    PhoneCountryCode["Ghana"] = "+233";
    PhoneCountryCode["Gibraltar"] = "+350";
    PhoneCountryCode["Greece"] = "+30";
    PhoneCountryCode["Greenland"] = "+299";
    PhoneCountryCode["Grenada"] = "+1 473";
    PhoneCountryCode["Guadeloupe"] = "+590";
    PhoneCountryCode["Guam"] = "+1 671";
    PhoneCountryCode["Guatemala"] = "+502";
    PhoneCountryCode["Guinea"] = "+224";
    PhoneCountryCode["GuineaBissau"] = "+245";
    PhoneCountryCode["Guyana"] = "+595";
    PhoneCountryCode["Haiti"] = "+509";
    PhoneCountryCode["Honduras"] = "+504";
    PhoneCountryCode["HongKong"] = "+852";
    PhoneCountryCode["Hungary"] = "+36";
    PhoneCountryCode["Iceland"] = "+354";
    PhoneCountryCode["India"] = "+91";
    PhoneCountryCode["Indonesia"] = "+62";
    PhoneCountryCode["Iran"] = "+98";
    PhoneCountryCode["Iraq"] = "+964";
    PhoneCountryCode["Ireland"] = "+353";
    PhoneCountryCode["Israel"] = "+972";
    PhoneCountryCode["Italy"] = "+39";
    PhoneCountryCode["IvoryCoast"] = "+225";
    PhoneCountryCode["Jamaica"] = "+1 876";
    PhoneCountryCode["Japan"] = "+81";
    PhoneCountryCode["Jordan"] = "+962";
    PhoneCountryCode["Kazakhstan"] = "+7 7";
    PhoneCountryCode["Kenya"] = "+254";
    PhoneCountryCode["Kiribati"] = "+686";
    PhoneCountryCode["Kuwait"] = "+965";
    PhoneCountryCode["Kyrgyzstan"] = "+996";
    PhoneCountryCode["Laos"] = "+856";
    PhoneCountryCode["Latvia"] = "+371";
    PhoneCountryCode["Lebanon"] = "+961";
    PhoneCountryCode["Lesotho"] = "+266";
    PhoneCountryCode["Liberia"] = "+231";
    PhoneCountryCode["Libya"] = "+218";
    PhoneCountryCode["Liechtenstein"] = "+423";
    PhoneCountryCode["Lithuania"] = "+370";
    PhoneCountryCode["Luxembourg"] = "+352";
    PhoneCountryCode["Macau"] = "+853";
    PhoneCountryCode["Macedonia"] = "+389";
    PhoneCountryCode["Madagascar"] = "+261";
    PhoneCountryCode["Malawi"] = "+265";
    PhoneCountryCode["Malaysia"] = "+60";
    PhoneCountryCode["Maldives"] = "+960";
    PhoneCountryCode["Mali"] = "+223";
    PhoneCountryCode["Malta"] = "+356";
    PhoneCountryCode["MarshallIslands"] = "+692";
    PhoneCountryCode["Martinique"] = "+596";
    PhoneCountryCode["Mauritania"] = "+222";
    PhoneCountryCode["Mauritius"] = "+230";
    PhoneCountryCode["Mayotte"] = "+262";
    PhoneCountryCode["Mexico"] = "+52";
    PhoneCountryCode["Micronesia"] = "+691";
    PhoneCountryCode["MidwayIsland"] = "+1 808";
    PhoneCountryCode["Moldova"] = "+373";
    PhoneCountryCode["Monaco"] = "+377";
    PhoneCountryCode["Mongolia"] = "+976";
    PhoneCountryCode["Montenegro"] = "+382";
    PhoneCountryCode["Montserrat"] = "+1664";
    PhoneCountryCode["Morocco"] = "+212";
    PhoneCountryCode["Myanmar"] = "+95";
    PhoneCountryCode["Namibia"] = "+264";
    PhoneCountryCode["Nauru"] = "+674";
    PhoneCountryCode["Nepal"] = "+977";
    PhoneCountryCode["Netherlands"] = "+31";
    PhoneCountryCode["NetherlandsAntilles"] = "+599";
    PhoneCountryCode["Nevis"] = "+1 869";
    PhoneCountryCode["NewCaledonia"] = "+687";
    PhoneCountryCode["NewZealand"] = "+64";
    PhoneCountryCode["Nicaragua"] = "+505";
    PhoneCountryCode["Niger"] = "+227";
    PhoneCountryCode["Nigeria"] = "+234";
    PhoneCountryCode["Niue"] = "+683";
    PhoneCountryCode["NorfolkIsland"] = "+672";
    PhoneCountryCode["NorthKorea"] = "+850";
    PhoneCountryCode["NorthernMarianaIslands"] = "+1 670";
    PhoneCountryCode["Norway"] = "+47";
    PhoneCountryCode["Oman"] = "+968";
    PhoneCountryCode["Pakistan"] = "+92";
    PhoneCountryCode["Palau"] = "+680";
    PhoneCountryCode["PalestinianTerritory"] = "+970";
    PhoneCountryCode["Panama"] = "+507";
    PhoneCountryCode["PapuaNewGuinea"] = "+675";
    PhoneCountryCode["Paraguay"] = "+595";
    PhoneCountryCode["Peru"] = "+51";
    PhoneCountryCode["Philippines"] = "+63";
    PhoneCountryCode["Poland"] = "+48";
    PhoneCountryCode["Portugal"] = "+351";
    PhoneCountryCode["PuertoRico"] = "+1 787";
    PhoneCountryCode["Qatar"] = "+974";
    PhoneCountryCode["Reunion"] = "+262";
    PhoneCountryCode["Romania"] = "+40";
    PhoneCountryCode["Russia"] = "+7";
    PhoneCountryCode["Rwanda"] = "+250";
    PhoneCountryCode["Samoa"] = "+685";
    PhoneCountryCode["SanMarino"] = "+378";
    PhoneCountryCode["SaudiArabia"] = "+966";
    PhoneCountryCode["Senegal"] = "+221";
    PhoneCountryCode["Serbia"] = "+381";
    PhoneCountryCode["Seychelles"] = "+248";
    PhoneCountryCode["SierraLeone"] = "+232";
    PhoneCountryCode["Singapore"] = "+65";
    PhoneCountryCode["Slovakia"] = "+421";
    PhoneCountryCode["Slovenia"] = "+386";
    PhoneCountryCode["SolomonIslands"] = "+677";
    PhoneCountryCode["SouthAfrica"] = "+27";
    PhoneCountryCode["SouthGeorgiaAndSandwichIsl"] = "+500";
    PhoneCountryCode["SouthKorea"] = "+82";
    PhoneCountryCode["Spain"] = "+34";
    PhoneCountryCode["SriLanka"] = "+94";
    PhoneCountryCode["Sudan"] = "+249";
    PhoneCountryCode["Suriname"] = "+597";
    PhoneCountryCode["Swaziland"] = "+268";
    PhoneCountryCode["Sweden"] = "+46";
    PhoneCountryCode["Switzerland"] = "+41";
    PhoneCountryCode["Syria"] = "+963";
    PhoneCountryCode["Taiwan"] = "+886";
    PhoneCountryCode["Tajikistan"] = "+992";
    PhoneCountryCode["Tanzania"] = "+255";
    PhoneCountryCode["Thailand"] = "+66";
    PhoneCountryCode["TimorLeste"] = "+670";
    PhoneCountryCode["Togo"] = "+228";
    PhoneCountryCode["Tokelau"] = "+690";
    PhoneCountryCode["Tonga"] = "+676";
    PhoneCountryCode["TrinidadAndTobago"] = "+1 868";
    PhoneCountryCode["Tunisia"] = "+216";
    PhoneCountryCode["Turkey"] = "+90";
    PhoneCountryCode["Turkmenistan"] = "+993";
    PhoneCountryCode["TurksAndCaicosIslands"] = "+1 649";
    PhoneCountryCode["Tuvalu"] = "+688";
    PhoneCountryCode["Uganda"] = "+256";
    PhoneCountryCode["Ukraine"] = "+380";
    PhoneCountryCode["UnitedArabEmirates"] = "+971";
    PhoneCountryCode["UnitedKingdom"] = "+44";
    PhoneCountryCode["UnitedStates"] = "+1";
    PhoneCountryCode["Uruguay"] = "+598";
    PhoneCountryCode["Uzbekistan"] = "+998";
    PhoneCountryCode["Vanuatu"] = "+678";
    PhoneCountryCode["Venezuela"] = "+58";
    PhoneCountryCode["Vietnam"] = "+84";
    PhoneCountryCode["VirginIslandsBritish"] = "+1 284";
    PhoneCountryCode["VirginIslandsUS"] = "+1 340";
    PhoneCountryCode["WakeIsland"] = "+1 808";
    PhoneCountryCode["WallisAndFutuna"] = "+681";
    PhoneCountryCode["Yemen"] = "+967";
    PhoneCountryCode["Zambia"] = "+260";
    PhoneCountryCode["Zanzibar"] = "+255";
    PhoneCountryCode["Zimbabwe"] = "+263";
})(PhoneCountryCode = exports.PhoneCountryCode || (exports.PhoneCountryCode = {}));
/**
 * Represents a credit type for credits that customers already have. This does not represent financial
 * products provided by VWFS. For that use Product enum from @bus/models.
 */
var CreditType;
(function (CreditType) {
    CreditType["CONSUMER_CREDIT"] = "CONSUMER_CREDIT";
    CreditType["CAR_CREDIT"] = "CAR_CREDIT";
    CreditType["LEASING"] = "LEASING";
    CreditType["EMPLOYEE_LOANS"] = "EMPLOYEE_LOANS";
    CreditType["ZERO_PERCENTAGE_FINANCING"] = "ZERO_PERCENTAGE_FINANCING";
    CreditType["FRAMEWORK_CREDIT"] = "FRAMEWORK_CREDIT";
    CreditType["CREDIT_CARD"] = "CREDIT_CARD";
})(CreditType = exports.CreditType || (exports.CreditType = {}));
/**
 * Represents type of a document template that may contain static content or may be filled with concrete
 * information related to a customer or the application data for a financial product. This enum should
 * be used by all DF.API services that need to handle documents instead of dealing with arbitrary string
 * values from various backends. For backends which require those kinds of string values this enum needs
 * to be mapped to the correct strings.
 */
var DocumentTemplateType;
(function (DocumentTemplateType) {
    /**
     * Represents the main application document for a financial product. It is filled with customer data and
     * data related to the financial product.
     */
    DocumentTemplateType["LOAN_APPLICATION"] = "LOAN_APPLICATION";
    /**
     * Represents the customers self disclosure about her general life situation and her financial position.
     * The document is filled with customer specific data.
     */
    DocumentTemplateType["CUSTOMER_SELF_DISCLOSURE"] = "CUSTOMER_SELF_DISCLOSURE";
    /**
     * Represents general information related to the loan brokerage. The document is filled with the data of
     * the loan broker (which is a car dealer of of the times) and application related data.
     */
    DocumentTemplateType["PRECONTRACTUAL_INFORMATION_LOAN_BROKERAGE"] = "PRECONTRACTUAL_INFORMATION_LOAN_BROKERAGE";
    /**
     * This represents a document containing european standard information on consumer credits. It is filled
     * with all kinds of concrete credit data including lender, loan amount, vehicle data and legal
     * information.
     */
    DocumentTemplateType["EUROPEAN_INFORMATION_CONSUMER_CREDITS"] = "EUROPEAN_INFORMATION_CONSUMER_CREDITS";
    /**
     * Represents a static explanation paper with information on the AutoCredit product. It contains no
     * transaction specific data.
     */
    DocumentTemplateType["AUTOCREDIT_PRODUCT_EXPLANATION"] = "AUTOCREDIT_PRODUCT_EXPLANATION";
    /**
     * Represents the acceptance document for the credit telling the customer that his loan was confirmed.
     * It is also filled with a subset of customer data, vehicle data and data related to the credit itself.
     */
    DocumentTemplateType["LOAN_ACCEPTANCE"] = "LOAN_ACCEPTANCE";
    /**
     * Represents a document for the customers consent on the data protection conditions. It is filled with
     * customer specific data and checkmarks for the consents.
     */
    DocumentTemplateType["DATA_PROTECTION_CONSENT"] = "DATA_PROTECTION_CONSENT";
    /**
     * Represents a document with data protection information. It is filled with the customers name and
     * address and transaction related data.
     */
    DocumentTemplateType["DATA_PROTECTION_INFORMATION"] = "DATA_PROTECTION_INFORMATION";
    /**
     * Represents the cover sheet with explanations on the documents of the credit application.
     */
    DocumentTemplateType["EXPLANATORY_COVER_SHEET"] = "EXPLANATORY_COVER_SHEET";
    /**
     * Represents a static information paper for the german credit worthiness agency SCHUFA.
     */
    DocumentTemplateType["SCHUFA_INFORMATION"] = "SCHUFA_INFORMATION";
    /**
     * Represents all kinds of documents that are uploaded by the customer during the application for a
     * financial product.
     */
    DocumentTemplateType["CUSTOMER_UPLOAD"] = "CUSTOMER_UPLOAD";
    /**
     * Represents the confirmation document from the identification provider (e.g. IDnow).
     */
    DocumentTemplateType["IDENTIFICATION_CONFIRMATION"] = "IDENTIFICATION_CONFIRMATION";
    /**
     * Represents the confirmation document from the identification provider for digital legitimation at the
     * point of sale
     */
    DocumentTemplateType["IDENTIFICATION_CONFIRMATION_DIGITAL_POS"] = "IDENTIFICATION_CONFIRMATION_DIGITAL_POS";
    /**
     * Represents the confirmation document from the identification provider for digital legitimation online
     * (e.g. video ident)
     */
    DocumentTemplateType["IDENTIFICATION_CONFIRMATION_DIGITAL_ONLINE"] = "IDENTIFICATION_CONFIRMATION_DIGITAL_ONLINE";
    /**
     * Represents the confirmation document from the identification provider for digital legitimation online
     * (bank ident)
     */
    DocumentTemplateType["IDENTIFICATION_CONFIRMATION_DIGITAL_ONLINE_BANK_IDENT"] = "IDENTIFICATION_CONFIRMATION_DIGITAL_ONLINE_BANK_IDENT";
    /**
     * Represents the contract document of the financial application in an aftersales channel.
     */
    DocumentTemplateType["AFTERSALES_CONTRACT"] = "AFTERSALES_CONTRACT";
    /**
     * Represents the offer document of the financial application in an aftersales channel.
     */
    DocumentTemplateType["AFTERSALES_OFFER"] = "AFTERSALES_OFFER";
    /**
     * Represents the offer document in thunder
     */
    DocumentTemplateType["CUSTOMER_FS_OFFER_PDF"] = "CUSTOMER_FS_OFFER_PDF";
    /**
     * Represents the cluster of contract confirmation documents
     */
    DocumentTemplateType["CONTRACT_CONFIRMATION_CLUSTER"] = "CONTRACT_CONFIRMATION_CLUSTER";
    /**
     * Represents the leasing contract confirmation document
     */
    DocumentTemplateType["CONTRACT_CONFIRMATION_LEASING"] = "CONTRACT_CONFIRMATION_LEASING";
    /**
     * Represents the confirmation document for receiving of contract
     */
    DocumentTemplateType["CONTRACT_CONFIRMATION_RECEIPT"] = "CONTRACT_CONFIRMATION_RECEIPT";
    /**
     * Represents the cluster of dealer documents
     */
    DocumentTemplateType["DEALER_DOCUMENT_CLUSTER"] = "DEALER_DOCUMENT_CLUSTER";
    /**
     * Represents the cover letter for dealer
     */
    DocumentTemplateType["COVER_LETTER_DEALER"] = "COVER_LETTER_DEALER";
    /**
     * Represents the purchase warranty document
     */
    DocumentTemplateType["PURCHASE_WARRANTY"] = "PURCHASE_WARRANTY";
    /**
     * Represents the leasing calculation document
     */
    DocumentTemplateType["CALCULATION_LEASING"] = "CALCULATION_LEASING";
    /**
     * Represents the services calculation document
     */
    DocumentTemplateType["CALCULATION_SERVICES"] = "CALCULATION_SERVICES";
    /**
     * Represents the calculation of extras
     */
    DocumentTemplateType["CALCULATION_EXTRAS"] = "CALCULATION_EXTRAS";
    /**
     * Represents the cluster of data protection documents
     */
    DocumentTemplateType["DATA_PROTECTION_CLUSTER"] = "DATA_PROTECTION_CLUSTER";
    /**
     * Represents the cluster of leasing contract documents
     */
    DocumentTemplateType["PRECONTRACTUAL_INFORMATION_CLUSTER_LEASING"] = "PRECONTRACTUAL_INFORMATION_CLUSTER_LEASING";
    /**
     * Represents the cluster of self disclosure documents
     */
    DocumentTemplateType["SELFDISCLOSURE_CUSTOMER_CLUSTER"] = "SELFDISCLOSURE_CUSTOMER_CLUSTER";
    /**
     * Represents the cluster of documents for pre-contractual LRV information
     */
    DocumentTemplateType["PRECONTRACTUAL_INFORMATION_CLUSTER_CPI"] = "PRECONTRACTUAL_INFORMATION_CLUSTER_CPI";
    /**
     * Represents the cluster of leasing contract documents for customer
     */
    DocumentTemplateType["CONTRACT_CUSTOMER_DOCUMENTS_LEASING"] = "CONTRACT_CUSTOMER_DOCUMENTS_LEASING";
    /**
     * Represents the cluster of leasing contract documents for VWFS
     */
    DocumentTemplateType["CONTRACT_VWFS_DOCUMENTS_LEASING"] = "CONTRACT_VWFS_DOCUMENTS_LEASING";
    /**
     * Represents the cluster of leasing contract documents for dealer
     */
    DocumentTemplateType["CONTRACT_DEALER_DOCUMENTS_LEASING"] = "CONTRACT_DEALER_DOCUMENTS_LEASING";
    /**
     * Represents the cluster of leasing contract documents for LogPay
     */
    DocumentTemplateType["CONTRACT_LOGPAY_DOCUMENTS_LEASING"] = "CONTRACT_LOGPAY_DOCUMENTS_LEASING";
    /**
     * Condition tyre substitution private
     */
    DocumentTemplateType["CONDITION_TYRE_SUBSTITUTION_PRIVATE"] = "CONDITION_TYRE_SUBSTITUTION_PRIVATE";
    /**
     * Fuel supply application consumer non cash
     */
    DocumentTemplateType["FUEL_SUPPLY_APPLICATION_CONSUMER_NON_CASH"] = "FUEL_SUPPLY_APPLICATION_CONSUMER_NON_CASH";
    /**
     * Fuel supply conditions consumer
     */
    DocumentTemplateType["FUEL_SUPPLY_CONDITIONS_CONSUMER"] = "FUEL_SUPPLY_CONDITIONS_CONSUMER";
    /**
     * Fuel supply cancellation term information consumer
     */
    DocumentTemplateType["FUEL_SUPPLY_CANCELLATION_TERM_INFORMATION_CONSUMER"] = "FUEL_SUPPLY_CANCELLATION_TERM_INFORMATION_CONSUMER";
    /**
     * Fuel supply data protection information lpts
     */
    DocumentTemplateType["FUEL_SUPPLY_DATA_PROTECTION_INFORMATION_LPTS"] = "FUEL_SUPPLY_DATA_PROTECTION_INFORMATION_LPTS";
    /**
     * Leasing order private id3
     */
    DocumentTemplateType["LEASING_ORDER_PRIVATE_ID3"] = "LEASING_ORDER_PRIVATE_ID3";
    /**
     * Thunder contract documents
     */
    DocumentTemplateType["THUNDER_CONTRACT_DOCUMENTS"] = "THUNDER_CONTRACT_DOCUMENTS";
    /**
     * Thunder customer information
     */
    DocumentTemplateType["THUNDER_CUSTOMER_INFORMATION"] = "THUNDER_CUSTOMER_INFORMATION";
    /**
     * Thunder self disclosure customer mail
     */
    DocumentTemplateType["THUNDER_SELF_DISCLOSURE_CUSTOMER_MAIL"] = "THUNDER_SELF_DISCLOSURE_CUSTOMER_MAIL";
    /**
     * Thunder VVI customer mail
     */
    DocumentTemplateType["THUNDER_VVI_CUSTOMER_MAIL"] = "THUNDER_VVI_CUSTOMER_MAIL";
    /**
     * Vap leasing order 179
     */
    DocumentTemplateType["VAP_LEASING_ORDER_179"] = "VAP_LEASING_ORDER_179";
    /**
     * Vap leasing conditions wi used car
     */
    DocumentTemplateType["VAP_LEASING_CONDITIONS_WI_USED_CAR"] = "VAP_LEASING_CONDITIONS_WI_USED_CAR";
    /**
     * Leasing calculation enclosure
     */
    DocumentTemplateType["LEASING_CALCULATION_ENCLOSURE"] = "LEASING_CALCULATION_ENCLOSURE";
    /**
     * Document that gives information about reduction in VAT (Value Added Tax).
     */
    DocumentTemplateType["VAT_REDUCTION_INFORMATION"] = "VAT_REDUCTION_INFORMATION";
    /**
     * Represents the contract composition (merged document), client copy
     */
    DocumentTemplateType["APPLICATION_COMPOSITION"] = "APPLICATION_COMPOSITION";
    /**
     * Represents the contract composition (merged document), dealership copy
     */
    DocumentTemplateType["APPLICATION_COMPOSITION_AH"] = "APPLICATION_COMPOSITION_AH";
    /**
     * Represents the contract composition (merged document), Volkswagen Leasing copy
     */
    DocumentTemplateType["APPLICATION_COMPOSITION_VWL"] = "APPLICATION_COMPOSITION_VWL";
    /**
     * Represents the information brochure residual debt insurance
     */
    DocumentTemplateType["IPID"] = "IPID";
    /**
     * Represents the insurance conditions
     */
    DocumentTemplateType["GPC"] = "GPC";
    /**
     * Represents the consultation protocol
     */
    DocumentTemplateType["CONSULTATION_PROTOCOL"] = "CONSULTATION_PROTOCOL";
    /**
     * Represents the application document
     */
    DocumentTemplateType["APPLICATION"] = "APPLICATION";
    /**
     * Represents the data protection information for Cardif
     */
    DocumentTemplateType["DPS_CARDIF"] = "DPS_CARDIF";
    /**
     * Represents the data protection information for Volkswagen Versicherungsdienst
     */
    DocumentTemplateType["DPS_VVD"] = "DPS_VVD";
    /**
     * Represents the initial information to inform customer about important product facts
     */
    DocumentTemplateType["INITIAL_INFORMATION"] = "INITIAL_INFORMATION";
    DocumentTemplateType["VEHICLE_CONSUMPTION_INFORMATION"] = "VEHICLE_CONSUMPTION_INFORMATION";
    DocumentTemplateType["VEHICLE_TIRE_INFORMATION"] = "VEHICLE_TIRE_INFORMATION";
    /**
     * Represents the appendix document related to occupation and industry.
     */
    DocumentTemplateType["ANNEX_OCCUPATION_INDUSTRY_KEY"] = "ANNEX_OCCUPATION_INDUSTRY_KEY";
    /**
     * Information about contract revocation.
     */
    DocumentTemplateType["REVOCATION_INFORMATION"] = "REVOCATION_INFORMATION";
})(DocumentTemplateType = exports.DocumentTemplateType || (exports.DocumentTemplateType = {}));
/**
 * This represents the unit of duration for a financial product provided by VWFS. Currently all products
 * are monthly paid and therefore there is only one value. This may change in the future
 */
var DocumentType;
(function (DocumentType) {
    DocumentType["UPLOADS"] = "uploads";
    DocumentType["CONTRACTSIGNED"] = "contract-signed";
    DocumentType["CONTRACTUNSIGNED"] = "contract-unsigned";
    DocumentType["CUSTOMER"] = "customer";
    DocumentType["DEALER"] = "dealer";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
/**
 * Represents the unit of power in a car engine.
 */
var EnginePowerUnit;
(function (EnginePowerUnit) {
    EnginePowerUnit["HORSEPOWER"] = "HORSEPOWER";
    EnginePowerUnit["KILOWATT"] = "KILOWATT";
})(EnginePowerUnit = exports.EnginePowerUnit || (exports.EnginePowerUnit = {}));
/**
 * Represents the gender of a person.
 */
var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender = exports.Gender || (exports.Gender = {}));
/**
 * Represents the housing situation of a person.
 */
var HousingSituation;
(function (HousingSituation) {
    HousingSituation["HOSTED_FREE"] = "HOSTED_FREE";
    HousingSituation["HOUSED_ADMIN"] = "HOUSED_ADMIN";
    HousingSituation["HOUSED_EMPLOYER"] = "HOUSED_EMPLOYER";
    HousingSituation["HOUSED_PARENTS"] = "HOUSED_PARENTS";
    HousingSituation["PROPERTY_ACCESS"] = "PROPERTY_ACCESS";
    HousingSituation["PROPERTY_OWNERSHIP"] = "PROPERTY_OWNERSHIP";
    HousingSituation["RENT"] = "RENT";
    HousingSituation["APARTMENT_OWNERSHIP"] = "APARTMENT_OWNERSHIP";
    HousingSituation["HOUSE_OWNERSHIP"] = "HOUSE_OWNERSHIP";
    HousingSituation["RENT_APARTMENT"] = "RENT_APARTMENT";
    HousingSituation["RENT_HOUSE"] = "RENT_HOUSE";
    HousingSituation["OTHER"] = "OTHER";
})(HousingSituation = exports.HousingSituation || (exports.HousingSituation = {}));
/**
 * Represents the identification reason of a single identification at IDnow. The reason will be sent in
 * identificationprocess.reason in the webhook by idNow when an identification is ABORTED or CANCELED.
 * The reasons can be permanent an/or caused by the user
 */
var IdentificationReason;
(function (IdentificationReason) {
    /**
     * Address from application does not match address from id document and cannot be corrected. Permanent:
     * yes Caused by user: yes
     */
    IdentificationReason["DATA_APPLICATION_ADDRESS"] = "DATA_APPLICATION_ADDRESS";
    /**
     * Data from application and data from the id document do not match and cannot be corrected. Permanent:
     * yes Caused by user: yes
     */
    IdentificationReason["DATA_APPLICATION_DATA"] = "DATA_APPLICATION_DATA";
    /**
     * The validity date of the id document has expired.User must just a different document. Permanent: no
     * Caused by user: yes
     */
    IdentificationReason["DATA_ID_EXPIRED"] = "DATA_ID_EXPIRED";
    /**
     * Abuse of the procedure.Inappropriate behavior. Permanent: no Caused by user: yes
     */
    IdentificationReason["OTHER_ABUSE"] = "OTHER_ABUSE";
    /**
     * Other error, which is not covered by specific error. Cannot be solved. Permanent: yes Caused by user:
     * -
     */
    IdentificationReason["OTHER_MISCELLANEOUS_PERMANENT"] = "OTHER_MISCELLANEOUS_PERMANENT";
    /**
     * Other error, which is not covered by specific error. Can be solved by a retry. Permanent: no Caused
     * by user: -
     */
    IdentificationReason["OTHER_MISCELLANEOUS_TEMPORARY"] = "OTHER_MISCELLANEOUS_TEMPORARY";
    /**
     * Identification was a test call. Permanent: no Caused by user: yes
     */
    IdentificationReason["OTHER_TEST"] = "OTHER_TEST";
    /**
     * When an identification process is running for too long, then the identification request no will be
     * cancelled with this reason. Permanent: no Caused by user: -
     */
    IdentificationReason["STALLED_TIMEOUT"] = "STALLED_TIMEOUT";
    /**
     * Poor audio quality.Audio quality is poor or no user / agent inaudible. Permanent: no Caused by user:
     * yes
     */
    IdentificationReason["TECH_AUDIO"] = "TECH_AUDIO";
    /**
     * The video stream has disconnected during no the identification. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_DISCONNECTED_VIDEO"] = "TECH_DISCONNECTED_VIDEO";
    /**
     * The websocket connection is disconnected during the identification. Normally caused no by loss of
     * internet connection by the user. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_DISCONNECTED_WEBSOCKET"] = "TECH_DISCONNECTED_WEBSOCKET";
    /**
     * Security features not visible or broken.No no suspicion of fraud. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_HOLOGRAM"] = "TECH_HOLOGRAM";
    /**
     * Id document is not allowed or is not no supported. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_ID_TYPE"] = "TECH_ID_TYPE";
    /**
     * User was unable to receive the ident code no SMS. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_IDENT_CODE_DELIVERY"] = "TECH_IDENT_CODE_DELIVERY";
    /**
     * An error occurred on server. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_INTERNAL_SERVER_ERROR"] = "TECH_INTERNAL_SERVER_ERROR";
    /**
     * Internet connection of the user is not fast no enough. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_INTERNET_CONNECTION"] = "TECH_INTERNET_CONNECTION";
    /**
     * Poor lighting. Person or id document not no sufficiently visible. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_LIGHTING"] = "TECH_LIGHTING";
    /**
     * Poor photo quality. Person or id document not sufficiently sharp and no recognizable. Permanent: no
     * Caused by user: yes
     */
    IdentificationReason["TECH_PHOTO"] = "TECH_PHOTO";
    /**
     * The identification request was open too long. Identification requests get aborted no after 30
     * minutes. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_TIMEOUT"] = "TECH_TIMEOUT";
    /**
     * Poor video quality or camera not good enough. Person or id document not no sufficiently sharp and
     * recognizable. Permanent: no Caused by user: yes
     */
    IdentificationReason["TECH_VIDEO"] = "TECH_VIDEO";
    /**
     * User has aborted the identification while he no was waiting for an available agent. Permanent: no
     * Caused by user: yes
     */
    IdentificationReason["USER_ABORT_WHILE_WAITING"] = "USER_ABORT_WHILE_WAITING";
    /**
     * User has aborted the identification.no Permanent: no Caused by user: yes
     */
    IdentificationReason["USER_CANCELLATION"] = "USER_CANCELLATION";
    /**
     * User repeatedly reads the wrong id no document number. Permanent: no Caused by user: yes
     */
    IdentificationReason["USER_ID_NUMBER"] = "USER_ID_NUMBER";
    /**
     * Ident code repeatedly entered incorrectly.no Permanent: no Caused by user: yes
     */
    IdentificationReason["USER_IDENT_CODE"] = "USER_IDENT_CODE";
    /**
     * User speaks unsupported language. Permanent: yes Caused by user: yes
     */
    IdentificationReason["USER_LANGUAGE"] = "USER_LANGUAGE";
    /**
     * User has currently no id card available Permanent: no Caused by user: yes
     */
    IdentificationReason["USER_NO_ID"] = "USER_NO_ID";
    /**
     * The person of application and identification do not match. E.g. Husband has opened no bank account,
     * but wife is in the identification call. No suspicion of fraud. Permanent: no Caused by user: yes
     */
    IdentificationReason["USER_WRONG_PERSON"] = "USER_WRONG_PERSON";
    /**
     * The user has been a victim of a social engineering attempt. Important: The user is not doing a fraud
     * attempt himself, but has been tricked into performing an identification.
     */
    IdentificationReason["WARNING_SOCIAL_ENGINEERING"] = "WARNING_SOCIAL_ENGINEERING";
    /**
     * The ID document has been manipulated (e.g. fields have been changed, photo has been replaced)
     */
    IdentificationReason["WARNING_ID_MANIPULATION"] = "WARNING_ID_MANIPULATION";
    /**
     * The ID document is a completely falsified document.
     */
    IdentificationReason["WARNING_FAKE_ID"] = "WARNING_FAKE_ID";
    /**
     * The person on the video chat is different from the person on the ID document.
     */
    IdentificationReason["WARNING_PHOTO"] = "WARNING_PHOTO";
    /**
     * The description of the person (e.g. height, eye color, age) does not match the person.
     */
    IdentificationReason["WARNING_DESCRIPTION"] = "WARNING_DESCRIPTION";
    /**
     * The person has shown suspicious behavior like answering psychological security question wrong.
     */
    IdentificationReason["WARNING_BEHAVIOUR"] = "WARNING_BEHAVIOUR";
    /**
     * The data on the ID document is inconsistent (e.g. differences between visible zone and MRZ)
     */
    IdentificationReason["WARNING_INCONSISTENT_DATA"] = "WARNING_INCONSISTENT_DATA";
    /**
     * A checksum on the ID document is wrong.
     */
    IdentificationReason["WARNING_WRONG_CHECKSUM"] = "WARNING_WRONG_CHECKSUM";
})(IdentificationReason = exports.IdentificationReason || (exports.IdentificationReason = {}));
/**
 * Represents the identification status of a single identification at IDnow. When starting an
 * identificaiton, the status will be INITIALIZED. The default happy-path will be: INITIALIZED ->
 * REVIEW_PENDING -> SUCCESS See also IDnow API Documentation Chapter 13
 */
var IdentificationStatus;
(function (IdentificationStatus) {
    /**
     * Identification was initialized at IDnow.
     */
    IdentificationStatus["INITIALIZED"] = "INITIALIZED";
    /**
     * The identification has been finished successfully and the result is now waiting for review. The
     * result is expected to be SUCCESS or SUCCESS_DATA_CHANGED after the review. For a realtime process
     * this result can be treated as a successful identification. Type: Preliminary
     */
    IdentificationStatus["REVIEW_PENDING"] = "REVIEW_PENDING";
    /**
     * The identification has finished but a fraud suspicion arised during the identification. The result is
     * expected to be FRAUD_SUSPICION_CONFIRMED after the review. For a realtime process this result should
     * be treated as a pending or failed identification. Type: Preliminary
     */
    IdentificationStatus["FRAUD_SUSPICION_PENDING"] = "FRAUD_SUSPICION_PENDING";
    /**
     * The identification has been performed without problems or changed data.
     */
    IdentificationStatus["SUCCESS"] = "SUCCESS";
    /**
     * The identification has been performed without problems, but data has been changed compared to the
     * initially provided data. This might happen if the user made a typo (“22.05.1982” instead of
     * “22.05.1983”). The changed field will be marked with status “CHANGE”.
     */
    IdentificationStatus["SUCCESS_DATA_CHANGED"] = "SUCCESS_DATA_CHANGED";
    /**
     * The agent has a suspicion that the user tried to commit fraud.  Additional details are available from
     * IDnow on request.
     */
    IdentificationStatus["FRAUD_SUSPICION_CONFIRMED"] = "FRAUD_SUSPICION_CONFIRMED";
    /**
     * If the agent aborted the identification. Example reasons are technical errors like the user’s camera
     * or audio is not working. You will also get the reason why the call failed.
     */
    IdentificationStatus["ABORTED"] = "ABORTED";
    /**
     * If the agent detects invalid data during the review that cannot be corrected. E.g. the reviewer
     * decides that the image quality was not good enough and cancels the identification after the realtime
     * result has already been sent. While this can happen, its rather rare (about 0.1 % of the
     * identifications)
     */
    IdentificationStatus["CANCELED"] = "CANCELED";
    /**
     * Address from application does not match address from id document and cannot be corrected.
     */
    IdentificationStatus["DATA_APPLICATION_ADDRESS"] = "DATA_APPLICATION_ADDRESS";
    /**
     * Data from application and data from the id document do not match and cannot be corrected.
     */
    IdentificationStatus["DATA_APPLICATION_DATA"] = "DATA_APPLICATION_DATA";
    /**
     * Other error, which is not covered by specific error. Cannot be solved.
     */
    IdentificationStatus["OTHER_MISCELLANEOUS_PERMANENT"] = "OTHER_MISCELLANEOUS_PERMANENT";
    /**
     * User speaks unsupported language.
     */
    IdentificationStatus["USER_LANGUAGE"] = "USER_LANGUAGE";
})(IdentificationStatus = exports.IdentificationStatus || (exports.IdentificationStatus = {}));
/**
 * * Represents the verifivation state of a single identification/consents/esign at Verimi.
 *  * When
 * starting an verification, the status will be INITIALIZED.
 *  * The default happy-path will be:
 *  *
 * INITIALIZED -> REVIEW_PENDING -> SUCCESS
 */
var VerificationState;
(function (VerificationState) {
    /**
     * Verification was initialized.
     */
    VerificationState["INITIALIZED"] = "INITIALIZED";
    /**
     * The verification has been finished successfully and the result is now waiting for review. The result
     * is expected to be SUCCESS after the review. For a realtime process this result can be treated as a
     * successful identification. Type: Preliminary
     */
    VerificationState["REVIEW_PENDING"] = "REVIEW_PENDING";
    /**
     * The verification has been finished on the provider and the result is now waiting for download.
     */
    VerificationState["DOWNLOAD_PENDING"] = "DOWNLOAD_PENDING";
    /**
     * The verification has been performed without problems or changed data.
     */
    VerificationState["SUCCESS"] = "SUCCESS";
    /**
     * If the agent aborted the verification. Example reasons are technical errors like the user’s camera or
     * audio is not working. You will also get the reason why the call failed.
     */
    VerificationState["ABORTED"] = "ABORTED";
    /**
     * If the agent detects invalid data during the review that cannot be corrected. E.g. the reviewer
     * decides that the image quality was not good enough and cancels the identification after the realtime
     * result has already been sent. While this can happen, its rather rare (about 0.1 % of the
     * identifications)
     */
    VerificationState["CANCELED"] = "CANCELED";
    /**
     * If agent return error, which has unknown reason. Some backends cannot distinquish between ABORTED and
     * CANCELLED and returns simply ERROR.
     */
    VerificationState["ERROR"] = "ERROR";
})(VerificationState = exports.VerificationState || (exports.VerificationState = {}));
/**
 * Represents the marital status of a person.
 */
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["CIVIL_PARTNERSHIP"] = "CIVIL_PARTNERSHIP";
    MaritalStatus["DIVORCED"] = "DIVORCED";
    MaritalStatus["LIVING_TOGETHER"] = "LIVING_TOGETHER";
    MaritalStatus["MARRIED"] = "MARRIED";
    MaritalStatus["MARRIED_SAME_GENDER"] = "MARRIED_SAME_GENDER";
    MaritalStatus["SEPARATED"] = "SEPARATED";
    MaritalStatus["SINGLE"] = "SINGLE";
    MaritalStatus["WIDOWED"] = "WIDOWED";
})(MaritalStatus = exports.MaritalStatus || (exports.MaritalStatus = {}));
/**
 * Represents the occupation type of an employment. It does not represent a profession in terms of a
 * certain activity like teacher or postman.
 */
var Occupation;
(function (Occupation) {
    Occupation["ADMINISTRATIVE_BUSINESS"] = "ADMINISTRATIVE_BUSINESS";
    Occupation["ADMINISTRATIVE_EMPLOYEE"] = "ADMINISTRATIVE_EMPLOYEE";
    Occupation["ADMINISTRATIVE_PUBLIC"] = "ADMINISTRATIVE_PUBLIC";
    Occupation["APPRENTICE"] = "APPRENTICE";
    Occupation["ASYLUM_SEEKER"] = "ASYLUM_SEEKER";
    Occupation["BUSINESS_OWNER"] = "BUSINESS_OWNER";
    Occupation["CARE_ATTENDANTS_SALARIED_DOCTORS"] = "CARE_ATTENDANTS_SALARIED_DOCTORS";
    Occupation["CIVIL_SERVANT"] = "CIVIL_SERVANT";
    Occupation["CIVIL_SERVANT_HIGHER_SERVICE"] = "CIVIL_SERVANT_HIGHER_SERVICE";
    Occupation["CLERGY"] = "CLERGY";
    Occupation["CONTRACTOR"] = "CONTRACTOR";
    Occupation["DEPENDENTLY_EMPLOYED_GRADUATE_PROFESSION"] = "DEPENDENTLY_EMPLOYED_GRADUATE_PROFESSION";
    Occupation["DEPENDENTLY_EMPLOYED_SOLICITOR"] = "DEPENDENTLY_EMPLOYED_SOLICITOR";
    Occupation["DIPLOMAT"] = "DIPLOMAT";
    Occupation["DRIVER"] = "DRIVER";
    Occupation["EMPLOYEE"] = "EMPLOYEE";
    Occupation["EMPLOYEE_PUBLIC"] = "EMPLOYEE_PUBLIC";
    Occupation["EMPLOYEE_TRADE"] = "EMPLOYEE_TRADE";
    Occupation["ENGINEER"] = "ENGINEER";
    Occupation["ENTERPRISE_EXECUTIVE"] = "ENTERPRISE_EXECUTIVE";
    Occupation["FARMER"] = "FARMER";
    Occupation["GASTRONOMY_EMPLOYEE"] = "GASTRONOMY_EMPLOYEE";
    Occupation["HEALTH_CARE"] = "HEALTH_CARE";
    Occupation["HOMEMAKER"] = "HOMEMAKER";
    Occupation["INFORMATION_ARTS_ENTERTAINMENT"] = "INFORMATION_ARTS_ENTERTAINMENT";
    Occupation["INVALID"] = "INVALID";
    Occupation["LAW_ENFORCEMENT"] = "LAW_ENFORCEMENT";
    Occupation["LIBERAL_PROFESSION"] = "LIBERAL_PROFESSION";
    Occupation["MANAGER"] = "MANAGER";
    Occupation["ARTIST"] = "ARTIST";
    Occupation["CRAFTSMAN"] = "CRAFTSMAN";
    Occupation["MAID_AND_CAREGIVER"] = "MAID_AND_CAREGIVER";
    Occupation["CONSULTANT"] = "CONSULTANT";
    Occupation["MUNICIPAL_EMPLOYEE"] = "MUNICIPAL_EMPLOYEE";
    Occupation["MANOVALS"] = "MANOVALS";
    Occupation["MILITARY_PETTY_OFFICER"] = "MILITARY_PETTY_OFFICER";
    Occupation["MILITARY_OFFICER"] = "MILITARY_OFFICER";
    Occupation["DEALER"] = "DEALER";
    Occupation["REPAIR_INSTALLER_WORKER"] = "REPAIR_INSTALLER_WORKER";
    Occupation["SKILLED_WORKER"] = "SKILLED_WORKER";
    Occupation["NURSE_PARAMEDICIANS"] = "NURSE_PARAMEDICIANS";
    Occupation["PROF"] = "PROF";
    Occupation["UNIVERSITY_RESEARCHER"] = "UNIVERSITY_RESEARCHER";
    Occupation["PROFESSIONAL"] = "PROFESSIONAL";
    Occupation["SECURITY_SERVICES"] = "SECURITY_SERVICES";
    Occupation["REPRESENTATIVES_AGENTS"] = "REPRESENTATIVES_AGENTS";
    Occupation["LAYOFF"] = "LAYOFF";
    Occupation["LEGAL_PERSON"] = "LEGAL_PERSON";
    Occupation["MANAGER_PUBLIC"] = "MANAGER_PUBLIC";
    Occupation["MIDDLE_MANAGEMENT_POSITION"] = "MIDDLE_MANAGEMENT_POSITION";
    Occupation["NEET"] = "NEET";
    Occupation["NEET_SENIOR"] = "NEET_SENIOR";
    Occupation["OFFICER_PROFESSIONAL_SOLDIER"] = "OFFICER_PROFESSIONAL_SOLDIER";
    Occupation["OFFICIAL_NON_STATE"] = "OFFICIAL_NON_STATE";
    Occupation["OFFICIAL_STATE"] = "OFFICIAL_STATE";
    Occupation["OTHERS"] = "OTHERS";
    Occupation["PENSIONER"] = "PENSIONER";
    Occupation["PERSON_IN_COMMUNITY_SERVICE"] = "PERSON_IN_COMMUNITY_SERVICE";
    Occupation["PERSON_WITHOUT_VOCATIONAL_QUALIFICATION"] = "PERSON_WITHOUT_VOCATIONAL_QUALIFICATION";
    Occupation["PERSONAL_SERVICES_TO_INDIVIDUALS"] = "PERSONAL_SERVICES_TO_INDIVIDUALS";
    Occupation["PUPIL"] = "PUPIL";
    Occupation["REGULAR_SOLDIER"] = "REGULAR_SOLDIER";
    Occupation["SALESPERSON"] = "SALESPERSON";
    Occupation["SCIENTIFIC"] = "SCIENTIFIC";
    Occupation["SEASONAL_WORKER"] = "SEASONAL_WORKER";
    Occupation["SELFEMPLOYED"] = "SELFEMPLOYED";
    Occupation["SKILLED_LABOUR"] = "SKILLED_LABOUR";
    Occupation["STUDENT"] = "STUDENT";
    Occupation["SUPERVISOR"] = "SUPERVISOR";
    Occupation["TEACHER"] = "TEACHER";
    Occupation["TECHNICIAN"] = "TECHNICIAN";
    Occupation["TRADER"] = "TRADER";
    Occupation["TRAINEE"] = "TRAINEE";
    Occupation["TRUCK_DRIVER"] = "TRUCK_DRIVER";
    Occupation["UNEMPLOYED"] = "UNEMPLOYED";
    Occupation["UNSKILLED_LABOUR"] = "UNSKILLED_LABOUR";
    Occupation["WELFARE_RECIPIENT"] = "WELFARE_RECIPIENT";
    Occupation["WORKER"] = "WORKER";
    Occupation["WORKER_AGRICULTURE"] = "WORKER_AGRICULTURE";
})(Occupation = exports.Occupation || (exports.Occupation = {}));
/**
 * Represents the type of a customer
 */
var PartnerType;
(function (PartnerType) {
    PartnerType["PRIVATE"] = "PRIVATE";
    PartnerType["ORGANIZATION"] = "ORGANIZATION";
    PartnerType["BUSINESS"] = "BUSINESS";
    PartnerType["ENTREPRENEUR"] = "ENTREPRENEUR";
    PartnerType["PARTNERSHIP"] = "PARTNERSHIP";
    PartnerType["CIVIL_PARTNERSHIP"] = "CIVIL_PARTNERSHIP";
})(PartnerType = exports.PartnerType || (exports.PartnerType = {}));
/**
 * Represents the role of a salesperson. TODO: clarify roles business meaning.
 */
var SalesPersonRole;
(function (SalesPersonRole) {
    SalesPersonRole["F_I_MANAGER"] = "F_I_MANAGER";
    SalesPersonRole["SALES_PERSON"] = "SALES_PERSON";
    SalesPersonRole["VWPFS_EMPLOYEE"] = "VWPFS_EMPLOYEE";
    SalesPersonRole["INSURER"] = "INSURER";
})(SalesPersonRole = exports.SalesPersonRole || (exports.SalesPersonRole = {}));
/**
 * Represents the salutation of a person. This is just a semantic code. For showing it to the end
 * customer you should also use mapping or localization.
 */
var Salutation;
(function (Salutation) {
    Salutation["MR"] = "MR";
    Salutation["MRS"] = "MRS";
    Salutation["MISS"] = "MISS";
    Salutation["MS"] = "MS";
})(Salutation = exports.Salutation || (exports.Salutation = {}));
/**
 * Represents the VAT which is raised on vehicle prices and costs of financial products.
 */
var TaxCode;
(function (TaxCode) {
    TaxCode["GermanVAT"] = "GermanVAT";
    TaxCode["GermanVATReduced"] = "GermanVATReduced";
    TaxCode["NoTax"] = "NoTax";
    TaxCode["NoTaxInland"] = "NoTaxInland";
    TaxCode["GermanInputVATInland15"] = "GermanInputVATInland15";
    TaxCode["GermanInputVATInlandReduced"] = "GermanInputVATInlandReduced";
    TaxCode["GermanInputVATInland16"] = "GermanInputVATInland16";
    TaxCode["GermanInputVATInland19"] = "GermanInputVATInland19";
    TaxCode["AcquisitionTaxServicesNonEU"] = "AcquisitionTaxServicesNonEU";
    TaxCode["AcquisitionTaxServicesEU"] = "AcquisitionTaxServicesEU";
    TaxCode["AcquisitionTaxGoodsEU"] = "AcquisitionTaxGoodsEU";
    TaxCode["GermanInputVATInland9Comma5"] = "GermanInputVATInland9Comma5";
    TaxCode["FranceInputVATInland19Comma6"] = "FranceInputVATInland19Comma6";
    TaxCode["FranceInputVATInland21Comma2"] = "FranceInputVATInland21Comma2";
    TaxCode["FranceInputVATInland20"] = "FranceInputVATInland20";
})(TaxCode = exports.TaxCode || (exports.TaxCode = {}));
/**
 * Represents the academic title of a person. This is just a semantic code. For showing it to the end
 * customer you should also use mapping or localization.
 */
var Title;
(function (Title) {
    Title["NONE"] = "NONE";
    Title["DR"] = "DR";
    Title["PROF"] = "PROF";
    Title["PROF_DR"] = "PROF_DR";
})(Title = exports.Title || (exports.Title = {}));
/**
 * Represents transaction status of the application for a financial product provided by VWFS.
 */
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["INITIALIZED"] = "INITIALIZED";
    TransactionStatus["CALCULATED"] = "CALCULATED";
    TransactionStatus["CALCULATION_INVALID"] = "CALCULATION_INVALID";
    TransactionStatus["OFFER_GENERATED"] = "OFFER_GENERATED";
    TransactionStatus["OFFER_ACCEPTED"] = "OFFER_ACCEPTED";
    TransactionStatus["LEGITIMATION_REFUSED"] = "LEGITIMATION_REFUSED";
    TransactionStatus["LEGITIMATION_CONDUCTED"] = "LEGITIMATION_CONDUCTED";
    TransactionStatus["LEGITIMATION_FRONTEND_CONDUCTED"] = "LEGITIMATION_FRONTEND_CONDUCTED";
    TransactionStatus["LEGITIMATION_DIGITAL_CONDUCTED"] = "LEGITIMATION_DIGITAL_CONDUCTED";
    TransactionStatus["LEGITIMATION_INVALID"] = "LEGITIMATION_INVALID";
    TransactionStatus["APPLICATION_STARTED"] = "APPLICATION_STARTED";
    TransactionStatus["MANUAL_APPLICATION_STARTED"] = "MANUAL_APPLICATION_STARTED";
    TransactionStatus["DAC_APPLICATION_STARTED"] = "DAC_APPLICATION_STARTED";
    TransactionStatus["APPLICATIONFORM_STARTED"] = "APPLICATIONFORM_STARTED";
    TransactionStatus["APPLICATIONFORM_COMPLETED"] = "APPLICATIONFORM_COMPLETED";
    TransactionStatus["DOCUMENTS_UPLOADED"] = "DOCUMENTS_UPLOADED";
    TransactionStatus["APPROVED"] = "APPROVED";
    TransactionStatus["ACCEPTED"] = "ACCEPTED";
    TransactionStatus["DECLINED"] = "DECLINED";
    TransactionStatus["ABORTED"] = "ABORTED";
    TransactionStatus["FINALLY_PAYED"] = "FINALLY_PAYED";
    TransactionStatus["COMPLETED"] = "COMPLETED";
    TransactionStatus["LEAD_SUBMITTED"] = "LEAD_SUBMITTED";
    TransactionStatus["CREDITCHECK_STARTED"] = "CREDITCHECK_STARTED";
    TransactionStatus["CREDIT_REQUESTED"] = "CREDIT_REQUESTED";
    TransactionStatus["CREDIT_PENDING"] = "CREDIT_PENDING";
    TransactionStatus["CREDIT_CHECKED"] = "CREDIT_CHECKED";
    TransactionStatus["CREDIT_REFUSED"] = "CREDIT_REFUSED";
    TransactionStatus["CREDIT_APPROVED"] = "CREDIT_APPROVED";
    TransactionStatus["CREDIT_APPROVED_OBLIGATIONS"] = "CREDIT_APPROVED_OBLIGATIONS";
    TransactionStatus["CREDIT_TO_BE_CONFIRMED"] = "CREDIT_TO_BE_CONFIRMED";
    TransactionStatus["CREDIT_INVALID"] = "CREDIT_INVALID";
    TransactionStatus["CREDIT_CUSTOMER_ACTION_REQUIRED"] = "CREDIT_CUSTOMER_ACTION_REQUIRED";
    TransactionStatus["CREDIT_OFFER_MODIFIED"] = "CREDIT_OFFER_MODIFIED";
    TransactionStatus["CREDIT_REFUSED_GUARANTOR_REQUIRED"] = "CREDIT_REFUSED_GUARANTOR_REQUIRED";
    TransactionStatus["SOFTCREDIT_APPROVED"] = "SOFTCREDIT_APPROVED";
    TransactionStatus["SOFTCREDIT_REFUSED"] = "SOFTCREDIT_REFUSED";
    TransactionStatus["CONTRACT_PRINTED"] = "CONTRACT_PRINTED";
    TransactionStatus["ESIGN_READY"] = "ESIGN_READY";
    TransactionStatus["ESIGN_STARTED"] = "ESIGN_STARTED";
    TransactionStatus["ESIGN_COMPLETED"] = "ESIGN_COMPLETED";
    TransactionStatus["ESIGN_REFUSED"] = "ESIGN_REFUSED";
    TransactionStatus["ESIGN_ABORTED"] = "ESIGN_ABORTED";
    TransactionStatus["ESIGN_FAILED"] = "ESIGN_FAILED";
    TransactionStatus["CONTRACT_CANCELLED"] = "CONTRACT_CANCELLED";
    TransactionStatus["CONTRACT_SIGNED"] = "CONTRACT_SIGNED";
    TransactionStatus["CONTRACT_CONFIRMED"] = "CONTRACT_CONFIRMED";
    TransactionStatus["CONTRACT_PENDING"] = "CONTRACT_PENDING";
    TransactionStatus["CONFIRMATION_PRINTED"] = "CONFIRMATION_PRINTED";
    TransactionStatus["CANCELED"] = "CANCELED";
    TransactionStatus["BOP_COMPLETED"] = "BOP_COMPLETED";
    TransactionStatus["APPLICATION_APPROVED"] = "APPLICATION_APPROVED";
    TransactionStatus["APPLICATION_COMPLETED"] = "APPLICATION_COMPLETED";
    TransactionStatus["APPLICATION_UNDER_REVIEW"] = "APPLICATION_UNDER_REVIEW";
    TransactionStatus["CONTRACT_INTERRUPTED"] = "CONTRACT_INTERRUPTED";
    TransactionStatus["LEGITIMATION_SUCCESSFUL_DATA_INCONSISTENT"] = "LEGITIMATION_SUCCESSFUL_DATA_INCONSISTENT";
    TransactionStatus["LEGITIMATION_SUCCESSFUL_DATA_MATCHED"] = "LEGITIMATION_SUCCESSFUL_DATA_MATCHED";
    TransactionStatus["TRANSACTION_EXPIRED"] = "TRANSACTION_EXPIRED";
    TransactionStatus["VEHICLE_INVALID"] = "VEHICLE_INVALID";
    TransactionStatus["VEHICLE_UNAVAILABLE"] = "VEHICLE_UNAVAILABLE";
    TransactionStatus["RESERVATION_FEE_OPENED"] = "RESERVATION_FEE_OPENED";
    TransactionStatus["RESERVATION_FEE_COMPLETED"] = "RESERVATION_FEE_COMPLETED";
    TransactionStatus["DEPOSIT_PAYMENT_OPENED"] = "DEPOSIT_PAYMENT_OPENED";
    TransactionStatus["DEPOSIT_PAYMENT_PENDING"] = "DEPOSIT_PAYMENT_PENDING";
    TransactionStatus["DEPOSIT_PAYMENT_DECLINED"] = "DEPOSIT_PAYMENT_DECLINED";
    TransactionStatus["DEPOSIT_PAYMENT_COMPLETED"] = "DEPOSIT_PAYMENT_COMPLETED";
    TransactionStatus["TIMER_EXPIRED"] = "TIMER_EXPIRED";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
/**
 * Represents the type of business.
 */
var TypeOfBusiness;
(function (TypeOfBusiness) {
    TypeOfBusiness["FINANCE"] = "FINANCE";
    TypeOfBusiness["LEASING"] = "LEASING";
    TypeOfBusiness["CASH"] = "CASH";
})(TypeOfBusiness = exports.TypeOfBusiness || (exports.TypeOfBusiness = {}));
/**
 * Represents the type of vehicle.
 */
var VehicleClass;
(function (VehicleClass) {
    VehicleClass["COMMERCIAL"] = "COMMERCIAL";
    VehicleClass["PASSENGER"] = "PASSENGER";
})(VehicleClass = exports.VehicleClass || (exports.VehicleClass = {}));
/**
 * Represents the data source from which the vehicle data where originally fetched from.
 */
var VehicleDataSource;
(function (VehicleDataSource) {
    VehicleDataSource["MANUAL_INPUT"] = "MANUAL_INPUT";
    VehicleDataSource["MBV"] = "MBV";
    VehicleDataSource["JATO"] = "JATO";
    VehicleDataSource["EUROBASE"] = "EUROBASE";
})(VehicleDataSource = exports.VehicleDataSource || (exports.VehicleDataSource = {}));
/**
 * Represents the method of estimating the market value of a vehicle. TODO: provide short descriptions
 * of the systems as a more detailed description.
 */
var VehicleMarketValueSystem;
(function (VehicleMarketValueSystem) {
    VehicleMarketValueSystem["DAT"] = "DAT";
    VehicleMarketValueSystem["MANUAL"] = "MANUAL";
    VehicleMarketValueSystem["RESIDUAL"] = "RESIDUAL";
})(VehicleMarketValueSystem = exports.VehicleMarketValueSystem || (exports.VehicleMarketValueSystem = {}));
/**
 * Represents the body type of a vehicle.
 */
var VehicleModelBodyType;
(function (VehicleModelBodyType) {
    VehicleModelBodyType["SEDAN"] = "SEDAN";
    VehicleModelBodyType["HATCHB"] = "HATCHB";
    VehicleModelBodyType["COUPE"] = "COUPE";
    VehicleModelBodyType["CABRIO"] = "CABRIO";
    VehicleModelBodyType["HARDT"] = "HARDT";
    VehicleModelBodyType["SOFTTOP"] = "SOFTTOP";
    VehicleModelBodyType["TARGA"] = "TARGA";
    VehicleModelBodyType["LIFTB"] = "LIFTB";
    VehicleModelBodyType["COMBI"] = "COMBI";
    VehicleModelBodyType["VAN"] = "VAN";
    VehicleModelBodyType["BESTEL"] = "BESTEL";
    VehicleModelBodyType["BUS"] = "BUS";
    VehicleModelBodyType["PICKUP"] = "PICKUP";
    VehicleModelBodyType["CHCAB"] = "CHCAB";
    VehicleModelBodyType["CHASSIS"] = "CHASSIS";
    VehicleModelBodyType["MPV"] = "MPV";
    VehicleModelBodyType["SUV"] = "SUV";
    VehicleModelBodyType["OVERIGE"] = "OVERIGE";
})(VehicleModelBodyType = exports.VehicleModelBodyType || (exports.VehicleModelBodyType = {}));
/**
 * Represents the type of vehicle model code. This affects the format of `VehicleModel.code`.
 */
var VehicleModelCodeType;
(function (VehicleModelCodeType) {
    VehicleModelCodeType["MBV"] = "MBV";
    VehicleModelCodeType["MANECK"] = "MANECK";
    VehicleModelCodeType["MBT"] = "MBT";
    VehicleModelCodeType["KBA"] = "KBA";
    VehicleModelCodeType["KUBA"] = "KUBA";
    VehicleModelCodeType["ATLAS"] = "ATLAS";
})(VehicleModelCodeType = exports.VehicleModelCodeType || (exports.VehicleModelCodeType = {}));
/**
 * Represents the drive type of a vehicle model.
 */
var VehicleModelDriveType;
(function (VehicleModelDriveType) {
    VehicleModelDriveType["FRONT"] = "FRONT";
    VehicleModelDriveType["REAR"] = "REAR";
    VehicleModelDriveType["ALL_WHEEL"] = "ALL_WHEEL";
    VehicleModelDriveType["FOUR_BY_FOUR"] = "FOUR_BY_FOUR";
})(VehicleModelDriveType = exports.VehicleModelDriveType || (exports.VehicleModelDriveType = {}));
/**
 * Represents how a vehicle is being used at a certain point in time.
 */
var VehicleUsage;
(function (VehicleUsage) {
    VehicleUsage["None"] = "None";
    VehicleUsage["DemonstrationCar"] = "DemonstrationCar";
    VehicleUsage["PlantCompanyCar"] = "PlantCompanyCar";
    VehicleUsage["CompanyCar"] = "CompanyCar";
    VehicleUsage["RentalCar"] = "RentalCar";
    VehicleUsage["OneYearOldCar"] = "OneYearOldCar";
    VehicleUsage["ExternalDealerDemonstrationCar"] = "ExternalDealerDemonstrationCar";
    VehicleUsage["DrivingSchoolCar"] = "DrivingSchoolCar";
    VehicleUsage["Taxi"] = "Taxi";
    VehicleUsage["MajorCustomerTestCar"] = "MajorCustomerTestCar";
    VehicleUsage["PersonEmployeeVWGroupLeasing"] = "PersonEmployeeVWGroupLeasing";
    VehicleUsage["OneDayOldCar"] = "OneDayOldCar";
    VehicleUsage["PromotionCar"] = "PromotionCar";
    VehicleUsage["Euromobil"] = "Euromobil";
})(VehicleUsage = exports.VehicleUsage || (exports.VehicleUsage = {}));
/**
 * Represents a VWFS Entry Point, software name, who calling this API.
 */
var EntryPoint;
(function (EntryPoint) {
    EntryPoint["EVA"] = "eva";
    EntryPoint["THUNDER"] = "thunder";
    EntryPoint["WECONNECTGO"] = "weconnectgo";
    EntryPoint["CSBR"] = "csbr";
    EntryPoint["STANDALONE"] = "standalone";
    EntryPoint["BRANDSTOREFRONT"] = "brandstorefront";
    EntryPoint["HEYCAR"] = "heycar";
    EntryPoint["LCV"] = "lcv";
    EntryPoint["ONESHOP"] = "oneshop";
    /**
     * Drive refers to contract hire UK journey where user finances a vehicle and can use it without
     * necessity to own it.
     */
    EntryPoint["DRIVE"] = "drive";
    /**
     * Customer to customer application of VWFS.
     */
    EntryPoint["C2C"] = "c2c";
    EntryPoint["ISA"] = "isa";
    EntryPoint["FSM"] = "fsm";
    EntryPoint["MYAUDI"] = "myaudi";
    EntryPoint["AFTERSALES"] = "aftersales";
    /**
     * Used by VWFS Digital Unit Berlin
     */
    EntryPoint["INTERNALLEGITIMATION"] = "internallegitimation";
    EntryPoint["VENDOR"] = "vendor";
    EntryPoint["CUSTOMERPORTAL"] = "customerportal";
    EntryPoint["SUBSCRIPTION"] = "subscription";
})(EntryPoint = exports.EntryPoint || (exports.EntryPoint = {}));
/**
 * Represents the customers employment contract type.
 */
var EmploymentContractType;
(function (EmploymentContractType) {
    EmploymentContractType["APPRENTICE"] = "APPRENTICE";
    EmploymentContractType["FIXED"] = "FIXED";
    EmploymentContractType["NO_CONTRACT"] = "NO_CONTRACT";
    EmploymentContractType["ATYPICAL"] = "ATYPICAL";
    EmploymentContractType["PERMANENT"] = "PERMANENT";
    EmploymentContractType["PERMANENT_ON_TRIAL"] = "PERMANENT_ON_TRIAL";
    EmploymentContractType["SEASONAL"] = "SEASONAL";
    EmploymentContractType["TEMPORARY"] = "TEMPORARY";
    EmploymentContractType["WITHIN_NOTICE_PERIOD"] = "WITHIN_NOTICE_PERIOD";
})(EmploymentContractType = exports.EmploymentContractType || (exports.EmploymentContractType = {}));
/**
 * Different options on how the car will be secured and locked.
 */
var CarSecurityVariant;
(function (CarSecurityVariant) {
    CarSecurityVariant["MECHANICAL"] = "MECHANICAL";
    CarSecurityVariant["AUTOMATIC"] = "AUTOMATIC";
    CarSecurityVariant["BOTH"] = "BOTH";
    CarSecurityVariant["NONE"] = "NONE";
})(CarSecurityVariant = exports.CarSecurityVariant || (exports.CarSecurityVariant = {}));
/**
 * Definition of where the customer can pick up the car.
 */
var PickupLocation;
(function (PickupLocation) {
    PickupLocation["DEALERSHOP"] = "DEALERSHOP";
    PickupLocation["FACTORY"] = "FACTORY";
    PickupLocation["CUSTOMERADDRESS"] = "CUSTOMERADDRESS";
    PickupLocation["OTHERADDRESS"] = "OTHERADDRESS";
})(PickupLocation = exports.PickupLocation || (exports.PickupLocation = {}));
/**
 * Education levels enumeration.
 */
var EducationLevel;
(function (EducationLevel) {
    EducationLevel["NONE"] = "NONE";
    EducationLevel["PRIMARY_SCHOOL"] = "PRIMARY_SCHOOL";
    EducationLevel["MIDDLE_SCHOOL"] = "MIDDLE_SCHOOL";
    EducationLevel["HIGH_SCHOOL"] = "HIGH_SCHOOL";
    EducationLevel["SECONDARY_SCHOOL"] = "SECONDARY_SCHOOL";
    EducationLevel["UNIVERSITY"] = "UNIVERSITY";
    EducationLevel["APPRENTICESHIP"] = "APPRENTICESHIP";
})(EducationLevel = exports.EducationLevel || (exports.EducationLevel = {}));
/**
 * Accounting type used in the company.
 */
var AccountingType;
(function (AccountingType) {
    AccountingType["TAX_BALANCE_SHEET"] = "TAX_BALANCE_SHEET";
    AccountingType["DOUBLE_ENTRY_BOOKKEEPING"] = "DOUBLE_ENTRY_BOOKKEEPING";
})(AccountingType = exports.AccountingType || (exports.AccountingType = {}));
/**
 * The paint type of the colorExterior
 */
var ColorExteriorType;
(function (ColorExteriorType) {
    ColorExteriorType["METALLIC"] = "METALLIC";
    ColorExteriorType["NON_METALLIC"] = "NON_METALLIC";
})(ColorExteriorType = exports.ColorExteriorType || (exports.ColorExteriorType = {}));
/**
 * Location where the transaction is being completed.
 */
var SalesChannelType;
(function (SalesChannelType) {
    /**
     * Point Of Sale, at the dealer
     */
    SalesChannelType["POINTOFSALE"] = "pointofsale";
    /**
     * Online, at the client
     */
    SalesChannelType["ONLINE"] = "online";
})(SalesChannelType = exports.SalesChannelType || (exports.SalesChannelType = {}));
/**
 * Insurance broker status of the sales person.
 */
var BrokerStatus;
(function (BrokerStatus) {
    /**
     * Sales person is not an insurance broker
     */
    BrokerStatus["NONE"] = "NONE";
    /**
     * Sales person is a fully licensed insurance broker
     */
    BrokerStatus["FULL"] = "FULL";
})(BrokerStatus = exports.BrokerStatus || (exports.BrokerStatus = {}));
/**
 * Indicates the type of an identity document.
 */
var IdentityDocumentType;
(function (IdentityDocumentType) {
    IdentityDocumentType["ID_CARD"] = "ID_CARD";
    IdentityDocumentType["PASSPORT"] = "PASSPORT";
    IdentityDocumentType["DRIVER_LICENSE"] = "DRIVER_LICENSE";
    IdentityDocumentType["PERMANENT_RESIDENCE_CARD"] = "PERMANENT_RESIDENCE_CARD";
    IdentityDocumentType["TEMPORARY_RESIDENCE_CARD"] = "TEMPORARY_RESIDENCE_CARD";
    IdentityDocumentType["FOREIGN_ID_CARD"] = "FOREIGN_ID_CARD";
})(IdentityDocumentType = exports.IdentityDocumentType || (exports.IdentityDocumentType = {}));
/**
 * The type of the vehicle accessory.
 */
var AccessoryType;
(function (AccessoryType) {
    AccessoryType["EXTERIOR"] = "EXTERIOR";
    AccessoryType["OTHER"] = "OTHER";
})(AccessoryType = exports.AccessoryType || (exports.AccessoryType = {}));
/**
 * The type of the vehicle equipment.
 */
var EquipmentType;
(function (EquipmentType) {
    EquipmentType["STANDARD"] = "STANDARD";
    EquipmentType["EXTRA"] = "EXTRA";
})(EquipmentType = exports.EquipmentType || (exports.EquipmentType = {}));
/**
 * The particle emission sticker indicates the amount of air pollution caused by a vehicle. Green is
 * "good", red is "bad" and may lead to a vehicle being banned from environmental zones where, e.g.,
 * only vehicles with Green stickers are allowed.
 */
var ParticleEmissionSticker;
(function (ParticleEmissionSticker) {
    ParticleEmissionSticker["GREEN"] = "GREEN";
    ParticleEmissionSticker["YELLOW"] = "YELLOW";
    ParticleEmissionSticker["RED"] = "RED";
    ParticleEmissionSticker["NONE"] = "NONE";
})(ParticleEmissionSticker = exports.ParticleEmissionSticker || (exports.ParticleEmissionSticker = {}));
/**
 * Represents the efficiency class.
 */
var EfficiencyClass;
(function (EfficiencyClass) {
    EfficiencyClass["A_PLUS"] = "A+";
    EfficiencyClass["A"] = "A";
    EfficiencyClass["B"] = "B";
    EfficiencyClass["C"] = "C";
    EfficiencyClass["D"] = "D";
    EfficiencyClass["E"] = "E";
    EfficiencyClass["F"] = "F";
    EfficiencyClass["G"] = "G";
})(EfficiencyClass = exports.EfficiencyClass || (exports.EfficiencyClass = {}));
/**
 * Indicates the test procedure applied to derive emission and consumption values of the vehicle. Note
 * that the former NEDC (German: NEFZ) is being replaced by the more recent WLTP method.
 */
var TestProcedureType;
(function (TestProcedureType) {
    TestProcedureType["NEDC"] = "NEDC";
    TestProcedureType["WLTP"] = "WLTP";
})(TestProcedureType = exports.TestProcedureType || (exports.TestProcedureType = {}));
/**
 * Represents the perspective/angle under which the vehicle is shown on the image.
 */
var VehicleView;
(function (VehicleView) {
    VehicleView["EXTERIOR_FRONT_RIGHT"] = "EXTERIOR_FRONT_RIGHT";
    VehicleView["EXTERIOR_SIDE_RIGHT"] = "EXTERIOR_SIDE_RIGHT";
    VehicleView["EXTERIOR_BACK_RIGHT"] = "EXTERIOR_BACK_RIGHT";
    VehicleView["EXTERIOR_BACK_LEFT"] = "EXTERIOR_BACK_LEFT";
    VehicleView["EXTERIOR_SIDE_LEFT"] = "EXTERIOR_SIDE_LEFT";
    VehicleView["EXTERIOR_FRONT_LEFT"] = "EXTERIOR_FRONT_LEFT";
    VehicleView["EXTERIOR_FRONT_CENTER"] = "EXTERIOR_FRONT_CENTER";
    VehicleView["EXTERIOR_BACK_CENTER"] = "EXTERIOR_BACK_CENTER";
    VehicleView["INTERIOR_CENTER"] = "INTERIOR_CENTER";
    VehicleView["INTERIOR_SEAT"] = "INTERIOR_SEAT";
    VehicleView["INTERIOR_SIDE"] = "INTERIOR_SIDE";
    VehicleView["EXTERIOR_WHEEL"] = "EXTERIOR_WHEEL";
    VehicleView["UNKNOWN"] = "UNKNOWN";
})(VehicleView = exports.VehicleView || (exports.VehicleView = {}));
/**
 * Indicates the unit of the respective value.
 */
var UnitType;
(function (UnitType) {
    UnitType["CCM"] = "ccm";
    UnitType["GRAMS_PER_KM"] = "g/km";
    UnitType["HORSEPOWER"] = "HORSEPOWER";
    UnitType["KILOGRAMS_PER_100KM"] = "kg/100km";
    UnitType["KILOMETER"] = "km";
    UnitType["KILOWATT"] = "KILOWATT";
    UnitType["KWH_PER_100KM"] = "kWh/100km";
    UnitType["LITER"] = "l";
    UnitType["LITERS_PER_100KM"] = "l/100km";
    UnitType["MILE"] = "mi";
    UnitType["MILLIMETER"] = "mm";
    UnitType["SECOND"] = "s";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
/**
 * The specific unit for a certain amount.
 */
var SpecificUnit;
(function (SpecificUnit) {
    SpecificUnit["ONE_PER_LITER"] = "1/liter";
    SpecificUnit["ONE_PER_YEAR"] = "1/year";
    SpecificUnit["CENT_PER_KILOMETER"] = "cent/km";
    SpecificUnit["ONE_PER_KILOWATT"] = "1/kWh";
    SpecificUnit["ONE_PER_KILOGRAM"] = "1/kilogram";
    SpecificUnit["ONE_PER_KILOMETER"] = "1/km";
    SpecificUnit["CENT_PER_KILOGRAM"] = "cent/kilogram";
    SpecificUnit["CENT_PER_KILOWATT"] = "cent/kWh";
    SpecificUnit["CENT_PER_LITER"] = "cent/liter";
})(SpecificUnit = exports.SpecificUnit || (exports.SpecificUnit = {}));
/**
 * The legal form of an entity which may be an individual, company, or organization that has legal
 * rights and obligations.
 */
var EntityLegalForm;
(function (EntityLegalForm) {
    EntityLegalForm["AKTIENGESELLSCHAFT"] = "Aktiengesellschaft";
    EntityLegalForm["AKTIENGESELLSCHAFT_UND_CO_KG"] = "Aktiengesellschaft & Co. KG";
    EntityLegalForm["ANSTALT_DES_OEFFENTLICHEN_RECHTS"] = "Anstalt des oeffentlichen Rechts";
    EntityLegalForm["BGB_GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG"] = "BGB-Gesellschaft mit beschraenkter Haftung";
    EntityLegalForm["EINGETRAGENE_GENOSSENSCHAFT"] = "Eingetragene Genossenschaft";
    EntityLegalForm["EINGETRAGENER_KAUFMANN"] = "Eingetragener Kaufmann";
    EntityLegalForm["EINGETRAGENER_VEREIN"] = "Eingetragener Verein";
    EntityLegalForm["EINZELUNTERNEHMEN"] = "Einzelunternehmen";
    EntityLegalForm["EUROPAEISCHE_WIRTSCHAFTLICHE_INTERESSENVEREINIGUNG"] = "Europaeische wirtschaftliche Interessenvereinigung";
    EntityLegalForm["EUROPAEISCHE_AKTIENGESELLSCHAFT"] = "Europaeische Aktiengesellschaft";
    EntityLegalForm["EUROPAEISCHE_GENOSSENSCHAFT"] = "Europaeische Genossenschaft";
    EntityLegalForm["FREIBERUFLER"] = "Freiberufler";
    EntityLegalForm["GEMEINNUETZIGE_AKTIENGESELLSCHAFT"] = "Gemeinnuetzige Aktiengesellschaft";
    EntityLegalForm["GEMEINNUETZIGE_GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG"] = "Gemeinnuetzige GmbH";
    EntityLegalForm["GEMEINNUETZIGE_GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG_EINMANN"] = "Gemeinnuetzige GmbH (Einmann)";
    EntityLegalForm["GEMEINNUETZIGE_STIFTUNG"] = "Gemeinnuetzige Stiftung";
    EntityLegalForm["GESELLSCHAFT_BUERGERLICHEN_RECHTS"] = "Gesellschaft buergerlichen Rechts";
    EntityLegalForm["GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG"] = "Gesellschaft mit beschraenkter Haftung (GmbH)";
    EntityLegalForm["GEWERBEBETRIEB"] = "Gewerbebetrieb";
    EntityLegalForm["GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG_UND_CO_KG"] = "GmbH & Co. KG";
    EntityLegalForm["GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG_UND_CO_KG_AUF_AKTIEN"] = "GmbH & Co. KG auf AKtien";
    EntityLegalForm["GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG_UND_CO_OHG"] = "GmbH & Co. OHG";
    EntityLegalForm["GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG_EINMANN"] = "GmbH (Einmann)";
    EntityLegalForm["GESELLSCHAFT_MIT_BESCHRAENKTER_HAFTUNG_IN_GRUENDUNG"] = "GmbH in Gruendung";
    EntityLegalForm["INVESTMENT_AKTIENGESELLSCHAFT"] = "Investment-Aktiengesellschaft";
    EntityLegalForm["KLEINE_AKTIENGESELLSCHAFT"] = "Kleine Aktiengesellschaft";
    EntityLegalForm["KOMMANDITGESELLSCHAFT"] = "Kommanditgesellschaft";
    EntityLegalForm["KOMMANDITGESELLSCHAFT_AUF_AKTIEN"] = "Kommanditgesellschaft auf Aktien";
    EntityLegalForm["KOERPERSCHAFT_DES_OEFFENTLICHEN_RECHTS"] = "Koerperschaft des oeffentlichen Rechts";
    EntityLegalForm["LANDESINNUNGSVERBAND"] = "Landesinnungsverband";
    EntityLegalForm["LIMITED"] = "Limited";
    EntityLegalForm["LIMITED_UND_CO_KG"] = "Limited & Co. KG";
    EntityLegalForm["NICHT_EINGETRAGENER_VEREIN"] = "Nicht eingetragener Verein";
    EntityLegalForm["OFFENE_HANDELSGESELLSCHAFT"] = "Offene Handelsgesellschaft";
    EntityLegalForm["PARTENREEDEREI"] = "Partenreederei";
    EntityLegalForm["PARTNERGESELLSCHAFT"] = "Partnergesellschaft";
    EntityLegalForm["PARTNERGESELLSCHAFT_MIT_BESCHRAENKTER_BERUFSHAFTUNG"] = "Partnergesellschaft mit beschraenkter Berufshaftung";
    EntityLegalForm["REIT_AKTIENGESELLSCHAFT"] = "REIT-Aktiengesellschaft";
    EntityLegalForm["OTHER"] = "Sonstiges";
    EntityLegalForm["STADT_LAENDER_GEMEINDEN"] = "Stadt/Laender/Gemeinden";
    EntityLegalForm["STIFTUNG_UND_CO_KG"] = "Stiftung & Co. KG";
    EntityLegalForm["STIFTUNG_DES_OEFFENTLICHEN_RECHTS"] = "Stiftung des privaten Rechts";
    EntityLegalForm["STIFTUNG_DES_PRIVATEN_RECHTS"] = "Stiftung des privaten Rechts";
    EntityLegalForm["STILLE_GESELLSCHAFT"] = "Stille Gesellschaft";
    EntityLegalForm["UNTERNEHMERGESELLSCHAFT"] = "Unternehmergesellschaft";
    EntityLegalForm["UNTERNEHMERGESELLSCHAFT_UND_CO_KG_HAFTUNGSBESCHRAENKT"] = "Unternehmergesellschaft (haftungsbeschraenkt) & Co. KG";
    EntityLegalForm["VEREIN_ALTEN_RECHTS"] = "Verein alten Rechts";
    EntityLegalForm["VERSICHERUNGSVEREIN_AUF_GEGENSEITIGKEIT"] = "Versicherungsverein auf Gegenseitigkeit";
    EntityLegalForm["WIRTSCHAFTLICHER_VEREIN"] = "Wirtschaftlicher Verein";
    EntityLegalForm["ZWECKVERBAND"] = "Zweckverband";
})(EntityLegalForm = exports.EntityLegalForm || (exports.EntityLegalForm = {}));
/**
 * Possible status of a contract
 */
var ContractStatus;
(function (ContractStatus) {
    /**
     * Non-binding offer
     */
    ContractStatus["OFFER"] = "OFFER";
    /**
     * Application has not yet been signed
     */
    ContractStatus["APPLICATION_UNSIGNED"] = "APPLICATION_UNSIGNED";
    /**
     * Signed application
     */
    ContractStatus["APPLICATION"] = "APPLICATION";
    /**
     * Binding / finished contract
     */
    ContractStatus["CONTRACT"] = "CONTRACT";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
/**
 * Signature method used when signing the contract / document
 */
var SignatureType;
(function (SignatureType) {
    /**
     * Signature with ink on paper
     */
    SignatureType["PHYSICAL_SIGNATURE"] = "PHYSICAL_SIGNATURE";
    /**
     * Qualified electronic signature, e.g. with Verimi or IDnow
     */
    SignatureType["QUALIFIED_ELECTRONIC_SIGNATURE"] = "QUALIFIED_ELECTRONIC_SIGNATURE";
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
var DocumentCategory;
(function (DocumentCategory) {
    DocumentCategory["FOOTER"] = "FOOTER";
    DocumentCategory["FAQ"] = "FAQ";
    DocumentCategory["COOKIE_POLICY"] = "COOKIE_POLICY";
    DocumentCategory["SALESPERSON_DEALER"] = "SALESPERSON_DEALER";
    DocumentCategory["VARIANT_DOC"] = "VARIANT_DOC";
    DocumentCategory["POLICY_DOC"] = "POLICY_DOC";
    DocumentCategory["INFORMATION_CLAUSE"] = "INFORMATION_CLAUSE";
    DocumentCategory["OTHER"] = "OTHER";
})(DocumentCategory = exports.DocumentCategory || (exports.DocumentCategory = {}));
var DocumentFormat;
(function (DocumentFormat) {
    DocumentFormat["PDF"] = "pdf";
})(DocumentFormat = exports.DocumentFormat || (exports.DocumentFormat = {}));
/**
 * Predefined list of additional products that can be used as a common reference across different
 * systems using deviating names.
 */
var AdditionalProductList;
(function (AdditionalProductList) {
    AdditionalProductList["CREDIT_PROTECTION_INSURANCE"] = "CREDIT_PROTECTION_INSURANCE";
    AdditionalProductList["LEASING_PROTECTION_INSURANCE"] = "LEASING_PROTECTION_INSURANCE";
    AdditionalProductList["LEASING_PROTECTION_INSURANCE_MOBILITY"] = "LEASING_PROTECTION_INSURANCE_MOBILITY";
    AdditionalProductList["LEASING_PROTECTION_INSURANCE_PLUS"] = "LEASING_PROTECTION_INSURANCE_PLUS";
    AdditionalProductList["LEASING_PROTECTION_INSURANCE_PLUS_MOBILITY"] = "LEASING_PROTECTION_INSURANCE_PLUS_MOBILITY";
    AdditionalProductList["VEHICLE_DELIVERY"] = "VEHICLE_DELIVERY";
    AdditionalProductList["VEHICLE_TITLE"] = "VEHICLE_TITLE";
})(AdditionalProductList = exports.AdditionalProductList || (exports.AdditionalProductList = {}));
/**
 * Describes the level of maturity of a customer journey: M1 lead generation, M2 binding credit-check
 * and M3 end to end online contract closer.
 */
var MaturityLevel;
(function (MaturityLevel) {
    MaturityLevel["LEAD_GENERATION"] = "Lead Generation";
    MaturityLevel["BINDING_CREDIT_CHECK"] = "Binding Credit Check";
    MaturityLevel["END_TO_END_ONLINE_CONTRACT_CLOSED"] = "End-to-End Online Contract Closed";
})(MaturityLevel = exports.MaturityLevel || (exports.MaturityLevel = {}));
/**
 * Extended warranty es salutation.
 */
var ExtendedWarrantyEsSalutation;
(function (ExtendedWarrantyEsSalutation) {
    ExtendedWarrantyEsSalutation["MR"] = "MR";
    ExtendedWarrantyEsSalutation["MRS"] = "MRS";
    ExtendedWarrantyEsSalutation["COMPANY"] = "COMPANY";
})(ExtendedWarrantyEsSalutation = exports.ExtendedWarrantyEsSalutation || (exports.ExtendedWarrantyEsSalutation = {}));
/**
 * Represents a car manufacturer (brand) of a vehicle model. This is different from the VWFS sales brand
 * in the Brand enum.
 */
var ServiceinspectionIeManufacturer;
(function (ServiceinspectionIeManufacturer) {
    ServiceinspectionIeManufacturer["Volkswagen"] = "Volkswagen";
    ServiceinspectionIeManufacturer["VolkswagenCommercialVehicles"] = "Volkswagen Commercial Vehicles";
    ServiceinspectionIeManufacturer["Audi"] = "Audi";
    ServiceinspectionIeManufacturer["SEAT"] = "SEAT";
    ServiceinspectionIeManufacturer["Skoda"] = "Skoda";
})(ServiceinspectionIeManufacturer = exports.ServiceinspectionIeManufacturer || (exports.ServiceinspectionIeManufacturer = {}));
/**
 * Represents the salutation of a person. This is just a semantic code. For showing it to the end
 * customer you should also use mapping or localization.
 */
var ServiceinspectionIeSalutation;
(function (ServiceinspectionIeSalutation) {
    ServiceinspectionIeSalutation["MR"] = "MR";
    ServiceinspectionIeSalutation["MRS"] = "MRS";
    ServiceinspectionIeSalutation["MS"] = "MS";
    ServiceinspectionIeSalutation["DR"] = "DR";
})(ServiceinspectionIeSalutation = exports.ServiceinspectionIeSalutation || (exports.ServiceinspectionIeSalutation = {}));
/**
 * Defines whether a new contract is generated or someone takes over an existing contract
 */
var ClassiccreditNlContractType;
(function (ClassiccreditNlContractType) {
    ClassiccreditNlContractType["NEW"] = "new";
    ClassiccreditNlContractType["TAKEOVER"] = "takeover";
})(ClassiccreditNlContractType = exports.ClassiccreditNlContractType || (exports.ClassiccreditNlContractType = {}));
var ClassiccreditNlVehicleModelManufacturer;
(function (ClassiccreditNlVehicleModelManufacturer) {
    ClassiccreditNlVehicleModelManufacturer["Abarth"] = "Abarth";
    ClassiccreditNlVehicleModelManufacturer["Acura"] = "Acura";
    ClassiccreditNlVehicleModelManufacturer["AlfaRomeo"] = "Alfa Romeo";
    ClassiccreditNlVehicleModelManufacturer["Alpine"] = "Alpine";
    ClassiccreditNlVehicleModelManufacturer["AstonMartin"] = "Aston Martin";
    ClassiccreditNlVehicleModelManufacturer["Audi"] = "Audi";
    ClassiccreditNlVehicleModelManufacturer["Bentley"] = "Bentley";
    ClassiccreditNlVehicleModelManufacturer["BMW"] = "BMW";
    ClassiccreditNlVehicleModelManufacturer["Bugatti"] = "Bugatti";
    ClassiccreditNlVehicleModelManufacturer["Cadillac"] = "Cadillac";
    ClassiccreditNlVehicleModelManufacturer["ChevroletUSA"] = "Chevrolet USA";
    ClassiccreditNlVehicleModelManufacturer["Chrysler"] = "Chrysler";
    ClassiccreditNlVehicleModelManufacturer["Citroen"] = "Citro\u00EBn";
    ClassiccreditNlVehicleModelManufacturer["CUPRA"] = "CUPRA";
    ClassiccreditNlVehicleModelManufacturer["Dacia"] = "Dacia";
    ClassiccreditNlVehicleModelManufacturer["Daewoo"] = "Daewoo";
    ClassiccreditNlVehicleModelManufacturer["Daf"] = "Daf";
    ClassiccreditNlVehicleModelManufacturer["Daihatsu"] = "Daihatsu";
    ClassiccreditNlVehicleModelManufacturer["DFSK"] = "DFSK";
    ClassiccreditNlVehicleModelManufacturer["Dodge"] = "Dodge";
    ClassiccreditNlVehicleModelManufacturer["Donkervoort"] = "Donkervoort";
    ClassiccreditNlVehicleModelManufacturer["DS"] = "DS";
    ClassiccreditNlVehicleModelManufacturer["Ducati"] = "Ducati";
    ClassiccreditNlVehicleModelManufacturer["Ferrari"] = "Ferrari";
    ClassiccreditNlVehicleModelManufacturer["Fiat"] = "Fiat";
    ClassiccreditNlVehicleModelManufacturer["Ford"] = "Ford";
    ClassiccreditNlVehicleModelManufacturer["FUSO"] = "FUSO";
    ClassiccreditNlVehicleModelManufacturer["Gaz"] = "Gaz";
    ClassiccreditNlVehicleModelManufacturer["Gazelle"] = "Gazelle";
    ClassiccreditNlVehicleModelManufacturer["Gmc"] = "Gmc";
    ClassiccreditNlVehicleModelManufacturer["HarleyDavidson"] = "Harley-Davidson";
    ClassiccreditNlVehicleModelManufacturer["Honda"] = "Honda";
    ClassiccreditNlVehicleModelManufacturer["Hummer"] = "Hummer";
    ClassiccreditNlVehicleModelManufacturer["Hyundai"] = "Hyundai";
    ClassiccreditNlVehicleModelManufacturer["Infiniti"] = "Infiniti";
    ClassiccreditNlVehicleModelManufacturer["Irizar"] = "Irizar";
    ClassiccreditNlVehicleModelManufacturer["Isuzu"] = "Isuzu";
    ClassiccreditNlVehicleModelManufacturer["Iveco"] = "Iveco";
    ClassiccreditNlVehicleModelManufacturer["Jaguar"] = "Jaguar";
    ClassiccreditNlVehicleModelManufacturer["Jeep"] = "Jeep";
    ClassiccreditNlVehicleModelManufacturer["Jmc"] = "Jmc";
    ClassiccreditNlVehicleModelManufacturer["Kamaz"] = "Kamaz";
    ClassiccreditNlVehicleModelManufacturer["Kawasaki"] = "Kawasaki";
    ClassiccreditNlVehicleModelManufacturer["Kia"] = "Kia";
    ClassiccreditNlVehicleModelManufacturer["Ktm"] = "Ktm";
    ClassiccreditNlVehicleModelManufacturer["Lada"] = "Lada";
    ClassiccreditNlVehicleModelManufacturer["Lamborghini"] = "Lamborghini";
    ClassiccreditNlVehicleModelManufacturer["Lancia"] = "Lancia";
    ClassiccreditNlVehicleModelManufacturer["LandRover"] = "Land Rover";
    ClassiccreditNlVehicleModelManufacturer["Lexus"] = "Lexus";
    ClassiccreditNlVehicleModelManufacturer["Lincoln"] = "Lincoln";
    ClassiccreditNlVehicleModelManufacturer["Lotus"] = "Lotus";
    ClassiccreditNlVehicleModelManufacturer["MAN"] = "MAN";
    ClassiccreditNlVehicleModelManufacturer["Maserati"] = "Maserati";
    ClassiccreditNlVehicleModelManufacturer["Mazda"] = "Mazda";
    ClassiccreditNlVehicleModelManufacturer["McLaren"] = "McLaren";
    ClassiccreditNlVehicleModelManufacturer["MercedesBenz"] = "Mercedes-Benz";
    ClassiccreditNlVehicleModelManufacturer["Mini"] = "MINI";
    ClassiccreditNlVehicleModelManufacturer["Mitsubishi"] = "Mitsubishi";
    ClassiccreditNlVehicleModelManufacturer["Morgan"] = "Morgan";
    ClassiccreditNlVehicleModelManufacturer["Nissan"] = "Nissan";
    ClassiccreditNlVehicleModelManufacturer["Opel"] = "Opel";
    ClassiccreditNlVehicleModelManufacturer["Peugeot"] = "Peugeot";
    ClassiccreditNlVehicleModelManufacturer["Pgo"] = "Pgo";
    ClassiccreditNlVehicleModelManufacturer["Piaggio"] = "Piaggio";
    ClassiccreditNlVehicleModelManufacturer["Polaris"] = "Polaris";
    ClassiccreditNlVehicleModelManufacturer["Pontiac"] = "Pontiac";
    ClassiccreditNlVehicleModelManufacturer["Porsche"] = "Porsche";
    ClassiccreditNlVehicleModelManufacturer["Ram"] = "Ram";
    ClassiccreditNlVehicleModelManufacturer["Renault"] = "Renault";
    ClassiccreditNlVehicleModelManufacturer["RollsRoyce"] = "Rolls-Royce";
    ClassiccreditNlVehicleModelManufacturer["Saab"] = "Saab";
    ClassiccreditNlVehicleModelManufacturer["SAIC"] = "SAIC";
    ClassiccreditNlVehicleModelManufacturer["Scania"] = "Scania";
    ClassiccreditNlVehicleModelManufacturer["SEAT"] = "SEAT";
    ClassiccreditNlVehicleModelManufacturer["Setra"] = "Setra";
    ClassiccreditNlVehicleModelManufacturer["Skoda"] = "\u0160KODA";
    ClassiccreditNlVehicleModelManufacturer["smart"] = "Smart";
    ClassiccreditNlVehicleModelManufacturer["SsangYong"] = "SsangYong";
    ClassiccreditNlVehicleModelManufacturer["StreetScooter"] = "StreetScooter";
    ClassiccreditNlVehicleModelManufacturer["Subaru"] = "Subaru";
    ClassiccreditNlVehicleModelManufacturer["Suzuki"] = "Suzuki";
    ClassiccreditNlVehicleModelManufacturer["Tata"] = "Tata";
    ClassiccreditNlVehicleModelManufacturer["Tesla"] = "Tesla";
    ClassiccreditNlVehicleModelManufacturer["Toyota"] = "Toyota";
    ClassiccreditNlVehicleModelManufacturer["Volkswagen"] = "Volkswagen";
    ClassiccreditNlVehicleModelManufacturer["VolkswagenNutzfahrzeuge"] = "Volkswagen Nutzfahrzeuge";
    ClassiccreditNlVehicleModelManufacturer["Volvo"] = "Volvo";
    ClassiccreditNlVehicleModelManufacturer["VWFS"] = "VWFS";
    ClassiccreditNlVehicleModelManufacturer["Jiayuan"] = "Jiayuan";
    ClassiccreditNlVehicleModelManufacturer["Goupil"] = "Goupil";
    ClassiccreditNlVehicleModelManufacturer["DFM"] = "DFM";
})(ClassiccreditNlVehicleModelManufacturer = exports.ClassiccreditNlVehicleModelManufacturer || (exports.ClassiccreditNlVehicleModelManufacturer = {}));
/**
 * Defines whether a new contract is generated or someone takes over an existing contract
 */
var FinanceleaseNlContractType;
(function (FinanceleaseNlContractType) {
    FinanceleaseNlContractType["NEW"] = "new";
    FinanceleaseNlContractType["IPS"] = "ips";
})(FinanceleaseNlContractType = exports.FinanceleaseNlContractType || (exports.FinanceleaseNlContractType = {}));
var FinanceleaseNlVehicleModelManufacturer;
(function (FinanceleaseNlVehicleModelManufacturer) {
    FinanceleaseNlVehicleModelManufacturer["Abarth"] = "Abarth";
    FinanceleaseNlVehicleModelManufacturer["Acura"] = "Acura";
    FinanceleaseNlVehicleModelManufacturer["AlfaRomeo"] = "Alfa Romeo";
    FinanceleaseNlVehicleModelManufacturer["Alpine"] = "Alpine";
    FinanceleaseNlVehicleModelManufacturer["AstonMartin"] = "Aston Martin";
    FinanceleaseNlVehicleModelManufacturer["Audi"] = "Audi";
    FinanceleaseNlVehicleModelManufacturer["Bentley"] = "Bentley";
    FinanceleaseNlVehicleModelManufacturer["BMW"] = "BMW";
    FinanceleaseNlVehicleModelManufacturer["Bugatti"] = "Bugatti";
    FinanceleaseNlVehicleModelManufacturer["Cadillac"] = "Cadillac";
    FinanceleaseNlVehicleModelManufacturer["ChevroletUSA"] = "Chevrolet USA";
    FinanceleaseNlVehicleModelManufacturer["Chrysler"] = "Chrysler";
    FinanceleaseNlVehicleModelManufacturer["Citroen"] = "Citro\u00EBn";
    FinanceleaseNlVehicleModelManufacturer["CUPRA"] = "CUPRA";
    FinanceleaseNlVehicleModelManufacturer["Dacia"] = "Dacia";
    FinanceleaseNlVehicleModelManufacturer["Daewoo"] = "Daewoo";
    FinanceleaseNlVehicleModelManufacturer["Daf"] = "Daf";
    FinanceleaseNlVehicleModelManufacturer["Daihatsu"] = "Daihatsu";
    FinanceleaseNlVehicleModelManufacturer["DFSK"] = "DFSK";
    FinanceleaseNlVehicleModelManufacturer["Dodge"] = "Dodge";
    FinanceleaseNlVehicleModelManufacturer["Donkervoort"] = "Donkervoort";
    FinanceleaseNlVehicleModelManufacturer["DS"] = "DS";
    FinanceleaseNlVehicleModelManufacturer["Ducati"] = "Ducati";
    FinanceleaseNlVehicleModelManufacturer["Ferrari"] = "Ferrari";
    FinanceleaseNlVehicleModelManufacturer["Fiat"] = "Fiat";
    FinanceleaseNlVehicleModelManufacturer["Ford"] = "Ford";
    FinanceleaseNlVehicleModelManufacturer["FUSO"] = "FUSO";
    FinanceleaseNlVehicleModelManufacturer["Gaz"] = "Gaz";
    FinanceleaseNlVehicleModelManufacturer["Gazelle"] = "Gazelle";
    FinanceleaseNlVehicleModelManufacturer["Gmc"] = "Gmc";
    FinanceleaseNlVehicleModelManufacturer["HarleyDavidson"] = "Harley-Davidson";
    FinanceleaseNlVehicleModelManufacturer["Honda"] = "Honda";
    FinanceleaseNlVehicleModelManufacturer["Hummer"] = "Hummer";
    FinanceleaseNlVehicleModelManufacturer["Hyundai"] = "Hyundai";
    FinanceleaseNlVehicleModelManufacturer["Infiniti"] = "Infiniti";
    FinanceleaseNlVehicleModelManufacturer["Irizar"] = "Irizar";
    FinanceleaseNlVehicleModelManufacturer["Isuzu"] = "Isuzu";
    FinanceleaseNlVehicleModelManufacturer["Iveco"] = "Iveco";
    FinanceleaseNlVehicleModelManufacturer["Jaguar"] = "Jaguar";
    FinanceleaseNlVehicleModelManufacturer["Jeep"] = "Jeep";
    FinanceleaseNlVehicleModelManufacturer["Jmc"] = "Jmc";
    FinanceleaseNlVehicleModelManufacturer["Kamaz"] = "Kamaz";
    FinanceleaseNlVehicleModelManufacturer["Kawasaki"] = "Kawasaki";
    FinanceleaseNlVehicleModelManufacturer["Kia"] = "Kia";
    FinanceleaseNlVehicleModelManufacturer["Ktm"] = "Ktm";
    FinanceleaseNlVehicleModelManufacturer["Lada"] = "Lada";
    FinanceleaseNlVehicleModelManufacturer["Lamborghini"] = "Lamborghini";
    FinanceleaseNlVehicleModelManufacturer["Lancia"] = "Lancia";
    FinanceleaseNlVehicleModelManufacturer["LandRover"] = "Land Rover";
    FinanceleaseNlVehicleModelManufacturer["Lexus"] = "Lexus";
    FinanceleaseNlVehicleModelManufacturer["Lincoln"] = "Lincoln";
    FinanceleaseNlVehicleModelManufacturer["Lotus"] = "Lotus";
    FinanceleaseNlVehicleModelManufacturer["MAN"] = "MAN";
    FinanceleaseNlVehicleModelManufacturer["Maserati"] = "Maserati";
    FinanceleaseNlVehicleModelManufacturer["Mazda"] = "Mazda";
    FinanceleaseNlVehicleModelManufacturer["McLaren"] = "McLaren";
    FinanceleaseNlVehicleModelManufacturer["MercedesBenz"] = "Mercedes-Benz";
    FinanceleaseNlVehicleModelManufacturer["Mini"] = "MINI";
    FinanceleaseNlVehicleModelManufacturer["Mitsubishi"] = "Mitsubishi";
    FinanceleaseNlVehicleModelManufacturer["Morgan"] = "Morgan";
    FinanceleaseNlVehicleModelManufacturer["Nissan"] = "Nissan";
    FinanceleaseNlVehicleModelManufacturer["Opel"] = "Opel";
    FinanceleaseNlVehicleModelManufacturer["Peugeot"] = "Peugeot";
    FinanceleaseNlVehicleModelManufacturer["Pgo"] = "Pgo";
    FinanceleaseNlVehicleModelManufacturer["Piaggio"] = "Piaggio";
    FinanceleaseNlVehicleModelManufacturer["Polaris"] = "Polaris";
    FinanceleaseNlVehicleModelManufacturer["Pontiac"] = "Pontiac";
    FinanceleaseNlVehicleModelManufacturer["Porsche"] = "Porsche";
    FinanceleaseNlVehicleModelManufacturer["Ram"] = "Ram";
    FinanceleaseNlVehicleModelManufacturer["Renault"] = "Renault";
    FinanceleaseNlVehicleModelManufacturer["RollsRoyce"] = "Rolls-Royce";
    FinanceleaseNlVehicleModelManufacturer["Saab"] = "Saab";
    FinanceleaseNlVehicleModelManufacturer["SAIC"] = "SAIC";
    FinanceleaseNlVehicleModelManufacturer["Scania"] = "Scania";
    FinanceleaseNlVehicleModelManufacturer["SEAT"] = "SEAT";
    FinanceleaseNlVehicleModelManufacturer["Setra"] = "Setra";
    FinanceleaseNlVehicleModelManufacturer["Skoda"] = "\u0160KODA";
    FinanceleaseNlVehicleModelManufacturer["smart"] = "Smart";
    FinanceleaseNlVehicleModelManufacturer["SsangYong"] = "SsangYong";
    FinanceleaseNlVehicleModelManufacturer["StreetScooter"] = "StreetScooter";
    FinanceleaseNlVehicleModelManufacturer["Subaru"] = "Subaru";
    FinanceleaseNlVehicleModelManufacturer["Suzuki"] = "Suzuki";
    FinanceleaseNlVehicleModelManufacturer["Tata"] = "Tata";
    FinanceleaseNlVehicleModelManufacturer["Tesla"] = "Tesla";
    FinanceleaseNlVehicleModelManufacturer["Toyota"] = "Toyota";
    FinanceleaseNlVehicleModelManufacturer["Volkswagen"] = "Volkswagen";
    FinanceleaseNlVehicleModelManufacturer["VolkswagenNutzfahrzeuge"] = "Volkswagen Nutzfahrzeuge";
    FinanceleaseNlVehicleModelManufacturer["Volvo"] = "Volvo";
    FinanceleaseNlVehicleModelManufacturer["VWFS"] = "VWFS";
    FinanceleaseNlVehicleModelManufacturer["Jiayuan"] = "Jiayuan";
    FinanceleaseNlVehicleModelManufacturer["Goupil"] = "Goupil";
    FinanceleaseNlVehicleModelManufacturer["DFM"] = "DFM";
})(FinanceleaseNlVehicleModelManufacturer = exports.FinanceleaseNlVehicleModelManufacturer || (exports.FinanceleaseNlVehicleModelManufacturer = {}));
/**
 * Represents the type of usage of a car.
 */
var MotorinsuranceNlUsageType;
(function (MotorinsuranceNlUsageType) {
    MotorinsuranceNlUsageType["PRIVATE"] = "Private";
    MotorinsuranceNlUsageType["COMMERCIAL"] = "Commercial";
    MotorinsuranceNlUsageType["OWN_GOODS"] = "OwnGoods";
    MotorinsuranceNlUsageType["DELIVERY"] = "Delivery";
    MotorinsuranceNlUsageType["RENTAL"] = "Rental";
    MotorinsuranceNlUsageType["PASSENGER_TRANSPORTATION"] = "PassengerTransportation";
})(MotorinsuranceNlUsageType = exports.MotorinsuranceNlUsageType || (exports.MotorinsuranceNlUsageType = {}));
/**
 * Defines whether a new contract is generated or someone takes over an existing contract
 */
var PrivateleaseNlContractType;
(function (PrivateleaseNlContractType) {
    PrivateleaseNlContractType["NEW"] = "new";
    PrivateleaseNlContractType["TAKEOVER"] = "takeover";
})(PrivateleaseNlContractType = exports.PrivateleaseNlContractType || (exports.PrivateleaseNlContractType = {}));
/**
 * Tires with which the car is equipped
 */
var PrivateleaseNlTires;
(function (PrivateleaseNlTires) {
    PrivateleaseNlTires["WINTER"] = "winter";
    PrivateleaseNlTires["SUMMER"] = "summer";
    PrivateleaseNlTires["ALLYEAR"] = "Allyear";
})(PrivateleaseNlTires = exports.PrivateleaseNlTires || (exports.PrivateleaseNlTires = {}));
/**
 * Describes whether and from when a replacement vehicle will be provided
 */
var PrivateleaseNlReplacementVehicle;
(function (PrivateleaseNlReplacementVehicle) {
    PrivateleaseNlReplacementVehicle["NO"] = "no";
    PrivateleaseNlReplacementVehicle["DIRECT"] = "direct";
    PrivateleaseNlReplacementVehicle["AFTER24HOURS"] = "after24hours";
    PrivateleaseNlReplacementVehicle["AFTER48HOURS"] = "after48hours";
})(PrivateleaseNlReplacementVehicle = exports.PrivateleaseNlReplacementVehicle || (exports.PrivateleaseNlReplacementVehicle = {}));
var OperateleaseGrManufacturer;
(function (OperateleaseGrManufacturer) {
    OperateleaseGrManufacturer["Abarth"] = "Abarth";
    OperateleaseGrManufacturer["Acura"] = "Acura";
    OperateleaseGrManufacturer["AlfaRomeo"] = "Alfa Romeo";
    OperateleaseGrManufacturer["Alpine"] = "Alpine";
    OperateleaseGrManufacturer["AstonMartin"] = "Aston Martin";
    OperateleaseGrManufacturer["Audi"] = "Audi";
    OperateleaseGrManufacturer["Bentley"] = "Bentley";
    OperateleaseGrManufacturer["BMW"] = "BMW";
    OperateleaseGrManufacturer["Bugatti"] = "Bugatti";
    OperateleaseGrManufacturer["Cadillac"] = "Cadillac";
    OperateleaseGrManufacturer["ChevroletUSA"] = "Chevrolet USA";
    OperateleaseGrManufacturer["Chrysler"] = "Chrysler";
    OperateleaseGrManufacturer["Citroen"] = "Citroen";
    OperateleaseGrManufacturer["CUPRA"] = "CUPRA";
    OperateleaseGrManufacturer["Dacia"] = "Dacia";
    OperateleaseGrManufacturer["Daewoo"] = "Daewoo";
    OperateleaseGrManufacturer["Daf"] = "Daf";
    OperateleaseGrManufacturer["Daihatsu"] = "Daihatsu";
    OperateleaseGrManufacturer["DFSK"] = "DFSK";
    OperateleaseGrManufacturer["Dodge"] = "Dodge";
    OperateleaseGrManufacturer["Donkervoort"] = "Donkervoort";
    OperateleaseGrManufacturer["DS"] = "DS";
    OperateleaseGrManufacturer["Ducati"] = "Ducati";
    OperateleaseGrManufacturer["Ferrari"] = "Ferrari";
    OperateleaseGrManufacturer["Fiat"] = "Fiat";
    OperateleaseGrManufacturer["Ford"] = "Ford";
    OperateleaseGrManufacturer["FUSO"] = "FUSO";
    OperateleaseGrManufacturer["Gaz"] = "Gaz";
    OperateleaseGrManufacturer["Gazelle"] = "Gazelle";
    OperateleaseGrManufacturer["Gmc"] = "Gmc";
    OperateleaseGrManufacturer["HarleyDavidson"] = "Harley-Davidson";
    OperateleaseGrManufacturer["Honda"] = "Honda";
    OperateleaseGrManufacturer["Hummer"] = "Hummer";
    OperateleaseGrManufacturer["Hyundai"] = "Hyundai";
    OperateleaseGrManufacturer["Infiniti"] = "Infiniti";
    OperateleaseGrManufacturer["Irizar"] = "Irizar";
    OperateleaseGrManufacturer["Isuzu"] = "Isuzu";
    OperateleaseGrManufacturer["Iveco"] = "Iveco";
    OperateleaseGrManufacturer["Jaguar"] = "Jaguar";
    OperateleaseGrManufacturer["Jeep"] = "Jeep";
    OperateleaseGrManufacturer["Jmc"] = "Jmc";
    OperateleaseGrManufacturer["Kamaz"] = "Kamaz";
    OperateleaseGrManufacturer["Kawasaki"] = "Kawasaki";
    OperateleaseGrManufacturer["Kia"] = "Kia";
    OperateleaseGrManufacturer["Ktm"] = "Ktm";
    OperateleaseGrManufacturer["Lada"] = "Lada";
    OperateleaseGrManufacturer["Lamborghini"] = "Lamborghini";
    OperateleaseGrManufacturer["Lancia"] = "Lancia";
    OperateleaseGrManufacturer["LandRover"] = "Land Rover";
    OperateleaseGrManufacturer["Lexus"] = "Lexus";
    OperateleaseGrManufacturer["Lincoln"] = "Lincoln";
    OperateleaseGrManufacturer["Lotus"] = "Lotus";
    OperateleaseGrManufacturer["MAN"] = "MAN";
    OperateleaseGrManufacturer["Maserati"] = "Maserati";
    OperateleaseGrManufacturer["Mazda"] = "Mazda";
    OperateleaseGrManufacturer["McLaren"] = "McLaren";
    OperateleaseGrManufacturer["MercedesBenz"] = "Mercedes-Benz";
    OperateleaseGrManufacturer["Mini"] = "Mini";
    OperateleaseGrManufacturer["Mitsubishi"] = "Mitsubishi";
    OperateleaseGrManufacturer["Morgan"] = "Morgan";
    OperateleaseGrManufacturer["Nissan"] = "Nissan";
    OperateleaseGrManufacturer["Opel"] = "Opel";
    OperateleaseGrManufacturer["Peugeot"] = "Peugeot";
    OperateleaseGrManufacturer["Pgo"] = "Pgo";
    OperateleaseGrManufacturer["Piaggio"] = "Piaggio";
    OperateleaseGrManufacturer["Polaris"] = "Polaris";
    OperateleaseGrManufacturer["Pontiac"] = "Pontiac";
    OperateleaseGrManufacturer["Porsche"] = "Porsche";
    OperateleaseGrManufacturer["Ram"] = "Ram";
    OperateleaseGrManufacturer["Renault"] = "Renault";
    OperateleaseGrManufacturer["RollsRoyce"] = "Rolls-Royce";
    OperateleaseGrManufacturer["Saab"] = "Saab";
    OperateleaseGrManufacturer["SAIC"] = "SAIC";
    OperateleaseGrManufacturer["Scania"] = "Scania";
    OperateleaseGrManufacturer["SEAT"] = "SEAT";
    OperateleaseGrManufacturer["Setra"] = "Setra";
    OperateleaseGrManufacturer["Skoda"] = "Skoda";
    OperateleaseGrManufacturer["smart"] = "smart";
    OperateleaseGrManufacturer["SsangYong"] = "SsangYong";
    OperateleaseGrManufacturer["StreetScooter"] = "StreetScooter";
    OperateleaseGrManufacturer["Subaru"] = "Subaru";
    OperateleaseGrManufacturer["Suzuki"] = "Suzuki";
    OperateleaseGrManufacturer["Tata"] = "Tata";
    OperateleaseGrManufacturer["Tesla"] = "Tesla";
    OperateleaseGrManufacturer["Toyota"] = "Toyota";
    OperateleaseGrManufacturer["Volkswagen"] = "Volkswagen";
    OperateleaseGrManufacturer["VolkswagenNutzfahrzeuge"] = "Volkswagen Nutzfahrzeuge";
    OperateleaseGrManufacturer["Volvo"] = "Volvo";
    OperateleaseGrManufacturer["Jiayuan"] = "Jiayuan";
    OperateleaseGrManufacturer["Goupil"] = "Goupil";
    OperateleaseGrManufacturer["DFM"] = "DFM";
})(OperateleaseGrManufacturer = exports.OperateleaseGrManufacturer || (exports.OperateleaseGrManufacturer = {}));
/**
 * Represents the type of a customer
 */
var OperateleasePlPartnerType;
(function (OperateleasePlPartnerType) {
    OperateleasePlPartnerType["BUSINESS"] = "FIRM";
    OperateleasePlPartnerType["PRIVATE"] = "PERSON";
    OperateleasePlPartnerType["ENTREPRENEUR"] = "SELF-EMPLOYED";
})(OperateleasePlPartnerType = exports.OperateleasePlPartnerType || (exports.OperateleasePlPartnerType = {}));
/**
 * Represents an ISO 3166-1 alpha-2 conform country code accessible through the full english name of the
 * country. This enum should be used to describe for instance vehicle origins or nationalities of
 * persons. Don't use it to describe a VWFS market. Use enum Country in @bus/models.
 */
var OperateleasePlCountryCode;
(function (OperateleasePlCountryCode) {
    OperateleasePlCountryCode["Afghanistan"] = "AF";
    OperateleasePlCountryCode["AlandIslands"] = "AX";
    OperateleasePlCountryCode["Albania"] = "AL";
    OperateleasePlCountryCode["Algeria"] = "DZ";
    OperateleasePlCountryCode["AmericanSamoa"] = "AS";
    OperateleasePlCountryCode["Andorra"] = "AD";
    OperateleasePlCountryCode["Angola"] = "AO";
    OperateleasePlCountryCode["Anguilla"] = "AI";
    OperateleasePlCountryCode["Antarctica"] = "AQ";
    OperateleasePlCountryCode["AntiguaAndBarbuda"] = "AG";
    OperateleasePlCountryCode["Argentina"] = "AR";
    OperateleasePlCountryCode["Armenia"] = "AM";
    OperateleasePlCountryCode["Aruba"] = "AW";
    OperateleasePlCountryCode["Australia"] = "AU";
    OperateleasePlCountryCode["Austria"] = "AT";
    OperateleasePlCountryCode["Azerbaijan"] = "AZ";
    OperateleasePlCountryCode["Bahamas"] = "BS";
    OperateleasePlCountryCode["Bahrain"] = "BH";
    OperateleasePlCountryCode["Bangladesh"] = "BD";
    OperateleasePlCountryCode["Barbados"] = "BB";
    OperateleasePlCountryCode["Belarus"] = "BY";
    OperateleasePlCountryCode["Belgium"] = "BE";
    OperateleasePlCountryCode["Belize"] = "BZ";
    OperateleasePlCountryCode["Benin"] = "BJ";
    OperateleasePlCountryCode["Bermuda"] = "BM";
    OperateleasePlCountryCode["Bhutan"] = "BT";
    OperateleasePlCountryCode["Bolivia"] = "BO";
    OperateleasePlCountryCode["BonaireSintEustatiusAndSaba"] = "BQ";
    OperateleasePlCountryCode["BosniaAndHerzegovina"] = "BA";
    OperateleasePlCountryCode["Botswana"] = "BW";
    OperateleasePlCountryCode["BouvetIsland"] = "BV";
    OperateleasePlCountryCode["Brazil"] = "BR";
    OperateleasePlCountryCode["BritishIndianOceanTerritory"] = "IO";
    OperateleasePlCountryCode["BruneiDarussalam"] = "BN";
    OperateleasePlCountryCode["Bulgaria"] = "BG";
    OperateleasePlCountryCode["BurkinaFaso"] = "BF";
    OperateleasePlCountryCode["Burundi"] = "BI";
    OperateleasePlCountryCode["Cambodia"] = "KH";
    OperateleasePlCountryCode["Cameroon"] = "CM";
    OperateleasePlCountryCode["Canada"] = "CA";
    OperateleasePlCountryCode["CapeVerde"] = "CV";
    OperateleasePlCountryCode["CaymanIslands"] = "KY";
    OperateleasePlCountryCode["CentralAfricanRepublic"] = "CF";
    OperateleasePlCountryCode["Chad"] = "TD";
    OperateleasePlCountryCode["Chile"] = "CL";
    OperateleasePlCountryCode["China"] = "CN";
    OperateleasePlCountryCode["ChristmasIsland"] = "CX";
    OperateleasePlCountryCode["CocosKeelingIslands"] = "CC";
    OperateleasePlCountryCode["Colombia"] = "CO";
    OperateleasePlCountryCode["Comoros"] = "KM";
    OperateleasePlCountryCode["Congo"] = "CG";
    OperateleasePlCountryCode["CongoDemocraticRepublic"] = "CD";
    OperateleasePlCountryCode["CookIslands"] = "CK";
    OperateleasePlCountryCode["CostaRica"] = "CR";
    OperateleasePlCountryCode["Croatia"] = "HR";
    OperateleasePlCountryCode["Cuba"] = "CU";
    OperateleasePlCountryCode["Curacao"] = "CW";
    OperateleasePlCountryCode["Cyprus"] = "CY";
    OperateleasePlCountryCode["CzechRepublic"] = "CZ";
    OperateleasePlCountryCode["Denmark"] = "DK";
    OperateleasePlCountryCode["Djibouti"] = "DJ";
    OperateleasePlCountryCode["Dominica"] = "DM";
    OperateleasePlCountryCode["DominicanRepublic"] = "DO";
    OperateleasePlCountryCode["Ecuador"] = "EC";
    OperateleasePlCountryCode["Egypt"] = "EG";
    OperateleasePlCountryCode["ElSalvador"] = "SV";
    OperateleasePlCountryCode["EquatorialGuinea"] = "GQ";
    OperateleasePlCountryCode["Eritrea"] = "ER";
    OperateleasePlCountryCode["Estonia"] = "EE";
    OperateleasePlCountryCode["Ethiopia"] = "ET";
    OperateleasePlCountryCode["FalklandIslands"] = "FK";
    OperateleasePlCountryCode["FaroeIslands"] = "FO";
    OperateleasePlCountryCode["Fiji"] = "FJ";
    OperateleasePlCountryCode["Finland"] = "FI";
    OperateleasePlCountryCode["France"] = "FR";
    OperateleasePlCountryCode["FrenchGuiana"] = "GF";
    OperateleasePlCountryCode["FrenchPolynesia"] = "PF";
    OperateleasePlCountryCode["FrenchSouthernTerritories"] = "TF";
    OperateleasePlCountryCode["Gabon"] = "GA";
    OperateleasePlCountryCode["Gambia"] = "GM";
    OperateleasePlCountryCode["Georgia"] = "GE";
    OperateleasePlCountryCode["Germany"] = "DE";
    OperateleasePlCountryCode["Ghana"] = "GH";
    OperateleasePlCountryCode["Gibraltar"] = "GI";
    OperateleasePlCountryCode["Greece"] = "GR";
    OperateleasePlCountryCode["Greenland"] = "GL";
    OperateleasePlCountryCode["Grenada"] = "GD";
    OperateleasePlCountryCode["Guadeloupe"] = "GP";
    OperateleasePlCountryCode["Guam"] = "GU";
    OperateleasePlCountryCode["Guatemala"] = "GT";
    OperateleasePlCountryCode["Guernsey"] = "GG";
    OperateleasePlCountryCode["Guinea"] = "GN";
    OperateleasePlCountryCode["GuineaBissau"] = "GW";
    OperateleasePlCountryCode["Guyana"] = "GY";
    OperateleasePlCountryCode["Haiti"] = "HT";
    OperateleasePlCountryCode["HeardIslandMcdonaldIslands"] = "HM";
    OperateleasePlCountryCode["HolySeeVaticanCityState"] = "VA";
    OperateleasePlCountryCode["Honduras"] = "HN";
    OperateleasePlCountryCode["HongKong"] = "HK";
    OperateleasePlCountryCode["Hungary"] = "HU";
    OperateleasePlCountryCode["Iceland"] = "IS";
    OperateleasePlCountryCode["India"] = "IN";
    OperateleasePlCountryCode["Indonesia"] = "ID";
    OperateleasePlCountryCode["Iran"] = "IR";
    OperateleasePlCountryCode["Iraq"] = "IQ";
    OperateleasePlCountryCode["Ireland"] = "IE";
    OperateleasePlCountryCode["IsleOfMan"] = "IM";
    OperateleasePlCountryCode["Israel"] = "IL";
    OperateleasePlCountryCode["Italy"] = "IT";
    OperateleasePlCountryCode["IvoryCoast"] = "CI";
    OperateleasePlCountryCode["Jamaica"] = "JM";
    OperateleasePlCountryCode["Japan"] = "JP";
    OperateleasePlCountryCode["Jersey"] = "JE";
    OperateleasePlCountryCode["Jordan"] = "JO";
    OperateleasePlCountryCode["Kazakhstan"] = "KZ";
    OperateleasePlCountryCode["Kenya"] = "KE";
    OperateleasePlCountryCode["Kiribati"] = "KI";
    OperateleasePlCountryCode["Korea"] = "KR";
    OperateleasePlCountryCode["Kosovo"] = "XK";
    OperateleasePlCountryCode["Kuwait"] = "KW";
    OperateleasePlCountryCode["Kyrgyzstan"] = "KG";
    OperateleasePlCountryCode["LaoPeoplesDemocraticRepublic"] = "LA";
    OperateleasePlCountryCode["Latvia"] = "LV";
    OperateleasePlCountryCode["Lebanon"] = "LB";
    OperateleasePlCountryCode["Lesotho"] = "LS";
    OperateleasePlCountryCode["Liberia"] = "LR";
    OperateleasePlCountryCode["LibyanArabJamahiriya"] = "LY";
    OperateleasePlCountryCode["Liechtenstein"] = "LI";
    OperateleasePlCountryCode["Lithuania"] = "LT";
    OperateleasePlCountryCode["Luxembourg"] = "LU";
    OperateleasePlCountryCode["Macao"] = "MO";
    OperateleasePlCountryCode["Macedonia"] = "MK";
    OperateleasePlCountryCode["Madagascar"] = "MG";
    OperateleasePlCountryCode["Malawi"] = "MW";
    OperateleasePlCountryCode["Malaysia"] = "MY";
    OperateleasePlCountryCode["Maldives"] = "MV";
    OperateleasePlCountryCode["Mali"] = "ML";
    OperateleasePlCountryCode["Malta"] = "MT";
    OperateleasePlCountryCode["MarshallIslands"] = "MH";
    OperateleasePlCountryCode["Martinique"] = "MQ";
    OperateleasePlCountryCode["Mauritania"] = "MR";
    OperateleasePlCountryCode["Mauritius"] = "MU";
    OperateleasePlCountryCode["Mayotte"] = "YT";
    OperateleasePlCountryCode["Mexico"] = "MX";
    OperateleasePlCountryCode["Micronesia"] = "FM";
    OperateleasePlCountryCode["Moldova"] = "MD";
    OperateleasePlCountryCode["Monaco"] = "MC";
    OperateleasePlCountryCode["Mongolia"] = "MN";
    OperateleasePlCountryCode["Montenegro"] = "ME";
    OperateleasePlCountryCode["Montserrat"] = "MS";
    OperateleasePlCountryCode["Morocco"] = "MA";
    OperateleasePlCountryCode["Mozambique"] = "MZ";
    OperateleasePlCountryCode["Myanmar"] = "MM";
    OperateleasePlCountryCode["Namibia"] = "NA";
    OperateleasePlCountryCode["Nauru"] = "NR";
    OperateleasePlCountryCode["Nepal"] = "NP";
    OperateleasePlCountryCode["Netherlands"] = "NL";
    OperateleasePlCountryCode["NetherlandsAntilles"] = "AN";
    OperateleasePlCountryCode["NewCaledonia"] = "NC";
    OperateleasePlCountryCode["NewZealand"] = "NZ";
    OperateleasePlCountryCode["Nicaragua"] = "NI";
    OperateleasePlCountryCode["Niger"] = "NE";
    OperateleasePlCountryCode["Nigeria"] = "NG";
    OperateleasePlCountryCode["Niue"] = "NU";
    OperateleasePlCountryCode["NorfolkIsland"] = "NF";
    OperateleasePlCountryCode["NorthernMarianaIslands"] = "MP";
    OperateleasePlCountryCode["NorthKorea"] = "KP";
    OperateleasePlCountryCode["Norway"] = "NO";
    OperateleasePlCountryCode["Oman"] = "OM";
    OperateleasePlCountryCode["Pakistan"] = "PK";
    OperateleasePlCountryCode["Palau"] = "PW";
    OperateleasePlCountryCode["PalestinianTerritory"] = "PS";
    OperateleasePlCountryCode["Panama"] = "PA";
    OperateleasePlCountryCode["PapuaNewGuinea"] = "PG";
    OperateleasePlCountryCode["Paraguay"] = "PY";
    OperateleasePlCountryCode["Peru"] = "PE";
    OperateleasePlCountryCode["Philippines"] = "PH";
    OperateleasePlCountryCode["Pitcairn"] = "PN";
    OperateleasePlCountryCode["Poland"] = "PL";
    OperateleasePlCountryCode["Portugal"] = "PT";
    OperateleasePlCountryCode["PuertoRico"] = "PR";
    OperateleasePlCountryCode["Qatar"] = "QA";
    OperateleasePlCountryCode["Reunion"] = "RE";
    OperateleasePlCountryCode["Romania"] = "RO";
    OperateleasePlCountryCode["RussianFederation"] = "RU";
    OperateleasePlCountryCode["Rwanda"] = "RW";
    OperateleasePlCountryCode["SaintBarthelemy"] = "BL";
    OperateleasePlCountryCode["SaintHelena"] = "SH";
    OperateleasePlCountryCode["SaintKittsAndNevis"] = "KN";
    OperateleasePlCountryCode["SaintLucia"] = "LC";
    OperateleasePlCountryCode["SaintMartin"] = "MF";
    OperateleasePlCountryCode["SaintPierreAndMiquelon"] = "PM";
    OperateleasePlCountryCode["SaintVincentAndGrenadines"] = "VC";
    OperateleasePlCountryCode["Samoa"] = "WS";
    OperateleasePlCountryCode["SanMarino"] = "SM";
    OperateleasePlCountryCode["SaoTomeAndPrincipe"] = "ST";
    OperateleasePlCountryCode["SaudiArabia"] = "SA";
    OperateleasePlCountryCode["Senegal"] = "SN";
    OperateleasePlCountryCode["Serbia"] = "RS";
    OperateleasePlCountryCode["Seychelles"] = "SC";
    OperateleasePlCountryCode["SierraLeone"] = "SL";
    OperateleasePlCountryCode["Singapore"] = "SG";
    OperateleasePlCountryCode["SintMaarten"] = "SX";
    OperateleasePlCountryCode["Slovakia"] = "SK";
    OperateleasePlCountryCode["Slovenia"] = "SI";
    OperateleasePlCountryCode["SolomonIslands"] = "SB";
    OperateleasePlCountryCode["Somalia"] = "SO";
    OperateleasePlCountryCode["SouthAfrica"] = "ZA";
    OperateleasePlCountryCode["SouthGeorgiaAndSandwichIsl"] = "GS";
    OperateleasePlCountryCode["Spain"] = "ES";
    OperateleasePlCountryCode["SriLanka"] = "LK";
    OperateleasePlCountryCode["Sudan"] = "SD";
    OperateleasePlCountryCode["Suriname"] = "SR";
    OperateleasePlCountryCode["SvalbardAndJanMayen"] = "SJ";
    OperateleasePlCountryCode["Swaziland"] = "SZ";
    OperateleasePlCountryCode["Sweden"] = "SE";
    OperateleasePlCountryCode["Switzerland"] = "CH";
    OperateleasePlCountryCode["SyrianArabRepublic"] = "SY";
    OperateleasePlCountryCode["Taiwan"] = "TW";
    OperateleasePlCountryCode["Tajikistan"] = "TJ";
    OperateleasePlCountryCode["Tanzania"] = "TZ";
    OperateleasePlCountryCode["Thailand"] = "TH";
    OperateleasePlCountryCode["TimorLeste"] = "TL";
    OperateleasePlCountryCode["Togo"] = "TG";
    OperateleasePlCountryCode["Tokelau"] = "TK";
    OperateleasePlCountryCode["Tonga"] = "TO";
    OperateleasePlCountryCode["TrinidadAndTobago"] = "TT";
    OperateleasePlCountryCode["Tunisia"] = "TN";
    OperateleasePlCountryCode["Turkey"] = "TR";
    OperateleasePlCountryCode["Turkmenistan"] = "TM";
    OperateleasePlCountryCode["TurksAndCaicosIslands"] = "TC";
    OperateleasePlCountryCode["Tuvalu"] = "TV";
    OperateleasePlCountryCode["Uganda"] = "UG";
    OperateleasePlCountryCode["Ukraine"] = "UA";
    OperateleasePlCountryCode["UnitedArabEmirates"] = "AE";
    OperateleasePlCountryCode["UnitedKingdom"] = "GB";
    OperateleasePlCountryCode["UnitedStates"] = "US";
    OperateleasePlCountryCode["UnitedStatesOutlyingIslands"] = "UM";
    OperateleasePlCountryCode["Uruguay"] = "UY";
    OperateleasePlCountryCode["Uzbekistan"] = "UZ";
    OperateleasePlCountryCode["Vanuatu"] = "VU";
    OperateleasePlCountryCode["Venezuela"] = "VE";
    OperateleasePlCountryCode["Vietnam"] = "VN";
    OperateleasePlCountryCode["VirginIslandsBritish"] = "VG";
    OperateleasePlCountryCode["VirginIslandsUS"] = "VI";
    OperateleasePlCountryCode["WallisAndFutuna"] = "WF";
    OperateleasePlCountryCode["WesternSahara"] = "EH";
    OperateleasePlCountryCode["Yemen"] = "YE";
    OperateleasePlCountryCode["Zambia"] = "ZM";
    OperateleasePlCountryCode["Zimbabwe"] = "ZW";
    OperateleasePlCountryCode["SouthSudan"] = "SS";
    OperateleasePlCountryCode["DemocraticPeoplesRepublicOfKorea"] = "KP";
})(OperateleasePlCountryCode = exports.OperateleasePlCountryCode || (exports.OperateleasePlCountryCode = {}));
var OperateleasePlCalculationMethod;
(function (OperateleasePlCalculationMethod) {
    OperateleasePlCalculationMethod["DECREASING"] = "DECREASING";
    OperateleasePlCalculationMethod["EQUAL"] = "EQUAL";
    OperateleasePlCalculationMethod["LEASE"] = "LEASE";
    OperateleasePlCalculationMethod["BALLOON"] = "BALLOON";
})(OperateleasePlCalculationMethod = exports.OperateleasePlCalculationMethod || (exports.OperateleasePlCalculationMethod = {}));
var OperateleasePlInsuranceType;
(function (OperateleasePlInsuranceType) {
    OperateleasePlInsuranceType["RSVA"] = "RSVA";
    OperateleasePlInsuranceType["RSVB"] = "RSVB";
    OperateleasePlInsuranceType["RSVC"] = "RSVC";
    OperateleasePlInsuranceType["GAPD"] = "GAPD";
    OperateleasePlInsuranceType["RTID2"] = "RTID2";
    OperateleasePlInsuranceType["RTID3"] = "RTID3";
    OperateleasePlInsuranceType["LIFEL"] = "LIFEL";
    OperateleasePlInsuranceType["CPI"] = "CPI";
    OperateleasePlInsuranceType["XWA"] = "XWA";
    OperateleasePlInsuranceType["CAR"] = "CAR";
})(OperateleasePlInsuranceType = exports.OperateleasePlInsuranceType || (exports.OperateleasePlInsuranceType = {}));
var OperateleasePlPaymentMethod;
(function (OperateleasePlPaymentMethod) {
    OperateleasePlPaymentMethod["CONTRACT"] = "CONTRACT";
    OperateleasePlPaymentMethod["CASH"] = "CASH";
})(OperateleasePlPaymentMethod = exports.OperateleasePlPaymentMethod || (exports.OperateleasePlPaymentMethod = {}));
var OperateleasePlInsuranceVariant;
(function (OperateleasePlInsuranceVariant) {
    OperateleasePlInsuranceVariant["ILLNESS"] = "ILLNESS";
    OperateleasePlInsuranceVariant["INABILITY"] = "INABILITY";
    OperateleasePlInsuranceVariant["DEATH"] = "DEATH";
})(OperateleasePlInsuranceVariant = exports.OperateleasePlInsuranceVariant || (exports.OperateleasePlInsuranceVariant = {}));
/**
 * Represents the type of vehicle.
 */
var OperateleasePlVehicleClass;
(function (OperateleasePlVehicleClass) {
    OperateleasePlVehicleClass["PASSENGER"] = "0";
    OperateleasePlVehicleClass["COMMERCIAL"] = "1";
})(OperateleasePlVehicleClass = exports.OperateleasePlVehicleClass || (exports.OperateleasePlVehicleClass = {}));
/**
 * This attribute defines the maturity of maintenance for the chosen contract, either basic or full.
 */
var CreditRentingPtMaintenancePackageType;
(function (CreditRentingPtMaintenancePackageType) {
    CreditRentingPtMaintenancePackageType["FULL_EXTERNAL"] = "Full External";
    CreditRentingPtMaintenancePackageType["BASIC_EXTERNAL"] = "Basic External";
})(CreditRentingPtMaintenancePackageType = exports.CreditRentingPtMaintenancePackageType || (exports.CreditRentingPtMaintenancePackageType = {}));
/**
 * The possible deductible values
 */
var CreditRentingPtDeductibleType;
(function (CreditRentingPtDeductibleType) {
    CreditRentingPtDeductibleType["NO"] = "No";
    CreditRentingPtDeductibleType["PCT20_DEDUCTIBLE"] = "20% Deductible (CCC)";
    CreditRentingPtDeductibleType["PCT12_DEDUCTIBLE"] = "12% Deductible (CCC)";
    CreditRentingPtDeductibleType["PCT8_DEDUCTIBLE"] = "8% Deductible (CCC)";
    CreditRentingPtDeductibleType["PCT8_DEDUCTIBLE_DP"] = "8% Deductible (DP)";
    CreditRentingPtDeductibleType["PCT4_DEDUCTIBLE"] = "4% Deductible (CCC)";
    CreditRentingPtDeductibleType["PCT4_DEDUCTIBLE_DP"] = "4% Deductible (DP)";
    CreditRentingPtDeductibleType["PCT2_DEDUCTIBLE"] = "2% Deductible (CCC)";
    CreditRentingPtDeductibleType["PCT2_DEDUCTIBLE_DP"] = "2% Deductible (DP)";
    CreditRentingPtDeductibleType["PCT0_DEDUCTIBLE"] = "0% Deductible (CCC)";
})(CreditRentingPtDeductibleType = exports.CreditRentingPtDeductibleType || (exports.CreditRentingPtDeductibleType = {}));
/**
 * The possible creditProtectionPackage code values
 */
var CreditRentingPtCodeType;
(function (CreditRentingPtCodeType) {
    CreditRentingPtCodeType["NO"] = "No";
    CreditRentingPtCodeType["PACK1"] = "Pack 1 - Standard";
    CreditRentingPtCodeType["PACK2"] = "Pack 2 - Standard";
    CreditRentingPtCodeType["PACK3"] = "Pack 3 - Standard";
})(CreditRentingPtCodeType = exports.CreditRentingPtCodeType || (exports.CreditRentingPtCodeType = {}));
/**
 * The possible product types
 */
var CreditRentingPtProductType;
(function (CreditRentingPtProductType) {
    CreditRentingPtProductType["AUTOCREDIT"] = "autocredit";
    CreditRentingPtProductType["RENTING"] = "renting";
})(CreditRentingPtProductType = exports.CreditRentingPtProductType || (exports.CreditRentingPtProductType = {}));
/**
 * The possible creditProtectionPackage code values
 */
var CreditRentingPtTempReplacementCarType;
(function (CreditRentingPtTempReplacementCarType) {
    CreditRentingPtTempReplacementCarType["CABIN_CHASSIS"] = "Cabin-chassis";
    CreditRentingPtTempReplacementCarType["CITY_DIESEL"] = "City Diesel";
    CreditRentingPtTempReplacementCarType["CITY_GASOLINE"] = "City Gasoline";
    CreditRentingPtTempReplacementCarType["ECONOMIC"] = "Economic";
    CreditRentingPtTempReplacementCarType["EXECUTIVE"] = "Executive";
    CreditRentingPtTempReplacementCarType["EXECUTIVE_TOP"] = "Executive TOP";
    CreditRentingPtTempReplacementCarType["FAMILY_DIESEL"] = "Family Diesel";
    CreditRentingPtTempReplacementCarType["FAMILY_SMALL_DIESEL"] = "Family Small Diesel";
    CreditRentingPtTempReplacementCarType["FAMILY_SMALL_SW_DIESEL"] = "Family Small SW Diesel";
    CreditRentingPtTempReplacementCarType["FAMILY_SMALL"] = "Family Small";
    CreditRentingPtTempReplacementCarType["FAMILY_SMALL_AUT"] = "Family Small Aut";
    CreditRentingPtTempReplacementCarType["FAMILY_SW_DIESEL"] = "Family SW Diesel";
    CreditRentingPtTempReplacementCarType["VAN"] = "Van";
    CreditRentingPtTempReplacementCarType["BIG_VAN"] = "Big Van";
    CreditRentingPtTempReplacementCarType["MEDIUM_VAN"] = "Medium Van";
    CreditRentingPtTempReplacementCarType["MINI_VAN_7L"] = "Minivan 7L";
    CreditRentingPtTempReplacementCarType["MINI_VAN_9L"] = "Minivan 9L";
    CreditRentingPtTempReplacementCarType["PICKUP_TRUCK"] = "Pickup Truck";
    CreditRentingPtTempReplacementCarType["PICKUP_DOUBLE_CABINE"] = "Pick-up Double Cabine";
    CreditRentingPtTempReplacementCarType["COMMERCIAL_VEHICLE"] = "Commercial Vehicle";
    CreditRentingPtTempReplacementCarType["NO"] = "No";
})(CreditRentingPtTempReplacementCarType = exports.CreditRentingPtTempReplacementCarType || (exports.CreditRentingPtTempReplacementCarType = {}));
/**
 * This attribute defines the maturity of maintenance for the chosen contract, either basic or full.
 */
var CreditRentingPtMaintenancePackageTypev2;
(function (CreditRentingPtMaintenancePackageTypev2) {
    CreditRentingPtMaintenancePackageTypev2["FULL_EXTERNAL"] = "Full External";
    CreditRentingPtMaintenancePackageTypev2["BASIC_EXTERNAL"] = "Basic External";
})(CreditRentingPtMaintenancePackageTypev2 = exports.CreditRentingPtMaintenancePackageTypev2 || (exports.CreditRentingPtMaintenancePackageTypev2 = {}));
/**
 * The possible deductible values
 */
var CreditRentingPtDeductibleTypev2;
(function (CreditRentingPtDeductibleTypev2) {
    CreditRentingPtDeductibleTypev2["NO"] = "No";
    CreditRentingPtDeductibleTypev2["PCT20_DEDUCTIBLE"] = "20% Deductible (CCC)";
    CreditRentingPtDeductibleTypev2["PCT12_DEDUCTIBLE"] = "12% Deductible (CCC)";
    CreditRentingPtDeductibleTypev2["PCT8_DEDUCTIBLE"] = "8% Deductible (CCC)";
    CreditRentingPtDeductibleTypev2["PCT8_DEDUCTIBLE_DP"] = "8% Deductible (DP)";
    CreditRentingPtDeductibleTypev2["PCT4_DEDUCTIBLE"] = "4% Deductible (CCC)";
    CreditRentingPtDeductibleTypev2["PCT4_DEDUCTIBLE_DP"] = "4% Deductible (DP)";
    CreditRentingPtDeductibleTypev2["PCT2_DEDUCTIBLE"] = "2% Deductible (CCC)";
    CreditRentingPtDeductibleTypev2["PCT2_DEDUCTIBLE_DP"] = "2% Deductible (DP)";
    CreditRentingPtDeductibleTypev2["PCT0_DEDUCTIBLE"] = "0% Deductible (CCC)";
})(CreditRentingPtDeductibleTypev2 = exports.CreditRentingPtDeductibleTypev2 || (exports.CreditRentingPtDeductibleTypev2 = {}));
/**
 * The possible creditProtectionPackage code values
 */
var CreditRentingPtCodeTypev2;
(function (CreditRentingPtCodeTypev2) {
    CreditRentingPtCodeTypev2["NO"] = "No";
    CreditRentingPtCodeTypev2["PACK1"] = "Pack 1 - Standard";
    CreditRentingPtCodeTypev2["PACK2"] = "Pack 2 - Standard";
    CreditRentingPtCodeTypev2["PACK3"] = "Pack 3 - Standard";
})(CreditRentingPtCodeTypev2 = exports.CreditRentingPtCodeTypev2 || (exports.CreditRentingPtCodeTypev2 = {}));
/**
 * The possible product types
 */
var CreditRentingPtProductTypev2;
(function (CreditRentingPtProductTypev2) {
    CreditRentingPtProductTypev2["AUTOCREDIT"] = "autocredit";
    CreditRentingPtProductTypev2["RENTING"] = "renting";
})(CreditRentingPtProductTypev2 = exports.CreditRentingPtProductTypev2 || (exports.CreditRentingPtProductTypev2 = {}));
/**
 * The possible creditProtectionPackage code values
 */
var CreditRentingPtTempReplacementCarTypev2;
(function (CreditRentingPtTempReplacementCarTypev2) {
    CreditRentingPtTempReplacementCarTypev2["CABIN_CHASSIS"] = "Cabin-chassis";
    CreditRentingPtTempReplacementCarTypev2["CITY_DIESEL"] = "City Diesel";
    CreditRentingPtTempReplacementCarTypev2["CITY_GASOLINE"] = "City Gasoline";
    CreditRentingPtTempReplacementCarTypev2["ECONOMIC"] = "Economic";
    CreditRentingPtTempReplacementCarTypev2["EXECUTIVE"] = "Executive";
    CreditRentingPtTempReplacementCarTypev2["EXECUTIVE_TOP"] = "Executive TOP";
    CreditRentingPtTempReplacementCarTypev2["FAMILY_DIESEL"] = "Family Diesel";
    CreditRentingPtTempReplacementCarTypev2["FAMILY_SMALL_DIESEL"] = "Family Small Diesel";
    CreditRentingPtTempReplacementCarTypev2["FAMILY_SMALL_SW_DIESEL"] = "Family Small SW Diesel";
    CreditRentingPtTempReplacementCarTypev2["FAMILY_SMALL"] = "Family Small";
    CreditRentingPtTempReplacementCarTypev2["FAMILY_SMALL_AUT"] = "Family Small Aut";
    CreditRentingPtTempReplacementCarTypev2["FAMILY_SW_DIESEL"] = "Family SW Diesel";
    CreditRentingPtTempReplacementCarTypev2["VAN"] = "Van";
    CreditRentingPtTempReplacementCarTypev2["BIG_VAN"] = "Big Van";
    CreditRentingPtTempReplacementCarTypev2["MEDIUM_VAN"] = "Medium Van";
    CreditRentingPtTempReplacementCarTypev2["MINI_VAN_7L"] = "Minivan 7L";
    CreditRentingPtTempReplacementCarTypev2["MINI_VAN_9L"] = "Minivan 9L";
    CreditRentingPtTempReplacementCarTypev2["PICKUP_TRUCK"] = "Pickup Truck";
    CreditRentingPtTempReplacementCarTypev2["PICKUP_DOUBLE_CABINE"] = "Pick-up Double Cabine";
    CreditRentingPtTempReplacementCarTypev2["COMMERCIAL_VEHICLE"] = "Commercial Vehicle";
    CreditRentingPtTempReplacementCarTypev2["NO"] = "No";
})(CreditRentingPtTempReplacementCarTypev2 = exports.CreditRentingPtTempReplacementCarTypev2 || (exports.CreditRentingPtTempReplacementCarTypev2 = {}));
/**
 * Represents a car manufacturer (brand) of a vehicle model. This is different from the VWFS sales brand
 * in the Brand enum.
 */
var ServiceinspectionDeManufacturer;
(function (ServiceinspectionDeManufacturer) {
    ServiceinspectionDeManufacturer["Volkswagen"] = "Volkswagen";
    ServiceinspectionDeManufacturer["VolkswagenNutzfahrzeuge"] = "Volkswagen Nutzfahrzeuge";
    ServiceinspectionDeManufacturer["Audi"] = "Audi";
    ServiceinspectionDeManufacturer["SEAT"] = "SEAT";
    ServiceinspectionDeManufacturer["Skoda"] = "Skoda";
})(ServiceinspectionDeManufacturer = exports.ServiceinspectionDeManufacturer || (exports.ServiceinspectionDeManufacturer = {}));
/**
 * Represents the status of the interaction
 */
var InteractionManagementStatus;
(function (InteractionManagementStatus) {
    InteractionManagementStatus["APPLICATIONFORM_COMPLETED"] = "APPLICATIONFORM_COMPLETED";
    InteractionManagementStatus["PAYMENT_CONFIRMED"] = "PAYMENT_CONFIRMED";
    InteractionManagementStatus["PAYMENT_REJECTED"] = "PAYMENT_REJECTED";
    InteractionManagementStatus["CONTRACT_CONFIRMED"] = "CONTRACT_CONFIRMED";
    InteractionManagementStatus["CONTRACT_REJECTED"] = "CONTRACT_REJECTED";
    InteractionManagementStatus["CONTRACT_ESIGN_READY"] = "CONTRACT_ESIGN_READY";
    InteractionManagementStatus["CONTRACT_READY"] = "CONTRACT_READY";
    InteractionManagementStatus["CONTRACT_SIGNED"] = "CONTRACT_SIGNED";
    InteractionManagementStatus["LEAD_SUBMITTED"] = "LEAD_SUBMITTED";
    InteractionManagementStatus["DOCUMENTS_UPLOADED"] = "DOCUMENTS_UPLOADED";
    InteractionManagementStatus["CREDIT_APPROVED"] = "CREDIT_APPROVED";
    InteractionManagementStatus["CREDIT_REFUSED"] = "CREDIT_REFUSED";
    InteractionManagementStatus["CREDIT_REJECTED"] = "CREDIT_REJECTED";
    InteractionManagementStatus["SOFTCREDIT_APPROVED"] = "SOFTCREDIT_APPROVED";
    InteractionManagementStatus["SOFTCREDIT_REJECTED"] = "SOFTCREDIT_REJECTED";
})(InteractionManagementStatus = exports.InteractionManagementStatus || (exports.InteractionManagementStatus = {}));
/**
 * Indicates the role of the customer.
 */
var CustomerRole;
(function (CustomerRole) {
    CustomerRole["INSURER"] = "INSURER";
    CustomerRole["USER"] = "USER";
    CustomerRole["OWNER"] = "OWNER";
    CustomerRole["CO_OWNER"] = "CO_OWNER";
    CustomerRole["CESSIONARY"] = "CESSIONARY";
    CustomerRole["BUSINESS_PARTNER"] = "BUSINESS_PARTNER";
    CustomerRole["BENEFICIARY"] = "BENEFICIARY";
})(CustomerRole = exports.CustomerRole || (exports.CustomerRole = {}));
/**
 * Represents the frequency of a payment
 */
var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["ONE_OFF"] = "ONE_OFF";
    PaymentFrequency["MONTHLY"] = "MONTHLY";
    PaymentFrequency["YEARLY"] = "YEARLY";
})(PaymentFrequency = exports.PaymentFrequency || (exports.PaymentFrequency = {}));
/**
 * Represents the currency code based on ISO standards
 */
var Currency;
(function (Currency) {
    Currency["Euro"] = "EUR";
    Currency["SwissFranc"] = "CHF";
    Currency["JapaneseYen"] = "JPY";
    Currency["ChineseYuan"] = "CNY";
    Currency["UnitedStatesDollar"] = "USD";
    Currency["CanadianDollar"] = "CAD";
})(Currency = exports.Currency || (exports.Currency = {}));
/**
 * The type of the unique customer identifier. This can be either a customerIdentity like Verimi or
 * VW.ID or any other kind of identifier.
 */
var IdentifierSourceType;
(function (IdentifierSourceType) {
    IdentifierSourceType["THUNDERAPP"] = "THUNDERAPP";
    IdentifierSourceType["VERIMI"] = "VERIMI";
    IdentifierSourceType["WE"] = "WE";
})(IdentifierSourceType = exports.IdentifierSourceType || (exports.IdentifierSourceType = {}));
/**
 * Determines, if the delivery date is binding or non-binding.
 */
var DeliveryDateInfo;
(function (DeliveryDateInfo) {
    DeliveryDateInfo["BINDING"] = "BINDING";
    DeliveryDateInfo["NON_BINDING"] = "NON_BINDING";
})(DeliveryDateInfo = exports.DeliveryDateInfo || (exports.DeliveryDateInfo = {}));
/**
 * Pcp Uk Salutations
 */
var PcpOneShopUkSalutation;
(function (PcpOneShopUkSalutation) {
    PcpOneShopUkSalutation["MR"] = "MR";
    PcpOneShopUkSalutation["MS"] = "MS";
    PcpOneShopUkSalutation["MISS"] = "MISS";
    PcpOneShopUkSalutation["MRS"] = "MRS";
})(PcpOneShopUkSalutation = exports.PcpOneShopUkSalutation || (exports.PcpOneShopUkSalutation = {}));
/**
 * Pcp Uk marital status
 */
var PcpOneShopUkMaritalStatus;
(function (PcpOneShopUkMaritalStatus) {
    PcpOneShopUkMaritalStatus["CIVIL_PARTNERSHIP"] = "CivilPartnership";
    PcpOneShopUkMaritalStatus["DIVORCED"] = "Divorced";
    PcpOneShopUkMaritalStatus["LIVING_TOGETHER"] = "Cohabiting";
    PcpOneShopUkMaritalStatus["MARRIED"] = "Married";
    PcpOneShopUkMaritalStatus["SEPARATED"] = "Separated";
    PcpOneShopUkMaritalStatus["SINGLE"] = "Single";
    PcpOneShopUkMaritalStatus["WIDOWED"] = "Widowed";
    PcpOneShopUkMaritalStatus["WIDOWER"] = "Widower";
})(PcpOneShopUkMaritalStatus = exports.PcpOneShopUkMaritalStatus || (exports.PcpOneShopUkMaritalStatus = {}));
/**
 * Pcp Uk residential status
 */
var PcpOneShopUkResidentialStatus;
(function (PcpOneShopUkResidentialStatus) {
    PcpOneShopUkResidentialStatus["EmployerSuppliedAccommodation"] = "EmployerSuppliedAccommodation";
    PcpOneShopUkResidentialStatus["JointOwned"] = "JointOwned";
    PcpOneShopUkResidentialStatus["Owner"] = "Owner";
    PcpOneShopUkResidentialStatus["LivingWithParents"] = "LivingWithParents";
    PcpOneShopUkResidentialStatus["LivingWithRelative"] = "LivingWithRelative";
    PcpOneShopUkResidentialStatus["TenantControlled"] = "TenantControlled";
    PcpOneShopUkResidentialStatus["PrivateTenant"] = "PrivateTenant";
    PcpOneShopUkResidentialStatus["TenantUncontrolled"] = "TenantUncontrolled";
})(PcpOneShopUkResidentialStatus = exports.PcpOneShopUkResidentialStatus || (exports.PcpOneShopUkResidentialStatus = {}));
/**
 * Pcp Uk occupations
 */
var PcpOneShopUkOccupation;
(function (PcpOneShopUkOccupation) {
    PcpOneShopUkOccupation["ADMINISTRATIVE_EMPLOYEE"] = "OfficeStaff";
    PcpOneShopUkOccupation["CIVIL_SERVANT"] = "SocialWorker";
    PcpOneShopUkOccupation["DRIVER"] = "Driver";
    PcpOneShopUkOccupation["EMPLOYEE_TRADE"] = "TradesBuildingAndRelated";
    PcpOneShopUkOccupation["ENTERPRISE_EXECUTIVE"] = "Executive";
    PcpOneShopUkOccupation["HOMEMAKER"] = "Housewife";
    PcpOneShopUkOccupation["MANAGER"] = "Manager";
    PcpOneShopUkOccupation["OFFICER_PROFESSIONAL_SOLDIER"] = "MilitaryOfficer";
    PcpOneShopUkOccupation["OTHERS"] = "ProfessionalOther";
    PcpOneShopUkOccupation["PENSIONER"] = "Retired";
    PcpOneShopUkOccupation["REGULAR_SOLDIER"] = "Guard";
    PcpOneShopUkOccupation["SELFEMPLOYED"] = "OwnerOfBusiness";
    PcpOneShopUkOccupation["STUDENT"] = "Student";
    PcpOneShopUkOccupation["SUPERVISOR"] = "Foreman";
    PcpOneShopUkOccupation["UNEMPLOYED"] = "Unemployed";
    PcpOneShopUkOccupation["WORKER"] = "LabourerOutdoorWorker";
    PcpOneShopUkOccupation["SALES_INDOOR"] = "SalesIndoor";
    PcpOneShopUkOccupation["SALES_OUTDOOR"] = "SalesOutdoor";
    PcpOneShopUkOccupation["FINANCIAL_CONSULTANT"] = "FinancialConsultant";
    PcpOneShopUkOccupation["FINANCIAL"] = "ProfessionalFinancial";
    PcpOneShopUkOccupation["LEGAL"] = "ProfessionalLegal";
    PcpOneShopUkOccupation["MILITARY"] = "MilitaryEnlistedNonComm";
    PcpOneShopUkOccupation["ANALYST"] = "OpsDevelopmentAnalyst";
    PcpOneShopUkOccupation["MEDICAL"] = "ProfessionalMedical";
    PcpOneShopUkOccupation["SERVICE_WORKER"] = "Service";
    PcpOneShopUkOccupation["TAXI_DRIVER"] = "TaxiDriver";
    PcpOneShopUkOccupation["DISPATCH_RIDER"] = "DispatchRider";
    PcpOneShopUkOccupation["NOT_CLASSIFIED"] = "NotClassified";
    PcpOneShopUkOccupation["PRODUCTION_WORKER"] = "ProductionFactoryWorker";
    PcpOneShopUkOccupation["SEMI_PROFESSIONAL_FINANCIAL"] = "SemiProfessionalFinancial";
    PcpOneShopUkOccupation["SEMI_PROFESSIONAL_OTHER"] = "SemiProfessionalOther";
    PcpOneShopUkOccupation["SEMI_PROFESSIONAL_LEGAL"] = "SemiProfessionalLegal";
    PcpOneShopUkOccupation["SEMI_PROFESSIONAL_MEDICAL"] = "SemiProfessionalMedical";
})(PcpOneShopUkOccupation = exports.PcpOneShopUkOccupation || (exports.PcpOneShopUkOccupation = {}));
/**
 * Pcp Uk empleyment status
 */
var PcpOneShopUkEmploymentStatus;
(function (PcpOneShopUkEmploymentStatus) {
    PcpOneShopUkEmploymentStatus["Employed"] = "Employed";
    PcpOneShopUkEmploymentStatus["Unemployed"] = "Unemployed";
    PcpOneShopUkEmploymentStatus["SelfEmployed"] = "SelfEmployed";
    PcpOneShopUkEmploymentStatus["HousePerson"] = "HousePerson";
    PcpOneShopUkEmploymentStatus["InEducation"] = "InEducation";
    PcpOneShopUkEmploymentStatus["Retired"] = "Retired";
})(PcpOneShopUkEmploymentStatus = exports.PcpOneShopUkEmploymentStatus || (exports.PcpOneShopUkEmploymentStatus = {}));
/**
 * Pcp Uk credit decision status
 */
var PcpOneShopUkCreditDecisionStatus;
(function (PcpOneShopUkCreditDecisionStatus) {
    PcpOneShopUkCreditDecisionStatus["Created"] = "Created";
    PcpOneShopUkCreditDecisionStatus["Submitted"] = "Submitted";
    PcpOneShopUkCreditDecisionStatus["Approved"] = "Approved";
    PcpOneShopUkCreditDecisionStatus["Cancelled"] = "Cancelled";
    PcpOneShopUkCreditDecisionStatus["Finalised"] = "Finalised";
    PcpOneShopUkCreditDecisionStatus["AwaitingDocuments"] = "AwaitingDocuments";
    PcpOneShopUkCreditDecisionStatus["PreFinalisationReview"] = "PreFinalisationReview";
    PcpOneShopUkCreditDecisionStatus["UnderReview"] = "UnderReview";
})(PcpOneShopUkCreditDecisionStatus = exports.PcpOneShopUkCreditDecisionStatus || (exports.PcpOneShopUkCreditDecisionStatus = {}));
/**
 * Pcp Uk Salutations
 */
var PcpUkSalutation;
(function (PcpUkSalutation) {
    PcpUkSalutation["MR"] = "MR";
    PcpUkSalutation["MS"] = "MS";
    PcpUkSalutation["MISS"] = "MISS";
    PcpUkSalutation["MRS"] = "MRS";
})(PcpUkSalutation = exports.PcpUkSalutation || (exports.PcpUkSalutation = {}));
/**
 * Pcp Uk marital status
 */
var PcpUkMaritalStatus;
(function (PcpUkMaritalStatus) {
    PcpUkMaritalStatus["CIVIL_PARTNERSHIP"] = "CivilPartnership";
    PcpUkMaritalStatus["DIVORCED"] = "Divorced";
    PcpUkMaritalStatus["LIVING_TOGETHER"] = "Cohabiting";
    PcpUkMaritalStatus["MARRIED"] = "Married";
    PcpUkMaritalStatus["SEPARATED"] = "Separated";
    PcpUkMaritalStatus["SINGLE"] = "Single";
    PcpUkMaritalStatus["WIDOWED"] = "Widowed";
    PcpUkMaritalStatus["WIDOWER"] = "Widower";
})(PcpUkMaritalStatus = exports.PcpUkMaritalStatus || (exports.PcpUkMaritalStatus = {}));
/**
 * Describes the residential situation of the customer, if he lives on his own, with parents, relatives
 * etc.
 */
var PcpUkResidentialStatus;
(function (PcpUkResidentialStatus) {
    PcpUkResidentialStatus["EmployerSuppliedAccommodation"] = "EmployerSuppliedAccommodation";
    PcpUkResidentialStatus["JointOwned"] = "JointOwned";
    PcpUkResidentialStatus["Owner"] = "Owner";
    PcpUkResidentialStatus["LivingWithParents"] = "LivingWithParents";
    PcpUkResidentialStatus["LivingWithRelative"] = "LivingWithRelative";
    PcpUkResidentialStatus["TenantControlled"] = "TenantControlled";
    PcpUkResidentialStatus["PrivateTenant"] = "PrivateTenant";
    PcpUkResidentialStatus["TenantUncontrolled"] = "TenantUncontrolled";
})(PcpUkResidentialStatus = exports.PcpUkResidentialStatus || (exports.PcpUkResidentialStatus = {}));
/**
 * Pcp Uk occupations
 */
var PcpUkOccupation;
(function (PcpUkOccupation) {
    PcpUkOccupation["ADMINISTRATIVE_EMPLOYEE"] = "OfficeStaff";
    PcpUkOccupation["CIVIL_SERVANT"] = "SocialWorker";
    PcpUkOccupation["DRIVER"] = "Driver";
    PcpUkOccupation["EMPLOYEE_TRADE"] = "TradesBuildingAndRelated";
    PcpUkOccupation["ENTERPRISE_EXECUTIVE"] = "Executive";
    PcpUkOccupation["HOMEMAKER"] = "Housewife";
    PcpUkOccupation["MANAGER"] = "Manager";
    PcpUkOccupation["OFFICER_PROFESSIONAL_SOLDIER"] = "MilitaryOfficer";
    PcpUkOccupation["OTHERS"] = "ProfessionalOther";
    PcpUkOccupation["PENSIONER"] = "Retired";
    PcpUkOccupation["REGULAR_SOLDIER"] = "Guard";
    PcpUkOccupation["SELFEMPLOYED"] = "OwnerOfBusiness";
    PcpUkOccupation["STUDENT"] = "Student";
    PcpUkOccupation["SUPERVISOR"] = "Foreman";
    PcpUkOccupation["UNEMPLOYED"] = "Unemployed";
    PcpUkOccupation["WORKER"] = "LabourerOutdoorWorker";
    PcpUkOccupation["SALES_INDOOR"] = "SalesIndoor";
    PcpUkOccupation["SALES_OUTDOOR"] = "SalesOutdoor";
    PcpUkOccupation["FINANCIAL_CONSULTANT"] = "FinancialConsultant";
    PcpUkOccupation["FINANCIAL"] = "ProfessionalFinancial";
    PcpUkOccupation["LEGAL"] = "ProfessionalLegal";
    PcpUkOccupation["MILITARY"] = "MilitaryEnlistedNonComm";
    PcpUkOccupation["ANALYST"] = "OpsDevelopmentAnalyst";
    PcpUkOccupation["MEDICAL"] = "ProfessionalMedical";
    PcpUkOccupation["SERVICE_WORKER"] = "Service";
    PcpUkOccupation["TAXI_DRIVER"] = "TaxiDriver";
    PcpUkOccupation["DISPATCH_RIDER"] = "DispatchRider";
    PcpUkOccupation["NOT_CLASSIFIED"] = "NotClassified";
    PcpUkOccupation["PRODUCTION_WORKER"] = "ProductionFactoryWorker";
    PcpUkOccupation["SEMI_PROFESSIONAL_FINANCIAL"] = "SemiProfessionalFinancial";
    PcpUkOccupation["SEMI_PROFESSIONAL_OTHER"] = "SemiProfessionalOther";
    PcpUkOccupation["SEMI_PROFESSIONAL_LEGAL"] = "SemiProfessionalLegal";
    PcpUkOccupation["SEMI_PROFESSIONAL_MEDICAL"] = "SemiProfessionalMedical";
})(PcpUkOccupation = exports.PcpUkOccupation || (exports.PcpUkOccupation = {}));
/**
 * Pcp Uk empleyment status
 */
var PcpUkEmploymentStatus;
(function (PcpUkEmploymentStatus) {
    PcpUkEmploymentStatus["Employed"] = "Employed";
    PcpUkEmploymentStatus["Unemployed"] = "Unemployed";
    PcpUkEmploymentStatus["SelfEmployed"] = "SelfEmployed";
    PcpUkEmploymentStatus["HousePerson"] = "HousePerson";
    PcpUkEmploymentStatus["InEducation"] = "InEducation";
    PcpUkEmploymentStatus["Retired"] = "Retired";
})(PcpUkEmploymentStatus = exports.PcpUkEmploymentStatus || (exports.PcpUkEmploymentStatus = {}));
/**
 * Pcp Uk credit decision status
 */
var PcpUkCreditDecisionStatus;
(function (PcpUkCreditDecisionStatus) {
    PcpUkCreditDecisionStatus["Created"] = "Created";
    PcpUkCreditDecisionStatus["Submitted"] = "Submitted";
    PcpUkCreditDecisionStatus["Approved"] = "Approved";
    PcpUkCreditDecisionStatus["Cancelled"] = "Cancelled";
    PcpUkCreditDecisionStatus["Finalised"] = "Finalised";
    PcpUkCreditDecisionStatus["AwaitingDocuments"] = "AwaitingDocuments";
    PcpUkCreditDecisionStatus["PreFinalisationReview"] = "PreFinalisationReview";
    PcpUkCreditDecisionStatus["UnderReview"] = "UnderReview";
})(PcpUkCreditDecisionStatus = exports.PcpUkCreditDecisionStatus || (exports.PcpUkCreditDecisionStatus = {}));
/**
 * Pcp Uk Salutations
 */
var PcpHeyCarUkUsedSalutation;
(function (PcpHeyCarUkUsedSalutation) {
    PcpHeyCarUkUsedSalutation["MR"] = "MR";
    PcpHeyCarUkUsedSalutation["MS"] = "MS";
    PcpHeyCarUkUsedSalutation["MISS"] = "MISS";
    PcpHeyCarUkUsedSalutation["MRS"] = "MRS";
})(PcpHeyCarUkUsedSalutation = exports.PcpHeyCarUkUsedSalutation || (exports.PcpHeyCarUkUsedSalutation = {}));
/**
 * Pcp Uk marital status
 */
var PcpHeyCarUkUsedMaritalStatus;
(function (PcpHeyCarUkUsedMaritalStatus) {
    PcpHeyCarUkUsedMaritalStatus["CIVIL_PARTNERSHIP"] = "CivilPartnership";
    PcpHeyCarUkUsedMaritalStatus["DIVORCED"] = "Divorced";
    PcpHeyCarUkUsedMaritalStatus["LIVING_TOGETHER"] = "Cohabiting";
    PcpHeyCarUkUsedMaritalStatus["MARRIED"] = "Married";
    PcpHeyCarUkUsedMaritalStatus["SEPARATED"] = "Separated";
    PcpHeyCarUkUsedMaritalStatus["SINGLE"] = "Single";
    PcpHeyCarUkUsedMaritalStatus["WIDOWED"] = "Widowed";
    PcpHeyCarUkUsedMaritalStatus["WIDOWER"] = "Widower";
})(PcpHeyCarUkUsedMaritalStatus = exports.PcpHeyCarUkUsedMaritalStatus || (exports.PcpHeyCarUkUsedMaritalStatus = {}));
/**
 * Pcp Uk residential status
 */
var PcpHeyCarUkUsedResidentialStatus;
(function (PcpHeyCarUkUsedResidentialStatus) {
    PcpHeyCarUkUsedResidentialStatus["EmployerSuppliedAccommodation"] = "EmployerSuppliedAccommodation";
    PcpHeyCarUkUsedResidentialStatus["JointOwned"] = "JointOwned";
    PcpHeyCarUkUsedResidentialStatus["Owner"] = "Owner";
    PcpHeyCarUkUsedResidentialStatus["LivingWithParents"] = "LivingWithParents";
    PcpHeyCarUkUsedResidentialStatus["LivingWithRelative"] = "LivingWithRelative";
    PcpHeyCarUkUsedResidentialStatus["TenantControlled"] = "TenantControlled";
    PcpHeyCarUkUsedResidentialStatus["PrivateTenant"] = "PrivateTenant";
    PcpHeyCarUkUsedResidentialStatus["TenantUncontrolled"] = "TenantUncontrolled";
})(PcpHeyCarUkUsedResidentialStatus = exports.PcpHeyCarUkUsedResidentialStatus || (exports.PcpHeyCarUkUsedResidentialStatus = {}));
/**
 * Pcp Uk occupations
 */
var PcpHeyCarUkUsedOccupation;
(function (PcpHeyCarUkUsedOccupation) {
    PcpHeyCarUkUsedOccupation["ADMINISTRATIVE_EMPLOYEE"] = "OfficeStaff";
    PcpHeyCarUkUsedOccupation["CIVIL_SERVANT"] = "SocialWorker";
    PcpHeyCarUkUsedOccupation["DRIVER"] = "Driver";
    PcpHeyCarUkUsedOccupation["EMPLOYEE_TRADE"] = "TradesBuildingAndRelated";
    PcpHeyCarUkUsedOccupation["ENTERPRISE_EXECUTIVE"] = "Executive";
    PcpHeyCarUkUsedOccupation["HOMEMAKER"] = "Housewife";
    PcpHeyCarUkUsedOccupation["MANAGER"] = "Manager";
    PcpHeyCarUkUsedOccupation["OFFICER_PROFESSIONAL_SOLDIER"] = "MilitaryOfficer";
    PcpHeyCarUkUsedOccupation["OTHERS"] = "ProfessionalOther";
    PcpHeyCarUkUsedOccupation["PENSIONER"] = "Retired";
    PcpHeyCarUkUsedOccupation["REGULAR_SOLDIER"] = "Guard";
    PcpHeyCarUkUsedOccupation["SELFEMPLOYED"] = "OwnerOfBusiness";
    PcpHeyCarUkUsedOccupation["STUDENT"] = "Student";
    PcpHeyCarUkUsedOccupation["SUPERVISOR"] = "Foreman";
    PcpHeyCarUkUsedOccupation["UNEMPLOYED"] = "Unemployed";
    PcpHeyCarUkUsedOccupation["WORKER"] = "LabourerOutdoorWorker";
    PcpHeyCarUkUsedOccupation["SALES_INDOOR"] = "SalesIndoor";
    PcpHeyCarUkUsedOccupation["SALES_OUTDOOR"] = "SalesOutdoor";
    PcpHeyCarUkUsedOccupation["FINANCIAL_CONSULTANT"] = "FinancialConsultant";
    PcpHeyCarUkUsedOccupation["FINANCIAL"] = "ProfessionalFinancial";
    PcpHeyCarUkUsedOccupation["LEGAL"] = "ProfessionalLegal";
    PcpHeyCarUkUsedOccupation["MILITARY"] = "MilitaryEnlistedNonComm";
    PcpHeyCarUkUsedOccupation["ANALYST"] = "OpsDevelopmentAnalyst";
    PcpHeyCarUkUsedOccupation["MEDICAL"] = "ProfessionalMedical";
    PcpHeyCarUkUsedOccupation["SERVICE_WORKER"] = "Service";
    PcpHeyCarUkUsedOccupation["TAXI_DRIVER"] = "TaxiDriver";
    PcpHeyCarUkUsedOccupation["DISPATCH_RIDER"] = "DispatchRider";
    PcpHeyCarUkUsedOccupation["NOT_CLASSIFIED"] = "NotClassified";
    PcpHeyCarUkUsedOccupation["PRODUCTION_WORKER"] = "ProductionFactoryWorker";
    PcpHeyCarUkUsedOccupation["SEMI_PROFESSIONAL_FINANCIAL"] = "SemiProfessionalFinancial";
    PcpHeyCarUkUsedOccupation["SEMI_PROFESSIONAL_OTHER"] = "SemiProfessionalOther";
    PcpHeyCarUkUsedOccupation["SEMI_PROFESSIONAL_LEGAL"] = "SemiProfessionalLegal";
    PcpHeyCarUkUsedOccupation["SEMI_PROFESSIONAL_MEDICAL"] = "SemiProfessionalMedical";
})(PcpHeyCarUkUsedOccupation = exports.PcpHeyCarUkUsedOccupation || (exports.PcpHeyCarUkUsedOccupation = {}));
/**
 * Pcp Uk empleyment status
 */
var PcpHeyCarUkUsedEmploymentStatus;
(function (PcpHeyCarUkUsedEmploymentStatus) {
    PcpHeyCarUkUsedEmploymentStatus["Employed"] = "Employed";
    PcpHeyCarUkUsedEmploymentStatus["Unemployed"] = "Unemployed";
    PcpHeyCarUkUsedEmploymentStatus["SelfEmployed"] = "SelfEmployed";
    PcpHeyCarUkUsedEmploymentStatus["HousePerson"] = "HousePerson";
    PcpHeyCarUkUsedEmploymentStatus["InEducation"] = "InEducation";
    PcpHeyCarUkUsedEmploymentStatus["Retired"] = "Retired";
})(PcpHeyCarUkUsedEmploymentStatus = exports.PcpHeyCarUkUsedEmploymentStatus || (exports.PcpHeyCarUkUsedEmploymentStatus = {}));
/**
 * Pcp Uk credit decision status
 */
var PcpHeyCarUkUsedCreditDecisionStatus;
(function (PcpHeyCarUkUsedCreditDecisionStatus) {
    PcpHeyCarUkUsedCreditDecisionStatus["Created"] = "Created";
    PcpHeyCarUkUsedCreditDecisionStatus["Submitted"] = "Submitted";
    PcpHeyCarUkUsedCreditDecisionStatus["Approved"] = "Approved";
    PcpHeyCarUkUsedCreditDecisionStatus["Cancelled"] = "Cancelled";
    PcpHeyCarUkUsedCreditDecisionStatus["Finalised"] = "Finalised";
    PcpHeyCarUkUsedCreditDecisionStatus["AwaitingDocuments"] = "AwaitingDocuments";
    PcpHeyCarUkUsedCreditDecisionStatus["PreFinalisationReview"] = "PreFinalisationReview";
    PcpHeyCarUkUsedCreditDecisionStatus["UnderReview"] = "UnderReview";
})(PcpHeyCarUkUsedCreditDecisionStatus = exports.PcpHeyCarUkUsedCreditDecisionStatus || (exports.PcpHeyCarUkUsedCreditDecisionStatus = {}));
/**
 * Private lease Uk Market values for Manufacturers
 */
var PrivateleaseUkMarketManufacturer;
(function (PrivateleaseUkMarketManufacturer) {
    PrivateleaseUkMarketManufacturer["SEAT"] = "Seat";
    PrivateleaseUkMarketManufacturer["Skoda"] = "Skoda";
    PrivateleaseUkMarketManufacturer["VolkswagenNutzfahrzeuge"] = "Volkswagen Commercial Vehicles";
    PrivateleaseUkMarketManufacturer["Volkswagen"] = "Volkswagen Passenger Cars";
    PrivateleaseUkMarketManufacturer["Audi"] = "Audi";
})(PrivateleaseUkMarketManufacturer = exports.PrivateleaseUkMarketManufacturer || (exports.PrivateleaseUkMarketManufacturer = {}));
/**
 * Private lease Uk Salutations
 */
var PrivateleaseUkSalutation;
(function (PrivateleaseUkSalutation) {
    PrivateleaseUkSalutation["MR"] = "MR";
    PrivateleaseUkSalutation["MS"] = "MS";
    PrivateleaseUkSalutation["MISS"] = "MISS";
    PrivateleaseUkSalutation["MRS"] = "MRS";
})(PrivateleaseUkSalutation = exports.PrivateleaseUkSalutation || (exports.PrivateleaseUkSalutation = {}));
/**
 * Private lease Uk marital status
 */
var PrivateleaseUkMaritalStatus;
(function (PrivateleaseUkMaritalStatus) {
    PrivateleaseUkMaritalStatus["CIVIL_PARTNERSHIP"] = "CivilPartnership";
    PrivateleaseUkMaritalStatus["DIVORCED"] = "Divorced";
    PrivateleaseUkMaritalStatus["LIVING_TOGETHER"] = "Cohabiting";
    PrivateleaseUkMaritalStatus["MARRIED"] = "Married";
    PrivateleaseUkMaritalStatus["SEPARATED"] = "Separated";
    PrivateleaseUkMaritalStatus["SINGLE"] = "Single";
    PrivateleaseUkMaritalStatus["WIDOWED"] = "Widowed";
    PrivateleaseUkMaritalStatus["WIDOWER"] = "Widower";
})(PrivateleaseUkMaritalStatus = exports.PrivateleaseUkMaritalStatus || (exports.PrivateleaseUkMaritalStatus = {}));
/**
 * Private lease Uk resintel status
 */
var PrivateleaseUkResidentialStatus;
(function (PrivateleaseUkResidentialStatus) {
    PrivateleaseUkResidentialStatus["EmployerSuppliedAccommodation"] = "EmployerSuppliedAccommodation";
    PrivateleaseUkResidentialStatus["JointOwned"] = "JointOwned";
    PrivateleaseUkResidentialStatus["Owner"] = "Owner";
    PrivateleaseUkResidentialStatus["LivingWithParents"] = "LivingWithParents";
    PrivateleaseUkResidentialStatus["LivingWithRelative"] = "LivingWithRelative";
    PrivateleaseUkResidentialStatus["TenantControlled"] = "TenantControlled";
    PrivateleaseUkResidentialStatus["PrivateTenant"] = "PrivateTenant";
    PrivateleaseUkResidentialStatus["TenantUncontrolled"] = "TenantUncontrolled";
})(PrivateleaseUkResidentialStatus = exports.PrivateleaseUkResidentialStatus || (exports.PrivateleaseUkResidentialStatus = {}));
/**
 * Private lease Uk occupations
 */
var PrivateleaseUkOccupation;
(function (PrivateleaseUkOccupation) {
    PrivateleaseUkOccupation["ADMINISTRATIVE_EMPLOYEE"] = "OfficeStaff";
    PrivateleaseUkOccupation["CIVIL_SERVANT"] = "SocialWorker";
    PrivateleaseUkOccupation["DRIVER"] = "Driver";
    PrivateleaseUkOccupation["EMPLOYEE_TRADE"] = "TradesBuildingAndRelated";
    PrivateleaseUkOccupation["ENTERPRISE_EXECUTIVE"] = "Executive";
    PrivateleaseUkOccupation["HOMEMAKER"] = "Housewife";
    PrivateleaseUkOccupation["MANAGER"] = "Manager";
    PrivateleaseUkOccupation["OFFICER_PROFESSIONAL_SOLDIER"] = "MilitaryOfficer";
    PrivateleaseUkOccupation["OTHERS"] = "ProfessionalOther";
    PrivateleaseUkOccupation["PENSIONER"] = "Retired";
    PrivateleaseUkOccupation["REGULAR_SOLDIER"] = "Guard";
    PrivateleaseUkOccupation["SELFEMPLOYED"] = "OwnerOfBusiness";
    PrivateleaseUkOccupation["STUDENT"] = "Student";
    PrivateleaseUkOccupation["SUPERVISOR"] = "Foreman";
    PrivateleaseUkOccupation["UNEMPLOYED"] = "Unemployed";
    PrivateleaseUkOccupation["WORKER"] = "LabourerOutdoorWorker";
    PrivateleaseUkOccupation["SALES_INDOOR"] = "SalesIndoor";
    PrivateleaseUkOccupation["SALES_OUTDOOR"] = "SalesOutdoor";
    PrivateleaseUkOccupation["FINANCIAL_CONSULTANT"] = "FinancialConsultant";
    PrivateleaseUkOccupation["FINANCIAL"] = "ProfessionalFinancial";
    PrivateleaseUkOccupation["LEGAL"] = "ProfessionalLegal";
    PrivateleaseUkOccupation["MILITARY"] = "MilitaryEnlistedNonComm";
    PrivateleaseUkOccupation["ANALYST"] = "OpsDevelopmentAnalyst";
    PrivateleaseUkOccupation["MEDICAL"] = "ProfessionalMedical";
    PrivateleaseUkOccupation["SERVICE_WORKER"] = "Service";
    PrivateleaseUkOccupation["TAXI_DRIVER"] = "TaxiDriver";
    PrivateleaseUkOccupation["DISPATCH_RIDER"] = "DispatchRider";
    PrivateleaseUkOccupation["NOT_CLASSIFIED"] = "NotClassified";
    PrivateleaseUkOccupation["PRODUCTION_WORKER"] = "ProductionFactoryWorker";
    PrivateleaseUkOccupation["SEMI_PROFESSIONAL_FINANCIAL"] = "SemiProfessionalFinancial";
    PrivateleaseUkOccupation["SEMI_PROFESSIONAL_OTHER"] = "SemiProfessionalOther";
    PrivateleaseUkOccupation["SEMI_PROFESSIONAL_LEGAL"] = "SemiProfessionalLegal";
    PrivateleaseUkOccupation["SEMI_PROFESSIONAL_MEDICAL"] = "SemiProfessionalMedical";
})(PrivateleaseUkOccupation = exports.PrivateleaseUkOccupation || (exports.PrivateleaseUkOccupation = {}));
/**
 * Private lease Uk empleyment status
 */
var PrivateleaseUkEmploymentStatus;
(function (PrivateleaseUkEmploymentStatus) {
    PrivateleaseUkEmploymentStatus["Employed"] = "Employed";
    PrivateleaseUkEmploymentStatus["Unemployed"] = "Unemployed";
    PrivateleaseUkEmploymentStatus["SelfEmployed"] = "SelfEmployed";
    PrivateleaseUkEmploymentStatus["HousePerson"] = "HousePerson";
    PrivateleaseUkEmploymentStatus["InEducation"] = "InEducation";
    PrivateleaseUkEmploymentStatus["Retired"] = "Retired";
})(PrivateleaseUkEmploymentStatus = exports.PrivateleaseUkEmploymentStatus || (exports.PrivateleaseUkEmploymentStatus = {}));
/**
 * Private lease Uk credit decision status
 */
var PrivateleaseUkCreditDecisionStatus;
(function (PrivateleaseUkCreditDecisionStatus) {
    PrivateleaseUkCreditDecisionStatus["Created"] = "Created";
    PrivateleaseUkCreditDecisionStatus["Submitted"] = "Submitted";
    PrivateleaseUkCreditDecisionStatus["Approved"] = "Approved";
    PrivateleaseUkCreditDecisionStatus["Cancelled"] = "Cancelled";
    PrivateleaseUkCreditDecisionStatus["Finalised"] = "Finalised";
    PrivateleaseUkCreditDecisionStatus["AwaitingDocuments"] = "AwaitingDocuments";
    PrivateleaseUkCreditDecisionStatus["PreFinalisationReview"] = "PreFinalisationReview";
    PrivateleaseUkCreditDecisionStatus["UnderReview"] = "UnderReview";
})(PrivateleaseUkCreditDecisionStatus = exports.PrivateleaseUkCreditDecisionStatus || (exports.PrivateleaseUkCreditDecisionStatus = {}));
